/* tslint:disable */
/* eslint-disable */
/**
 * Thrive Catalog
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * The formatted address for this merchant.
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'locality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postal_code'?: string | null;
}
/**
 * 
 * @export
 * @interface AgeVerification
 */
export interface AgeVerification {
    /**
     * The ID of the item or category that this age verification rule applies to.
     * @type {string}
     * @memberof AgeVerification
     */
    'resource_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgeVerification
     */
    'name'?: string | null;
    /**
     * Determines what age is required for this rule. Options are 
     * @type {string}
     * @memberof AgeVerification
     */
    'age_limit': AgeVerificationAgeLimitEnum;
    /**
     * Can be item or category.
     * @type {string}
     * @memberof AgeVerification
     */
    'type': AgeVerificationTypeEnum;
    /**
     * The id of the age verification rule.
     * @type {string}
     * @memberof AgeVerification
     */
    'id': string;
}

export const AgeVerificationAgeLimitEnum = {
    _18: '18',
    _21: '21'
} as const;

export type AgeVerificationAgeLimitEnum = typeof AgeVerificationAgeLimitEnum[keyof typeof AgeVerificationAgeLimitEnum];
export const AgeVerificationTypeEnum = {
    Item: 'item',
    Category: 'category'
} as const;

export type AgeVerificationTypeEnum = typeof AgeVerificationTypeEnum[keyof typeof AgeVerificationTypeEnum];

/**
 * 
 * @export
 * @interface AgeVerificationBase
 */
export interface AgeVerificationBase {
    /**
     * The ID of the item or category that this age verification rule applies to.
     * @type {string}
     * @memberof AgeVerificationBase
     */
    'resource_id': string;
    /**
     * 
     * @type {string}
     * @memberof AgeVerificationBase
     */
    'name'?: string | null;
    /**
     * Determines what age is required for this rule. Options are 
     * @type {string}
     * @memberof AgeVerificationBase
     */
    'age_limit': AgeVerificationBaseAgeLimitEnum;
    /**
     * Can be item or category.
     * @type {string}
     * @memberof AgeVerificationBase
     */
    'type': AgeVerificationBaseTypeEnum;
}

export const AgeVerificationBaseAgeLimitEnum = {
    _18: '18',
    _21: '21'
} as const;

export type AgeVerificationBaseAgeLimitEnum = typeof AgeVerificationBaseAgeLimitEnum[keyof typeof AgeVerificationBaseAgeLimitEnum];
export const AgeVerificationBaseTypeEnum = {
    Item: 'item',
    Category: 'category'
} as const;

export type AgeVerificationBaseTypeEnum = typeof AgeVerificationBaseTypeEnum[keyof typeof AgeVerificationBaseTypeEnum];

/**
 * 
 * @export
 * @interface AsyncCatalogAssociation
 */
export interface AsyncCatalogAssociation {
    /**
     * 
     * @type {string}
     * @memberof AsyncCatalogAssociation
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AsyncCatalogAssociation
     */
    'gtin': string;
    /**
     * 
     * @type {Offer}
     * @memberof AsyncCatalogAssociation
     */
    'price'?: Offer | null;
    /**
     * 
     * @type {string}
     * @memberof AsyncCatalogAssociation
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface AsyncCatalogUploadTracking
 */
export interface AsyncCatalogUploadTracking {
    /**
     * 
     * @type {string}
     * @memberof AsyncCatalogUploadTracking
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AsyncCatalogUploadTracking
     */
    'total_count': number;
    /**
     * 
     * @type {number}
     * @memberof AsyncCatalogUploadTracking
     */
    'processed_count': number;
    /**
     * 
     * @type {number}
     * @memberof AsyncCatalogUploadTracking
     */
    'successful_count': number;
    /**
     * 
     * @type {number}
     * @memberof AsyncCatalogUploadTracking
     */
    'unsuccesful_count': number;
    /**
     * 
     * @type {string}
     * @memberof AsyncCatalogUploadTracking
     */
    'catalog_id': string;
    /**
     * 
     * @type {string}
     * @memberof AsyncCatalogUploadTracking
     */
    'merchant_id': string;
}
/**
 * 
 * @export
 * @interface Brand
 */
export interface Brand {
    /**
     * The ID for this brand.
     * @type {string}
     * @memberof Brand
     */
    'id': string;
    /**
     * Name of the brand such as `Nike`.
     * @type {string}
     * @memberof Brand
     */
    'name': string;
    /**
     * Default language for product records belonging to this brand.
     * @type {string}
     * @memberof Brand
     */
    'default_language'?: BrandDefaultLanguageEnum;
    /**
     * 
     * @type {Brand}
     * @memberof Brand
     */
    'parent'?: Brand | null;
}

export const BrandDefaultLanguageEnum = {
    Us: 'en_US',
    Gb: 'en_GB'
} as const;

export type BrandDefaultLanguageEnum = typeof BrandDefaultLanguageEnum[keyof typeof BrandDefaultLanguageEnum];

/**
 * 
 * @export
 * @interface BrandPayload
 */
export interface BrandPayload {
    /**
     * The ID for this record
     * @type {string}
     * @memberof BrandPayload
     */
    'id'?: string | null;
    /**
     * Name of the brand such as `Nike`.
     * @type {string}
     * @memberof BrandPayload
     */
    'name': string;
    /**
     * Default language for product records belonging to this brand.
     * @type {string}
     * @memberof BrandPayload
     */
    'default_language'?: BrandPayloadDefaultLanguageEnum;
    /**
     * 
     * @type {BrandRecordId}
     * @memberof BrandPayload
     */
    'parent'?: BrandRecordId | null;
}

export const BrandPayloadDefaultLanguageEnum = {
    Us: 'en_US',
    Gb: 'en_GB'
} as const;

export type BrandPayloadDefaultLanguageEnum = typeof BrandPayloadDefaultLanguageEnum[keyof typeof BrandPayloadDefaultLanguageEnum];

/**
 * 
 * @export
 * @interface BrandRecordId
 */
export interface BrandRecordId {
    /**
     * The ID for this brand.
     * @type {string}
     * @memberof BrandRecordId
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface CatalogCopy
 */
export interface CatalogCopy {
    /**
     * 
     * @type {string}
     * @memberof CatalogCopy
     */
    'catalog_id': string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCopy
     */
    'merchant_id': string;
}
/**
 * 
 * @export
 * @interface CatalogMerchantsListMerchants200Response
 */
export interface CatalogMerchantsListMerchants200Response {
    /**
     * 
     * @type {Array<Merchant>}
     * @memberof CatalogMerchantsListMerchants200Response
     */
    'items'?: Array<Merchant>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof CatalogMerchantsListMerchants200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof CatalogMerchantsListMerchants200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface CatalogProductAssociation
 */
export interface CatalogProductAssociation {
    /**
     * 
     * @type {string}
     * @memberof CatalogProductAssociation
     */
    'id'?: string | null;
    /**
     * 
     * @type {CatalogProductPayload}
     * @memberof CatalogProductAssociation
     */
    'product': CatalogProductPayload;
}
/**
 * 
 * @export
 * @interface CatalogProductAssociationResponse
 */
export interface CatalogProductAssociationResponse {
    /**
     * 
     * @type {string}
     * @memberof CatalogProductAssociationResponse
     */
    'id'?: string | null;
    /**
     * 
     * @type {MerchantCatalogProduct}
     * @memberof CatalogProductAssociationResponse
     */
    'product': MerchantCatalogProduct;
}
/**
 * 
 * @export
 * @interface CatalogProductPayload
 */
export interface CatalogProductPayload {
    /**
     * The ID of the product record.
     * @type {string}
     * @memberof CatalogProductPayload
     */
    'id': string;
    /**
     * 
     * @type {Array<CatalogProductVariantPayload>}
     * @memberof CatalogProductPayload
     */
    'variants': Array<CatalogProductVariantPayload>;
}
/**
 * 
 * @export
 * @interface CatalogProductVariantPayload
 */
export interface CatalogProductVariantPayload {
    /**
     * The ID of the variant record. Variant ID must belong to the correct product.
     * @type {string}
     * @memberof CatalogProductVariantPayload
     */
    'id': string;
    /**
     * 
     * @type {Offer}
     * @memberof CatalogProductVariantPayload
     */
    'price': Offer;
}
/**
 * 
 * @export
 * @interface Claims
 */
export interface Claims {
    /**
     * The list of admin roles to apply.
     * @type {Array<string>}
     * @memberof Claims
     */
    'internal_roles'?: Array<ClaimsInternalRolesEnum>;
    /**
     * The list of partner roles to apply.
     * @type {Array<string>}
     * @memberof Claims
     */
    'partner_rep_roles'?: Array<ClaimsPartnerRepRolesEnum>;
}

export const ClaimsInternalRolesEnum = {
    SuperAdmin: 'Thrive Super Admin',
    Developer: 'Thrive Developer',
    CustomerCare: 'Thrive Customer Care'
} as const;

export type ClaimsInternalRolesEnum = typeof ClaimsInternalRolesEnum[keyof typeof ClaimsInternalRolesEnum];
export const ClaimsPartnerRepRolesEnum = {
    CloverBusinessConsultant: 'Clover Business Consultant'
} as const;

export type ClaimsPartnerRepRolesEnum = typeof ClaimsPartnerRepRolesEnum[keyof typeof ClaimsPartnerRepRolesEnum];

/**
 * 
 * @export
 * @interface CloverAddress
 */
export interface CloverAddress {
    /**
     * 
     * @type {string}
     * @memberof CloverAddress
     */
    'address1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloverAddress
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloverAddress
     */
    'address3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloverAddress
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloverAddress
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloverAddress
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloverAddress
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloverAddress
     */
    'zip'?: string | null;
}
/**
 * Not Authorized Exception
 * @export
 * @interface CloverAuthToken401Response
 */
export interface CloverAuthToken401Response {
    /**
     * 
     * @type {number}
     * @memberof CloverAuthToken401Response
     */
    'status_code': number;
    /**
     * 
     * @type {string}
     * @memberof CloverAuthToken401Response
     */
    'detail': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CloverAuthToken401Response
     */
    'extra'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface CloverInterest
 */
export interface CloverInterest {
    /**
     * 
     * @type {string}
     * @memberof CloverInterest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CloverInterest
     */
    'name': string;
    /**
     * 
     * @type {CloverOwner}
     * @memberof CloverInterest
     */
    'owner': CloverOwner;
    /**
     * 
     * @type {CloverAddress}
     * @memberof CloverInterest
     */
    'address': CloverAddress;
    /**
     * 
     * @type {string}
     * @memberof CloverInterest
     */
    'employee_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloverInterest
     */
    'employee_email'?: string | null;
}
/**
 * 
 * @export
 * @interface CloverOwner
 */
export interface CloverOwner {
    /**
     * 
     * @type {string}
     * @memberof CloverOwner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CloverOwner
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CloverToken
 */
export interface CloverToken {
    /**
     * Our app ID associated with this token
     * @type {string}
     * @memberof CloverToken
     */
    'app_id': string;
    /**
     * The Clover merchant ID associated with this token
     * @type {string}
     * @memberof CloverToken
     */
    'merchant_id': string;
    /**
     * 
     * @type {string}
     * @memberof CloverToken
     */
    'device_id'?: string | null;
    /**
     * Access token from Clover device or OAuth
     * @type {string}
     * @memberof CloverToken
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof CloverToken
     */
    'refresh_token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloverToken
     */
    'expires'?: string | null;
}
/**
 * Not Found Exception
 * @export
 * @interface CreateBrand404Response
 */
export interface CreateBrand404Response {
    /**
     * 
     * @type {number}
     * @memberof CreateBrand404Response
     */
    'status_code': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBrand404Response
     */
    'detail': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateBrand404Response
     */
    'extra'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface CreateSearchResultSearchResultRequestBody
 */
export interface CreateSearchResultSearchResultRequestBody {
    /**
     * 
     * @type {string}
     * @memberof CreateSearchResultSearchResultRequestBody
     */
    'term': string;
}
/**
 * 
 * @export
 * @interface CreateSearchResultSearchResultResponseBody
 */
export interface CreateSearchResultSearchResultResponseBody {
    /**
     * 
     * @type {string}
     * @memberof CreateSearchResultSearchResultResponseBody
     */
    'term': string;
}
/**
 * 
 * @export
 * @interface Discount
 */
export interface Discount {
    /**
     * Whether this discount is active.
     * @type {boolean}
     * @memberof Discount
     */
    'active'?: boolean;
    /**
     * This field is for our use only. Any discount imported from a program like Altria\'s discount program should be marked readonly on import so that the discount cannot be changed by the merchant
     * @type {boolean}
     * @memberof Discount
     */
    'readonly'?: boolean;
    /**
     * If this discount was imported from an external program, define which program it was imported from.
     * @type {string}
     * @memberof Discount
     */
    'external_program'?: DiscountExternalProgramEnum | null;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'ext_id'?: string | null;
    /**
     * The name of the discount.
     * @type {string}
     * @memberof Discount
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Discount
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * List of conditions required to trigger this discount.
     * @type {Array<DiscountCondition>}
     * @memberof Discount
     */
    'conditions': Array<DiscountCondition>;
    /**
     * 
     * @type {DiscountResult}
     * @memberof Discount
     */
    'result': DiscountResult;
    /**
     * 
     * @type {number}
     * @memberof Discount
     */
    'limit_discount_amount'?: number | null;
    /**
     * Whether or not the discount can be combined with other offers for the same product
     * @type {boolean}
     * @memberof Discount
     */
    'stackable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Discount
     */
    'usage_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'daily_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'daily_end_time'?: string | null;
    /**
     * Interval for recurring discounts.
     * @type {string}
     * @memberof Discount
     */
    'scheduling_interval'?: DiscountSchedulingIntervalEnum | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof Discount
     */
    'scheduling_interval_selections'?: Array<number> | null;
    /**
     * The id of the discount.
     * @type {string}
     * @memberof Discount
     */
    'id': string;
}

export const DiscountExternalProgramEnum = {
    Altria: 'altria',
    Null: 'null'
} as const;

export type DiscountExternalProgramEnum = typeof DiscountExternalProgramEnum[keyof typeof DiscountExternalProgramEnum];
export const DiscountSchedulingIntervalEnum = {
    Weekly: 'weekly',
    Monthly: 'monthly',
    Null: 'null'
} as const;

export type DiscountSchedulingIntervalEnum = typeof DiscountSchedulingIntervalEnum[keyof typeof DiscountSchedulingIntervalEnum];

/**
 * 
 * @export
 * @interface DiscountBase
 */
export interface DiscountBase {
    /**
     * Whether this discount is active.
     * @type {boolean}
     * @memberof DiscountBase
     */
    'active'?: boolean;
    /**
     * This field is for our use only. Any discount imported from a program like Altria\'s discount program should be marked readonly on import so that the discount cannot be changed by the merchant
     * @type {boolean}
     * @memberof DiscountBase
     */
    'readonly'?: boolean;
    /**
     * If this discount was imported from an external program, define which program it was imported from.
     * @type {string}
     * @memberof DiscountBase
     */
    'external_program'?: DiscountBaseExternalProgramEnum | null;
    /**
     * 
     * @type {string}
     * @memberof DiscountBase
     */
    'ext_id'?: string | null;
    /**
     * The name of the discount.
     * @type {string}
     * @memberof DiscountBase
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DiscountBase
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * List of conditions required to trigger this discount.
     * @type {Array<DiscountCondition>}
     * @memberof DiscountBase
     */
    'conditions': Array<DiscountCondition>;
    /**
     * 
     * @type {DiscountResult}
     * @memberof DiscountBase
     */
    'result': DiscountResult;
    /**
     * 
     * @type {number}
     * @memberof DiscountBase
     */
    'limit_discount_amount'?: number | null;
    /**
     * Whether or not the discount can be combined with other offers for the same product
     * @type {boolean}
     * @memberof DiscountBase
     */
    'stackable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscountBase
     */
    'usage_limit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DiscountBase
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiscountBase
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiscountBase
     */
    'daily_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DiscountBase
     */
    'daily_end_time'?: string | null;
    /**
     * Interval for recurring discounts.
     * @type {string}
     * @memberof DiscountBase
     */
    'scheduling_interval'?: DiscountBaseSchedulingIntervalEnum | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DiscountBase
     */
    'scheduling_interval_selections'?: Array<number> | null;
}

export const DiscountBaseExternalProgramEnum = {
    Altria: 'altria',
    Null: 'null'
} as const;

export type DiscountBaseExternalProgramEnum = typeof DiscountBaseExternalProgramEnum[keyof typeof DiscountBaseExternalProgramEnum];
export const DiscountBaseSchedulingIntervalEnum = {
    Weekly: 'weekly',
    Monthly: 'monthly',
    Null: 'null'
} as const;

export type DiscountBaseSchedulingIntervalEnum = typeof DiscountBaseSchedulingIntervalEnum[keyof typeof DiscountBaseSchedulingIntervalEnum];

/**
 * 
 * @export
 * @interface DiscountCondition
 */
export interface DiscountCondition {
    /**
     * 
     * @type {ItemSelectionGroup}
     * @memberof DiscountCondition
     */
    'item_selection_group'?: ItemSelectionGroup | null;
    /**
     * Purchase requirements that apply to the item selection for this discount condition.
     * @type {Array<PurchaseRequirement>}
     * @memberof DiscountCondition
     */
    'purchase_requirements'?: Array<PurchaseRequirement>;
    /**
     * If true, all items must be identical to trigger the condition.
     * @type {boolean}
     * @memberof DiscountCondition
     */
    'all_items_must_match'?: boolean;
}
/**
 * A result defining the outcome of the discount.
 * @export
 * @interface DiscountResult
 */
export interface DiscountResult {
    /**
     * The type of result. Options are: percent_discount - a percentage to be discounted, amount_discount - a monetary amount to be discounted, fixed_price - set a fixed price for each item as defined by applies_to
     * @type {string}
     * @memberof DiscountResult
     */
    'result_type': DiscountResultResultTypeEnum;
    /**
     * 
     * @type {ItemSelectionGroup}
     * @memberof DiscountResult
     */
    'item_selection_group'?: ItemSelectionGroup | null;
    /**
     * What to apply the result to. Options are: condition_items - applies to the items purchased in order to meet the conditions, additional_items - applies to additional items that may be purchased at a discount,order - applies to the whole order
     * @type {string}
     * @memberof DiscountResult
     */
    'applies_to': DiscountResultAppliesToEnum;
    /**
     * The value of the discount result. Either a percentage or a monetary value dependant on the result type.
     * @type {number}
     * @memberof DiscountResult
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof DiscountResult
     */
    'quantity_discounted'?: number | null;
}

export const DiscountResultResultTypeEnum = {
    PercentDiscount: 'percent_discount',
    AmountDiscount: 'amount_discount',
    FixedPrice: 'fixed_price'
} as const;

export type DiscountResultResultTypeEnum = typeof DiscountResultResultTypeEnum[keyof typeof DiscountResultResultTypeEnum];
export const DiscountResultAppliesToEnum = {
    Order: 'order',
    ConditionItems: 'condition_items',
    AdditionalItems: 'additional_items'
} as const;

export type DiscountResultAppliesToEnum = typeof DiscountResultAppliesToEnum[keyof typeof DiscountResultAppliesToEnum];

/**
 * 
 * @export
 * @interface FSUser
 */
export interface FSUser {
    /**
     * 
     * @type {string}
     * @memberof FSUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FSUser
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FSUser
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof FSUser
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {string}
     * @memberof FSUser
     */
    'photoURL'?: string | null;
    /**
     * 
     * @type {Claims}
     * @memberof FSUser
     */
    'claims': Claims;
}
/**
 * Validation Exception
 * @export
 * @interface GetInternalUser400Response
 */
export interface GetInternalUser400Response {
    /**
     * 
     * @type {number}
     * @memberof GetInternalUser400Response
     */
    'status_code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInternalUser400Response
     */
    'detail': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetInternalUser400Response
     */
    'extra'?: { [key: string]: any; };
}
/**
 * Not Found Exception
 * @export
 * @interface GetOrg404Response
 */
export interface GetOrg404Response {
    /**
     * 
     * @type {number}
     * @memberof GetOrg404Response
     */
    'status_code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrg404Response
     */
    'detail': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GetOrg404Response
     */
    'extra'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface GetProgramProgramCredentialResponseBody
 */
export interface GetProgramProgramCredentialResponseBody {
    /**
     * 
     * @type {string}
     * @memberof GetProgramProgramCredentialResponseBody
     */
    'type': GetProgramProgramCredentialResponseBodyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetProgramProgramCredentialResponseBody
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof GetProgramProgramCredentialResponseBody
     */
    'sftp_username': string;
    /**
     * The ID for this record
     * @type {string}
     * @memberof GetProgramProgramCredentialResponseBody
     */
    'id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProgramProgramCredentialResponseBody
     */
    'merchant_ids': Array<string>;
}

export const GetProgramProgramCredentialResponseBodyTypeEnum = {
    Altria: 'altria'
} as const;

export type GetProgramProgramCredentialResponseBodyTypeEnum = typeof GetProgramProgramCredentialResponseBodyTypeEnum[keyof typeof GetProgramProgramCredentialResponseBodyTypeEnum];

/**
 * 
 * @export
 * @interface GetVariants200Response
 */
export interface GetVariants200Response {
    /**
     * 
     * @type {Array<ProductVariantWithProduct>}
     * @memberof GetVariants200Response
     */
    'items'?: Array<ProductVariantWithProduct>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof GetVariants200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof GetVariants200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface GoogleProductCategory
 */
export interface GoogleProductCategory {
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategory
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategory
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategory
     */
    'display_text': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategory
     */
    'version': string;
}
/**
 * 
 * @export
 * @interface GoogleProductCategoryReference
 */
export interface GoogleProductCategoryReference {
    /**
     * 
     * @type {string}
     * @memberof GoogleProductCategoryReference
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'type': ImageTypeEnum;
}

export const ImageTypeEnum = {
    Png: 'image/png',
    Bmp: 'image/bmp',
    Heif: 'image/heif',
    Heic: 'image/heic',
    HeifSequence: 'image/heif-sequence',
    HeicSequence: 'image/heic-sequence',
    Jpeg: 'image/jpeg',
    Gif: 'image/gif',
    Webp: 'image/webp',
    Svgxml: 'image/svg+xml'
} as const;

export type ImageTypeEnum = typeof ImageTypeEnum[keyof typeof ImageTypeEnum];

/**
 * 
 * @export
 * @interface ItemSelection
 */
export interface ItemSelection {
    /**
     * 
     * @type {string}
     * @memberof ItemSelection
     */
    'field_name': ItemSelectionFieldNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ItemSelection
     */
    'operator': ItemSelectionOperatorEnum;
    /**
     * 
     * @type {any}
     * @memberof ItemSelection
     */
    'field_value'?: any;
}

export const ItemSelectionFieldNameEnum = {
    Id: 'id',
    Name: 'name',
    Categories: 'categories',
    Price: 'price',
    Sku: 'sku',
    Code: 'code'
} as const;

export type ItemSelectionFieldNameEnum = typeof ItemSelectionFieldNameEnum[keyof typeof ItemSelectionFieldNameEnum];
export const ItemSelectionOperatorEnum = {
    Equal: '=',
    NotEqual: '!=',
    GreaterThan: '>',
    LessThan: '<',
    GreaterThanOrEqualTo: '>=',
    LessThanOrEqualTo: '<=',
    In: 'in',
    NotIn: 'not in',
    Contains: 'contains'
} as const;

export type ItemSelectionOperatorEnum = typeof ItemSelectionOperatorEnum[keyof typeof ItemSelectionOperatorEnum];

/**
 * 
 * @export
 * @interface ItemSelectionGroup
 */
export interface ItemSelectionGroup {
    /**
     * 
     * @type {string}
     * @memberof ItemSelectionGroup
     */
    'operator': ItemSelectionGroupOperatorEnum;
    /**
     * 
     * @type {Array<ItemSelectionGroupItemSelectionsInner>}
     * @memberof ItemSelectionGroup
     */
    'item_selections': Array<ItemSelectionGroupItemSelectionsInner>;
}

export const ItemSelectionGroupOperatorEnum = {
    Or: 'or',
    And: 'and'
} as const;

export type ItemSelectionGroupOperatorEnum = typeof ItemSelectionGroupOperatorEnum[keyof typeof ItemSelectionGroupOperatorEnum];

/**
 * @type ItemSelectionGroupItemSelectionsInner
 * @export
 */
export type ItemSelectionGroupItemSelectionsInner = ItemSelection | ItemSelectionGroup;

/**
 * 
 * @export
 * @interface List200Response
 */
export interface List200Response {
    /**
     * 
     * @type {Array<Organization>}
     * @memberof List200Response
     */
    'items'?: Array<Organization>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof List200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof List200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface ListAgeVerification200Response
 */
export interface ListAgeVerification200Response {
    /**
     * 
     * @type {Array<AgeVerification>}
     * @memberof ListAgeVerification200Response
     */
    'items'?: Array<AgeVerification>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ListAgeVerification200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ListAgeVerification200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface ListBrands200Response
 */
export interface ListBrands200Response {
    /**
     * 
     * @type {Array<Brand>}
     * @memberof ListBrands200Response
     */
    'items'?: Array<Brand>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ListBrands200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ListBrands200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface ListDiscounts200Response
 */
export interface ListDiscounts200Response {
    /**
     * 
     * @type {Array<Discount>}
     * @memberof ListDiscounts200Response
     */
    'items'?: Array<Discount>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ListDiscounts200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ListDiscounts200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface ListMerchantCatalogProducts200Response
 */
export interface ListMerchantCatalogProducts200Response {
    /**
     * 
     * @type {Array<CatalogProductAssociationResponse>}
     * @memberof ListMerchantCatalogProducts200Response
     */
    'items'?: Array<CatalogProductAssociationResponse>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ListMerchantCatalogProducts200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ListMerchantCatalogProducts200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface ListMerchantCatalogProductsToVerify200Response
 */
export interface ListMerchantCatalogProductsToVerify200Response {
    /**
     * 
     * @type {Array<AsyncCatalogAssociation>}
     * @memberof ListMerchantCatalogProductsToVerify200Response
     */
    'items'?: Array<AsyncCatalogAssociation>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ListMerchantCatalogProductsToVerify200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ListMerchantCatalogProductsToVerify200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface ListMerchantCatalogUploads200Response
 */
export interface ListMerchantCatalogUploads200Response {
    /**
     * 
     * @type {Array<AsyncCatalogUploadTracking>}
     * @memberof ListMerchantCatalogUploads200Response
     */
    'items'?: Array<AsyncCatalogUploadTracking>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ListMerchantCatalogUploads200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ListMerchantCatalogUploads200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface ListMerchantCatalogs200Response
 */
export interface ListMerchantCatalogs200Response {
    /**
     * 
     * @type {Array<MerchantCatalog>}
     * @memberof ListMerchantCatalogs200Response
     */
    'items'?: Array<MerchantCatalog>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ListMerchantCatalogs200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ListMerchantCatalogs200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface ListProducts200Response
 */
export interface ListProducts200Response {
    /**
     * 
     * @type {Array<ProductWithVariants>}
     * @memberof ListProducts200Response
     */
    'items'?: Array<ProductWithVariants>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ListProducts200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ListProducts200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface ListScandataSubmissions200Response
 */
export interface ListScandataSubmissions200Response {
    /**
     * 
     * @type {Array<ScandataSubmission>}
     * @memberof ListScandataSubmissions200Response
     */
    'items'?: Array<ScandataSubmission>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ListScandataSubmissions200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ListScandataSubmissions200Response
     */
    'results_per_page'?: number;
}
/**
 * 
 * @export
 * @interface Media
 */
export interface Media {
    /**
     * 
     * @type {Array<Image>}
     * @memberof Media
     */
    'images'?: Array<Image>;
    /**
     * 
     * @type {Array<Video>}
     * @memberof Media
     */
    'videos'?: Array<Video>;
    /**
     * 
     * @type {Array<ModelObject>}
     * @memberof Media
     */
    'models'?: Array<ModelObject>;
}
/**
 * 
 * @export
 * @interface MediaUploadRequest
 */
export interface MediaUploadRequest {
    /**
     * The type of media file.
     * @type {string}
     * @memberof MediaUploadRequest
     */
    'type'?: MediaUploadRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MediaUploadRequest
     */
    'alt'?: string | null;
    /**
     * The name of the file you want to upload
     * @type {string}
     * @memberof MediaUploadRequest
     */
    'filename': string;
    /**
     * The size in bytes of the file you are uploading. Max 20 megabytes.
     * @type {number}
     * @memberof MediaUploadRequest
     */
    'filesize': number;
    /**
     * The mime type of the file
     * @type {string}
     * @memberof MediaUploadRequest
     */
    'mime_type': MediaUploadRequestMimeTypeEnum;
}

export const MediaUploadRequestTypeEnum = {
    Image: 'IMAGE',
    Video: 'VIDEO',
    ExternalVideo: 'EXTERNAL_VIDEO',
    _3DModel: '3D_MODEL'
} as const;

export type MediaUploadRequestTypeEnum = typeof MediaUploadRequestTypeEnum[keyof typeof MediaUploadRequestTypeEnum];
export const MediaUploadRequestMimeTypeEnum = {
    ImagePng: 'image/png',
    ImageBmp: 'image/bmp',
    ImageHeif: 'image/heif',
    ImageHeic: 'image/heic',
    ImageHeifSequence: 'image/heif-sequence',
    ImageHeicSequence: 'image/heic-sequence',
    ImageJpeg: 'image/jpeg',
    ImageGif: 'image/gif',
    ImageWebp: 'image/webp',
    ImageSvgxml: 'image/svg+xml',
    ImageAvif: 'image/avif',
    VideoMp4: 'video/mp4',
    ModelGltfBinary: 'model/gltf-binary'
} as const;

export type MediaUploadRequestMimeTypeEnum = typeof MediaUploadRequestMimeTypeEnum[keyof typeof MediaUploadRequestMimeTypeEnum];

/**
 * 
 * @export
 * @interface MediaUploadResponse
 */
export interface MediaUploadResponse {
    /**
     * 
     * @type {string}
     * @memberof MediaUploadResponse
     */
    'url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MediaUploadResponse
     */
    'fields': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof MediaUploadResponse
     */
    'media_type': string;
}
/**
 * 
 * @export
 * @interface Merchant
 */
export interface Merchant {
    /**
     * The merchant ID identifying this merchant in the partner system. This value is globally unique in combination with the provider.
     * @type {string}
     * @memberof Merchant
     */
    'merchant_id': string;
    /**
     * The business name for this merchant.
     * @type {string}
     * @memberof Merchant
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'provider': MerchantProviderEnum;
    /**
     * 
     * @type {Address}
     * @memberof Merchant
     */
    'address': Address;
    /**
     * 
     * @type {string}
     * @memberof Merchant
     */
    'phone'?: string | null;
}

export const MerchantProviderEnum = {
    Clover: 'clover',
    Shopify: 'shopify'
} as const;

export type MerchantProviderEnum = typeof MerchantProviderEnum[keyof typeof MerchantProviderEnum];

/**
 * 
 * @export
 * @interface MerchantCatalog
 */
export interface MerchantCatalog {
    /**
     * The name for this catalog. e.g. Spring 2025 Catalog.
     * @type {string}
     * @memberof MerchantCatalog
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalog
     */
    'availability_start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalog
     */
    'availability_end'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalog
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof MerchantCatalog
     */
    'product_count'?: number | null;
    /**
     * Whether or not this catalog is active and appears on the device.
     * @type {boolean}
     * @memberof MerchantCatalog
     */
    'activated'?: boolean;
}
/**
 * 
 * @export
 * @interface MerchantCatalogBase
 */
export interface MerchantCatalogBase {
    /**
     * The name for this catalog. e.g. Spring 2025 Catalog.
     * @type {string}
     * @memberof MerchantCatalogBase
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalogBase
     */
    'availability_start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalogBase
     */
    'availability_end'?: string | null;
}
/**
 * 
 * @export
 * @interface MerchantCatalogProduct
 */
export interface MerchantCatalogProduct {
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalogProduct
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalogProduct
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalogProduct
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalogProduct
     */
    'html_description'?: string | null;
    /**
     * An array of strings to indicate how the variants of this product varies. Ex. [`Size`, `Color`]. Variants must define the property of each `varies_by` option. If this field is empty, this product can only have one default variant.
     * @type {Array<string>}
     * @memberof MerchantCatalogProduct
     */
    'varies_by'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MerchantCatalogProduct
     */
    'tags'?: Array<string> | null;
    /**
     * 
     * @type {GoogleProductCategory}
     * @memberof MerchantCatalogProduct
     */
    'google_product_category'?: GoogleProductCategory | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MerchantCatalogProduct
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalogProduct
     */
    'has_adult_consideration'?: MerchantCatalogProductHasAdultConsiderationEnum | null;
    /**
     * Determines whether or not the product information is publicly available
     * @type {boolean}
     * @memberof MerchantCatalogProduct
     */
    'is_published'?: boolean;
    /**
     * Determines whether or not the product is eligible for EBT/SNAP at the point of sale.
     * @type {boolean}
     * @memberof MerchantCatalogProduct
     */
    'is_ebt_eligible'?: boolean;
    /**
     * 
     * @type {Media}
     * @memberof MerchantCatalogProduct
     */
    'media'?: Media | null;
    /**
     * 
     * @type {Brand}
     * @memberof MerchantCatalogProduct
     */
    'brand'?: Brand | null;
    /**
     * 
     * @type {Organization}
     * @memberof MerchantCatalogProduct
     */
    'organization'?: Organization | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantCatalogProduct
     */
    'id'?: string | null;
    /**
     * 
     * @type {Array<VariantsWithPrice>}
     * @memberof MerchantCatalogProduct
     */
    'variants': Array<VariantsWithPrice>;
}

export const MerchantCatalogProductHasAdultConsiderationEnum = {
    AlcoholConsideration: 'AlcoholConsideration',
    DangerousGoodConsideration: 'DangerousGoodConsideration',
    HealthcareConsideration: 'HealthcareConsideration',
    NarcoticConsideration: 'NarcoticConsideration',
    ReducedRelevanceForChildrenConsideration: 'ReducedRelevanceForChildrenConsideration',
    SexualContentConsideration: 'SexualContentConsideration',
    TobaccoNicotineConsideration: 'TobaccoNicotineConsideration',
    UnclassifiedAdultConsideration: 'UnclassifiedAdultConsideration',
    ViolenceConsideration: 'ViolenceConsideration',
    WeaponConsideration: 'WeaponConsideration',
    Null: 'null'
} as const;

export type MerchantCatalogProductHasAdultConsiderationEnum = typeof MerchantCatalogProductHasAdultConsiderationEnum[keyof typeof MerchantCatalogProductHasAdultConsiderationEnum];

/**
 * 
 * @export
 * @interface ModelObject
 */
export interface ModelObject {
    /**
     * 
     * @type {string}
     * @memberof ModelObject
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ModelObject
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ModelObject
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ModelObject
     */
    'type': ModelObjectTypeEnum;
}

export const ModelObjectTypeEnum = {
    ModelGltfBinary: 'model/gltf-binary'
} as const;

export type ModelObjectTypeEnum = typeof ModelObjectTypeEnum[keyof typeof ModelObjectTypeEnum];

/**
 * 
 * @export
 * @interface Offer
 */
export interface Offer {
    /**
     * The price at which the product is sold.
     * @type {number}
     * @memberof Offer
     */
    'amount': number;
    /**
     * The currency code for this offer.
     * @type {string}
     * @memberof Offer
     */
    'currency_code'?: OfferCurrencyCodeEnum;
}

export const OfferCurrencyCodeEnum = {
    Usd: 'USD'
} as const;

export type OfferCurrencyCodeEnum = typeof OfferCurrencyCodeEnum[keyof typeof OfferCurrencyCodeEnum];

/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * The record ID of the Organization.
     * @type {string}
     * @memberof Organization
     */
    'id': string;
    /**
     * Name of organization such as `Proctor & Gamble` or `AB InBev`
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     * Default language for all records including product records.
     * @type {string}
     * @memberof Organization
     */
    'default_language'?: OrganizationDefaultLanguageEnum;
    /**
     * 
     * @type {Organization}
     * @memberof Organization
     */
    'parent'?: Organization | null;
}

export const OrganizationDefaultLanguageEnum = {
    Us: 'en_US',
    Gb: 'en_GB'
} as const;

export type OrganizationDefaultLanguageEnum = typeof OrganizationDefaultLanguageEnum[keyof typeof OrganizationDefaultLanguageEnum];

/**
 * 
 * @export
 * @interface OrganizationPayload
 */
export interface OrganizationPayload {
    /**
     * The ID for this record
     * @type {string}
     * @memberof OrganizationPayload
     */
    'id'?: string | null;
    /**
     * Name of organization such as `Proctor & Gamble` or `AB InBev`
     * @type {string}
     * @memberof OrganizationPayload
     */
    'name': string;
    /**
     * Default language for all records including product records.
     * @type {string}
     * @memberof OrganizationPayload
     */
    'default_language'?: OrganizationPayloadDefaultLanguageEnum;
    /**
     * 
     * @type {OrganizationRecordId}
     * @memberof OrganizationPayload
     */
    'parent'?: OrganizationRecordId | null;
}

export const OrganizationPayloadDefaultLanguageEnum = {
    Us: 'en_US',
    Gb: 'en_GB'
} as const;

export type OrganizationPayloadDefaultLanguageEnum = typeof OrganizationPayloadDefaultLanguageEnum[keyof typeof OrganizationPayloadDefaultLanguageEnum];

/**
 * 
 * @export
 * @interface OrganizationRecordId
 */
export interface OrganizationRecordId {
    /**
     * The record ID of the Organization.
     * @type {string}
     * @memberof OrganizationRecordId
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface ParseProductPageProductLookupRequestBody
 */
export interface ParseProductPageProductLookupRequestBody {
    /**
     * 
     * @type {string}
     * @memberof ParseProductPageProductLookupRequestBody
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ParseProductPageProductLookupResponseBody
 */
export interface ParseProductPageProductLookupResponseBody {
    /**
     * 
     * @type {string}
     * @memberof ParseProductPageProductLookupResponseBody
     */
    'url': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ParseProductPageProductLookupResponseBody
     */
    'product_data': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBody
 */
export interface PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBodyId}
     * @memberof PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBody
     */
    'id'?: PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBodyId;
}
/**
 * @type PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBodyId
 * The ID for this record
 * @export
 */
export type PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBodyId = string;

/**
 * 
 * @export
 * @interface PartialUpdateBrandByIdBrandPayloadRequestBody
 */
export interface PartialUpdateBrandByIdBrandPayloadRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PartialUpdateBrandByIdBrandPayloadRequestBody
     */
    'name'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyDefaultLanguage}
     * @memberof PartialUpdateBrandByIdBrandPayloadRequestBody
     */
    'default_language'?: PartialUpdateBrandByIdBrandPayloadRequestBodyDefaultLanguage;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBody}
     * @memberof PartialUpdateBrandByIdBrandPayloadRequestBody
     */
    'parent'?: PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBody | null;
}
/**
 * @type PartialUpdateBrandByIdBrandPayloadRequestBodyDefaultLanguage
 * @export
 */
export type PartialUpdateBrandByIdBrandPayloadRequestBodyDefaultLanguage = string;

/**
 * @type PartialUpdateBrandByIdBrandPayloadRequestBodyName
 * @export
 */
export type PartialUpdateBrandByIdBrandPayloadRequestBodyName = string;

/**
 * 
 * @export
 * @interface PartialUpdateCatalogMerchantCatalogRequestBody
 */
export interface PartialUpdateCatalogMerchantCatalogRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PartialUpdateCatalogMerchantCatalogRequestBody
     */
    'name'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateCatalogMerchantCatalogRequestBody
     */
    'availability_start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateCatalogMerchantCatalogRequestBody
     */
    'availability_end'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateCatalogMerchantCatalogRequestBody
     */
    'product_count'?: number | null;
}
/**
 * 
 * @export
 * @interface PartialUpdateCatalogMerchantCatalogResponseBody
 */
export interface PartialUpdateCatalogMerchantCatalogResponseBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PartialUpdateCatalogMerchantCatalogResponseBody
     */
    'name'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateCatalogMerchantCatalogResponseBody
     */
    'availability_start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateCatalogMerchantCatalogResponseBody
     */
    'availability_end'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateCatalogMerchantCatalogResponseBody
     */
    'product_count'?: number | null;
}
/**
 * 
 * @export
 * @interface PartialUpdateOrganizationOrganizationPayload0OrganizationRecordIdRequestBody
 */
export interface PartialUpdateOrganizationOrganizationPayload0OrganizationRecordIdRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBodyId}
     * @memberof PartialUpdateOrganizationOrganizationPayload0OrganizationRecordIdRequestBody
     */
    'id'?: PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBodyId;
}
/**
 * 
 * @export
 * @interface PartialUpdateOrganizationOrganizationPayloadRequestBody
 */
export interface PartialUpdateOrganizationOrganizationPayloadRequestBody {
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateOrganizationOrganizationPayloadRequestBody
     */
    'id'?: string | null;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PartialUpdateOrganizationOrganizationPayloadRequestBody
     */
    'name'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyDefaultLanguage}
     * @memberof PartialUpdateOrganizationOrganizationPayloadRequestBody
     */
    'default_language'?: PartialUpdateBrandByIdBrandPayloadRequestBodyDefaultLanguage;
    /**
     * 
     * @type {PartialUpdateOrganizationOrganizationPayload0OrganizationRecordIdRequestBody}
     * @memberof PartialUpdateOrganizationOrganizationPayloadRequestBody
     */
    'parent'?: PartialUpdateOrganizationOrganizationPayload0OrganizationRecordIdRequestBody | null;
}
/**
 * 
 * @export
 * @interface PartialUpdateVariantProductVariant00SuggestedPriceRequestBody
 */
export interface PartialUpdateVariantProductVariant00SuggestedPriceRequestBody {
    /**
     * 
     * @type {PartialUpdateVariantProductVariant00SuggestedPriceRequestBodyAmount}
     * @memberof PartialUpdateVariantProductVariant00SuggestedPriceRequestBody
     */
    'amount'?: PartialUpdateVariantProductVariant00SuggestedPriceRequestBodyAmount;
    /**
     * 
     * @type {PartialUpdateVariantProductVariant00SuggestedPriceRequestBodyCurrencyCode}
     * @memberof PartialUpdateVariantProductVariant00SuggestedPriceRequestBody
     */
    'currency_code'?: PartialUpdateVariantProductVariant00SuggestedPriceRequestBodyCurrencyCode;
}
/**
 * @type PartialUpdateVariantProductVariant00SuggestedPriceRequestBodyAmount
 * @export
 */
export type PartialUpdateVariantProductVariant00SuggestedPriceRequestBodyAmount = number;

/**
 * @type PartialUpdateVariantProductVariant00SuggestedPriceRequestBodyCurrencyCode
 * @export
 */
export type PartialUpdateVariantProductVariant00SuggestedPriceRequestBodyCurrencyCode = string;

/**
 * 
 * @export
 * @interface PartialUpdateVariantProductVariant00SuggestedPriceResponseBody
 */
export interface PartialUpdateVariantProductVariant00SuggestedPriceResponseBody {
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateVariantProductVariant00SuggestedPriceResponseBody
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariant00SuggestedPriceResponseBody
     */
    'currency_code': PartialUpdateVariantProductVariant00SuggestedPriceResponseBodyCurrencyCodeEnum;
}

export const PartialUpdateVariantProductVariant00SuggestedPriceResponseBodyCurrencyCodeEnum = {
    Usd: 'USD'
} as const;

export type PartialUpdateVariantProductVariant00SuggestedPriceResponseBodyCurrencyCodeEnum = typeof PartialUpdateVariantProductVariant00SuggestedPriceResponseBodyCurrencyCodeEnum[keyof typeof PartialUpdateVariantProductVariant00SuggestedPriceResponseBodyCurrencyCodeEnum];

/**
 * 
 * @export
 * @interface PartialUpdateVariantProductVariant0VariesByRequestBody
 */
export interface PartialUpdateVariantProductVariant0VariesByRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PartialUpdateVariantProductVariant0VariesByRequestBody
     */
    'name'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PartialUpdateVariantProductVariant0VariesByRequestBody
     */
    'value'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PartialUpdateVariantProductVariant0VariesByRequestBody
     */
    'metadata'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface PartialUpdateVariantProductVariant0VariesByResponseBody
 */
export interface PartialUpdateVariantProductVariant0VariesByResponseBody {
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariant0VariesByResponseBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariant0VariesByResponseBody
     */
    'value': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PartialUpdateVariantProductVariant0VariesByResponseBody
     */
    'metadata'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface PartialUpdateVariantProductVariantRequestBody
 */
export interface PartialUpdateVariantProductVariantRequestBody {
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariantRequestBody
     */
    'sku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariantRequestBody
     */
    'gtin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariantRequestBody
     */
    'gtin12'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariantRequestBody
     */
    'gtin8'?: string | null;
    /**
     * 
     * @type {PartialUpdateVariantProductVariantRequestBodyVariesBy}
     * @memberof PartialUpdateVariantProductVariantRequestBody
     */
    'varies_by'?: PartialUpdateVariantProductVariantRequestBodyVariesBy;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PartialUpdateVariantProductVariantRequestBody
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<PartialUpdateVariantProductVariant00SuggestedPriceRequestBody>}
     * @memberof PartialUpdateVariantProductVariantRequestBody
     */
    'suggested_prices'?: Array<PartialUpdateVariantProductVariant00SuggestedPriceRequestBody> | null;
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateVariantProductVariantRequestBody
     */
    'ordinal'?: number | null;
}
/**
 * @type PartialUpdateVariantProductVariantRequestBodyVariesBy
 * @export
 */
export type PartialUpdateVariantProductVariantRequestBodyVariesBy = Array<PartialUpdateVariantProductVariant0VariesByRequestBody>;

/**
 * 
 * @export
 * @interface PartialUpdateVariantProductVariantResponseBody
 */
export interface PartialUpdateVariantProductVariantResponseBody {
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariantResponseBody
     */
    'sku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariantResponseBody
     */
    'gtin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariantResponseBody
     */
    'gtin12'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PartialUpdateVariantProductVariantResponseBody
     */
    'gtin8'?: string | null;
    /**
     * 
     * @type {Array<PartialUpdateVariantProductVariant0VariesByResponseBody>}
     * @memberof PartialUpdateVariantProductVariantResponseBody
     */
    'varies_by'?: Array<PartialUpdateVariantProductVariant0VariesByResponseBody>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PartialUpdateVariantProductVariantResponseBody
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<PartialUpdateVariantProductVariant00SuggestedPriceResponseBody>}
     * @memberof PartialUpdateVariantProductVariantResponseBody
     */
    'suggested_prices'?: Array<PartialUpdateVariantProductVariant00SuggestedPriceResponseBody> | null;
    /**
     * 
     * @type {number}
     * @memberof PartialUpdateVariantProductVariantResponseBody
     */
    'ordinal'?: number | null;
    /**
     * The ID for this record
     * @type {string}
     * @memberof PartialUpdateVariantProductVariantResponseBody
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PatchProductMedia0ImageRequestBody
 */
export interface PatchProductMedia0ImageRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductMedia0ImageRequestBody
     */
    'url'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductMedia0ImageRequestBody
     */
    'name'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductMedia0ImageRequestBody
     */
    'key'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PatchProductMedia0ImageRequestBodyType}
     * @memberof PatchProductMedia0ImageRequestBody
     */
    'type'?: PatchProductMedia0ImageRequestBodyType;
}
/**
 * @type PatchProductMedia0ImageRequestBodyType
 * @export
 */
export type PatchProductMedia0ImageRequestBodyType = string;

/**
 * 
 * @export
 * @interface PatchProductMedia0ModelObjectRequestBody
 */
export interface PatchProductMedia0ModelObjectRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductMedia0ModelObjectRequestBody
     */
    'url'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductMedia0ModelObjectRequestBody
     */
    'name'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductMedia0ModelObjectRequestBody
     */
    'key'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PatchProductMedia0ModelObjectRequestBodyType}
     * @memberof PatchProductMedia0ModelObjectRequestBody
     */
    'type'?: PatchProductMedia0ModelObjectRequestBodyType;
}
/**
 * @type PatchProductMedia0ModelObjectRequestBodyType
 * @export
 */
export type PatchProductMedia0ModelObjectRequestBodyType = string;

/**
 * 
 * @export
 * @interface PatchProductMedia0VideoRequestBody
 */
export interface PatchProductMedia0VideoRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductMedia0VideoRequestBody
     */
    'url'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductMedia0VideoRequestBody
     */
    'name'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductMedia0VideoRequestBody
     */
    'key'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {PatchProductMedia0VideoRequestBodyType}
     * @memberof PatchProductMedia0VideoRequestBody
     */
    'type'?: PatchProductMedia0VideoRequestBodyType;
}
/**
 * @type PatchProductMedia0VideoRequestBodyType
 * @export
 */
export type PatchProductMedia0VideoRequestBodyType = string;

/**
 * 
 * @export
 * @interface PatchProductProductUpdate0BrandRecordIdRequestBody
 */
export interface PatchProductProductUpdate0BrandRecordIdRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBodyId}
     * @memberof PatchProductProductUpdate0BrandRecordIdRequestBody
     */
    'id'?: PartialUpdateBrandByIdBrandPayload0BrandRecordIdRequestBodyId;
}
/**
 * 
 * @export
 * @interface PatchProductProductUpdate0GoogleProductCategoryReferenceRequestBody
 */
export interface PatchProductProductUpdate0GoogleProductCategoryReferenceRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductProductUpdate0GoogleProductCategoryReferenceRequestBody
     */
    'id'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
}
/**
 * 
 * @export
 * @interface PatchProductProductUpdate0MediaRequestBody
 */
export interface PatchProductProductUpdate0MediaRequestBody {
    /**
     * 
     * @type {PatchProductProductUpdate0MediaRequestBodyImages}
     * @memberof PatchProductProductUpdate0MediaRequestBody
     */
    'images'?: PatchProductProductUpdate0MediaRequestBodyImages;
    /**
     * 
     * @type {PatchProductProductUpdate0MediaRequestBodyVideos}
     * @memberof PatchProductProductUpdate0MediaRequestBody
     */
    'videos'?: PatchProductProductUpdate0MediaRequestBodyVideos;
    /**
     * 
     * @type {PatchProductProductUpdate0MediaRequestBodyModels}
     * @memberof PatchProductProductUpdate0MediaRequestBody
     */
    'models'?: PatchProductProductUpdate0MediaRequestBodyModels;
}
/**
 * @type PatchProductProductUpdate0MediaRequestBodyImages
 * @export
 */
export type PatchProductProductUpdate0MediaRequestBodyImages = Array<PatchProductMedia0ImageRequestBody>;

/**
 * @type PatchProductProductUpdate0MediaRequestBodyModels
 * @export
 */
export type PatchProductProductUpdate0MediaRequestBodyModels = Array<PatchProductMedia0ModelObjectRequestBody>;

/**
 * @type PatchProductProductUpdate0MediaRequestBodyVideos
 * @export
 */
export type PatchProductProductUpdate0MediaRequestBodyVideos = Array<PatchProductMedia0VideoRequestBody>;

/**
 * 
 * @export
 * @interface PatchProductProductUpdateRequestBody
 */
export interface PatchProductProductUpdateRequestBody {
    /**
     * 
     * @type {PartialUpdateBrandByIdBrandPayloadRequestBodyName}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'title'?: PartialUpdateBrandByIdBrandPayloadRequestBodyName;
    /**
     * 
     * @type {string}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'html_description'?: string | null;
    /**
     * 
     * @type {PatchProductProductUpdateRequestBodyVariesBy}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'varies_by'?: PatchProductProductUpdateRequestBodyVariesBy;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'tags'?: Array<string> | null;
    /**
     * 
     * @type {PatchProductProductUpdate0GoogleProductCategoryReferenceRequestBody}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'google_product_category'?: PatchProductProductUpdate0GoogleProductCategoryReferenceRequestBody | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'has_adult_consideration'?: PatchProductProductUpdateRequestBodyHasAdultConsiderationEnum | null;
    /**
     * 
     * @type {PatchProductProductUpdateRequestBodyIsPublished}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'is_published'?: PatchProductProductUpdateRequestBodyIsPublished;
    /**
     * 
     * @type {PatchProductProductUpdateRequestBodyIsPublished}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'is_ebt_eligible'?: PatchProductProductUpdateRequestBodyIsPublished;
    /**
     * 
     * @type {PatchProductProductUpdate0MediaRequestBody}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'media'?: PatchProductProductUpdate0MediaRequestBody | null;
    /**
     * 
     * @type {PatchProductProductUpdate0BrandRecordIdRequestBody}
     * @memberof PatchProductProductUpdateRequestBody
     */
    'brand'?: PatchProductProductUpdate0BrandRecordIdRequestBody | null;
}

export const PatchProductProductUpdateRequestBodyHasAdultConsiderationEnum = {
    AlcoholConsideration: 'AlcoholConsideration',
    DangerousGoodConsideration: 'DangerousGoodConsideration',
    HealthcareConsideration: 'HealthcareConsideration',
    NarcoticConsideration: 'NarcoticConsideration',
    ReducedRelevanceForChildrenConsideration: 'ReducedRelevanceForChildrenConsideration',
    SexualContentConsideration: 'SexualContentConsideration',
    TobaccoNicotineConsideration: 'TobaccoNicotineConsideration',
    UnclassifiedAdultConsideration: 'UnclassifiedAdultConsideration',
    ViolenceConsideration: 'ViolenceConsideration',
    WeaponConsideration: 'WeaponConsideration'
} as const;

export type PatchProductProductUpdateRequestBodyHasAdultConsiderationEnum = typeof PatchProductProductUpdateRequestBodyHasAdultConsiderationEnum[keyof typeof PatchProductProductUpdateRequestBodyHasAdultConsiderationEnum];

/**
 * @type PatchProductProductUpdateRequestBodyIsPublished
 * @export
 */
export type PatchProductProductUpdateRequestBodyIsPublished = boolean;

/**
 * @type PatchProductProductUpdateRequestBodyVariesBy
 * @export
 */
export type PatchProductProductUpdateRequestBodyVariesBy = Array<string>;

/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * The name of the product
     * @type {string}
     * @memberof Product
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'html_description'?: string | null;
    /**
     * An array of strings to indicate how the variants of this product varies. Ex. [`Size`, `Color`]. Variants must define the property of each `varies_by` option. If this field is empty, this product can only have one default variant.
     * @type {Array<string>}
     * @memberof Product
     */
    'varies_by'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    'tags'?: Array<string> | null;
    /**
     * 
     * @type {GoogleProductCategory}
     * @memberof Product
     */
    'google_product_category'?: GoogleProductCategory | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Product
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'has_adult_consideration'?: ProductHasAdultConsiderationEnum | null;
    /**
     * Determines whether or not the product information is publicly available
     * @type {boolean}
     * @memberof Product
     */
    'is_published'?: boolean;
    /**
     * Determines whether or not the product is eligible for EBT/SNAP at the point of sale.
     * @type {boolean}
     * @memberof Product
     */
    'is_ebt_eligible'?: boolean;
    /**
     * 
     * @type {Media}
     * @memberof Product
     */
    'media'?: Media | null;
    /**
     * 
     * @type {Brand}
     * @memberof Product
     */
    'brand'?: Brand | null;
    /**
     * 
     * @type {Organization}
     * @memberof Product
     */
    'organization'?: Organization | null;
    /**
     * The ID for this record
     * @type {string}
     * @memberof Product
     */
    'id': string;
}

export const ProductHasAdultConsiderationEnum = {
    AlcoholConsideration: 'AlcoholConsideration',
    DangerousGoodConsideration: 'DangerousGoodConsideration',
    HealthcareConsideration: 'HealthcareConsideration',
    NarcoticConsideration: 'NarcoticConsideration',
    ReducedRelevanceForChildrenConsideration: 'ReducedRelevanceForChildrenConsideration',
    SexualContentConsideration: 'SexualContentConsideration',
    TobaccoNicotineConsideration: 'TobaccoNicotineConsideration',
    UnclassifiedAdultConsideration: 'UnclassifiedAdultConsideration',
    ViolenceConsideration: 'ViolenceConsideration',
    WeaponConsideration: 'WeaponConsideration',
    Null: 'null'
} as const;

export type ProductHasAdultConsiderationEnum = typeof ProductHasAdultConsiderationEnum[keyof typeof ProductHasAdultConsiderationEnum];

/**
 * 
 * @export
 * @interface ProductCreateWithVariants
 */
export interface ProductCreateWithVariants {
    /**
     * The name of the product
     * @type {string}
     * @memberof ProductCreateWithVariants
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateWithVariants
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateWithVariants
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateWithVariants
     */
    'html_description'?: string | null;
    /**
     * An array of strings to indicate how the variants of this product varies. Ex. [`Size`, `Color`]. Variants must define the property of each `varies_by` option. If this field is empty, this product can only have one default variant.
     * @type {Array<string>}
     * @memberof ProductCreateWithVariants
     */
    'varies_by'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductCreateWithVariants
     */
    'tags'?: Array<string> | null;
    /**
     * 
     * @type {GoogleProductCategoryReference}
     * @memberof ProductCreateWithVariants
     */
    'google_product_category'?: GoogleProductCategoryReference | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProductCreateWithVariants
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof ProductCreateWithVariants
     */
    'has_adult_consideration'?: ProductCreateWithVariantsHasAdultConsiderationEnum | null;
    /**
     * Determines whether or not the product information is publicly available
     * @type {boolean}
     * @memberof ProductCreateWithVariants
     */
    'is_published'?: boolean;
    /**
     * Determines whether or not the product is eligible for EBT/SNAP at the point of sale.
     * @type {boolean}
     * @memberof ProductCreateWithVariants
     */
    'is_ebt_eligible'?: boolean;
    /**
     * 
     * @type {Media}
     * @memberof ProductCreateWithVariants
     */
    'media'?: Media | null;
    /**
     * 
     * @type {BrandRecordId}
     * @memberof ProductCreateWithVariants
     */
    'brand'?: BrandRecordId | null;
    /**
     * The variants of this product. At least one is required for every product.
     * @type {Array<ProductVariantBase>}
     * @memberof ProductCreateWithVariants
     */
    'variants': Array<ProductVariantBase>;
}

export const ProductCreateWithVariantsHasAdultConsiderationEnum = {
    AlcoholConsideration: 'AlcoholConsideration',
    DangerousGoodConsideration: 'DangerousGoodConsideration',
    HealthcareConsideration: 'HealthcareConsideration',
    NarcoticConsideration: 'NarcoticConsideration',
    ReducedRelevanceForChildrenConsideration: 'ReducedRelevanceForChildrenConsideration',
    SexualContentConsideration: 'SexualContentConsideration',
    TobaccoNicotineConsideration: 'TobaccoNicotineConsideration',
    UnclassifiedAdultConsideration: 'UnclassifiedAdultConsideration',
    ViolenceConsideration: 'ViolenceConsideration',
    WeaponConsideration: 'WeaponConsideration',
    Null: 'null'
} as const;

export type ProductCreateWithVariantsHasAdultConsiderationEnum = typeof ProductCreateWithVariantsHasAdultConsiderationEnum[keyof typeof ProductCreateWithVariantsHasAdultConsiderationEnum];

/**
 * 
 * @export
 * @interface ProductUpdateWithVariants
 */
export interface ProductUpdateWithVariants {
    /**
     * The name of the product
     * @type {string}
     * @memberof ProductUpdateWithVariants
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateWithVariants
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateWithVariants
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateWithVariants
     */
    'html_description'?: string | null;
    /**
     * An array of strings to indicate how the variants of this product varies. Ex. [`Size`, `Color`]. Variants must define the property of each `varies_by` option. If this field is empty, this product can only have one default variant.
     * @type {Array<string>}
     * @memberof ProductUpdateWithVariants
     */
    'varies_by'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductUpdateWithVariants
     */
    'tags'?: Array<string> | null;
    /**
     * 
     * @type {GoogleProductCategoryReference}
     * @memberof ProductUpdateWithVariants
     */
    'google_product_category'?: GoogleProductCategoryReference | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProductUpdateWithVariants
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof ProductUpdateWithVariants
     */
    'has_adult_consideration'?: ProductUpdateWithVariantsHasAdultConsiderationEnum | null;
    /**
     * Determines whether or not the product information is publicly available
     * @type {boolean}
     * @memberof ProductUpdateWithVariants
     */
    'is_published'?: boolean;
    /**
     * Determines whether or not the product is eligible for EBT/SNAP at the point of sale.
     * @type {boolean}
     * @memberof ProductUpdateWithVariants
     */
    'is_ebt_eligible'?: boolean;
    /**
     * 
     * @type {Media}
     * @memberof ProductUpdateWithVariants
     */
    'media'?: Media | null;
    /**
     * 
     * @type {BrandRecordId}
     * @memberof ProductUpdateWithVariants
     */
    'brand'?: BrandRecordId | null;
    /**
     * The ID for this record
     * @type {string}
     * @memberof ProductUpdateWithVariants
     */
    'id': string;
    /**
     * 
     * @type {Array<ProductUpdateWithVariantsVariantsInner>}
     * @memberof ProductUpdateWithVariants
     */
    'variants': Array<ProductUpdateWithVariantsVariantsInner>;
}

export const ProductUpdateWithVariantsHasAdultConsiderationEnum = {
    AlcoholConsideration: 'AlcoholConsideration',
    DangerousGoodConsideration: 'DangerousGoodConsideration',
    HealthcareConsideration: 'HealthcareConsideration',
    NarcoticConsideration: 'NarcoticConsideration',
    ReducedRelevanceForChildrenConsideration: 'ReducedRelevanceForChildrenConsideration',
    SexualContentConsideration: 'SexualContentConsideration',
    TobaccoNicotineConsideration: 'TobaccoNicotineConsideration',
    UnclassifiedAdultConsideration: 'UnclassifiedAdultConsideration',
    ViolenceConsideration: 'ViolenceConsideration',
    WeaponConsideration: 'WeaponConsideration',
    Null: 'null'
} as const;

export type ProductUpdateWithVariantsHasAdultConsiderationEnum = typeof ProductUpdateWithVariantsHasAdultConsiderationEnum[keyof typeof ProductUpdateWithVariantsHasAdultConsiderationEnum];

/**
 * @type ProductUpdateWithVariantsVariantsInner
 * @export
 */
export type ProductUpdateWithVariantsVariantsInner = ProductVariant | ProductVariantBase;

/**
 * 
 * @export
 * @interface ProductVariant
 */
export interface ProductVariant {
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    'sku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    'gtin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    'gtin12'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    'gtin8'?: string | null;
    /**
     * A list of properties that identify this variant. Must match those defined on the product. If defined on the product, it is required on the variant.
     * @type {Array<VariesBy>}
     * @memberof ProductVariant
     */
    'varies_by'?: Array<VariesBy>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProductVariant
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SuggestedPrice>}
     * @memberof ProductVariant
     */
    'suggested_prices'?: Array<SuggestedPrice> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductVariant
     */
    'ordinal'?: number | null;
    /**
     * The ID for this record
     * @type {string}
     * @memberof ProductVariant
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductVariant
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface ProductVariantBase
 */
export interface ProductVariantBase {
    /**
     * 
     * @type {string}
     * @memberof ProductVariantBase
     */
    'sku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantBase
     */
    'gtin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantBase
     */
    'gtin12'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantBase
     */
    'gtin8'?: string | null;
    /**
     * A list of properties that identify this variant. Must match those defined on the product. If defined on the product, it is required on the variant.
     * @type {Array<VariesBy>}
     * @memberof ProductVariantBase
     */
    'varies_by'?: Array<VariesBy>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProductVariantBase
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SuggestedPrice>}
     * @memberof ProductVariantBase
     */
    'suggested_prices'?: Array<SuggestedPrice> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantBase
     */
    'ordinal'?: number | null;
}
/**
 * 
 * @export
 * @interface ProductVariantWithProduct
 */
export interface ProductVariantWithProduct {
    /**
     * 
     * @type {string}
     * @memberof ProductVariantWithProduct
     */
    'sku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantWithProduct
     */
    'gtin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantWithProduct
     */
    'gtin12'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantWithProduct
     */
    'gtin8'?: string | null;
    /**
     * A list of properties that identify this variant. Must match those defined on the product. If defined on the product, it is required on the variant.
     * @type {Array<VariesBy>}
     * @memberof ProductVariantWithProduct
     */
    'varies_by'?: Array<VariesBy>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProductVariantWithProduct
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SuggestedPrice>}
     * @memberof ProductVariantWithProduct
     */
    'suggested_prices'?: Array<SuggestedPrice> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductVariantWithProduct
     */
    'ordinal'?: number | null;
    /**
     * The ID for this record
     * @type {string}
     * @memberof ProductVariantWithProduct
     */
    'id': string;
    /**
     * 
     * @type {Product}
     * @memberof ProductVariantWithProduct
     */
    'product': Product;
    /**
     * 
     * @type {string}
     * @memberof ProductVariantWithProduct
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface ProductWithVariants
 */
export interface ProductWithVariants {
    /**
     * The name of the product
     * @type {string}
     * @memberof ProductWithVariants
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ProductWithVariants
     */
    'subtitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductWithVariants
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductWithVariants
     */
    'html_description'?: string | null;
    /**
     * An array of strings to indicate how the variants of this product varies. Ex. [`Size`, `Color`]. Variants must define the property of each `varies_by` option. If this field is empty, this product can only have one default variant.
     * @type {Array<string>}
     * @memberof ProductWithVariants
     */
    'varies_by'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductWithVariants
     */
    'tags'?: Array<string> | null;
    /**
     * 
     * @type {GoogleProductCategory}
     * @memberof ProductWithVariants
     */
    'google_product_category'?: GoogleProductCategory | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProductWithVariants
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof ProductWithVariants
     */
    'has_adult_consideration'?: ProductWithVariantsHasAdultConsiderationEnum | null;
    /**
     * Determines whether or not the product information is publicly available
     * @type {boolean}
     * @memberof ProductWithVariants
     */
    'is_published'?: boolean;
    /**
     * Determines whether or not the product is eligible for EBT/SNAP at the point of sale.
     * @type {boolean}
     * @memberof ProductWithVariants
     */
    'is_ebt_eligible'?: boolean;
    /**
     * 
     * @type {Media}
     * @memberof ProductWithVariants
     */
    'media'?: Media | null;
    /**
     * 
     * @type {Brand}
     * @memberof ProductWithVariants
     */
    'brand'?: Brand | null;
    /**
     * 
     * @type {Organization}
     * @memberof ProductWithVariants
     */
    'organization'?: Organization | null;
    /**
     * The ID for this record
     * @type {string}
     * @memberof ProductWithVariants
     */
    'id': string;
    /**
     * 
     * @type {Array<ProductUpdateWithVariantsVariantsInner>}
     * @memberof ProductWithVariants
     */
    'variants': Array<ProductUpdateWithVariantsVariantsInner>;
}

export const ProductWithVariantsHasAdultConsiderationEnum = {
    AlcoholConsideration: 'AlcoholConsideration',
    DangerousGoodConsideration: 'DangerousGoodConsideration',
    HealthcareConsideration: 'HealthcareConsideration',
    NarcoticConsideration: 'NarcoticConsideration',
    ReducedRelevanceForChildrenConsideration: 'ReducedRelevanceForChildrenConsideration',
    SexualContentConsideration: 'SexualContentConsideration',
    TobaccoNicotineConsideration: 'TobaccoNicotineConsideration',
    UnclassifiedAdultConsideration: 'UnclassifiedAdultConsideration',
    ViolenceConsideration: 'ViolenceConsideration',
    WeaponConsideration: 'WeaponConsideration',
    Null: 'null'
} as const;

export type ProductWithVariantsHasAdultConsiderationEnum = typeof ProductWithVariantsHasAdultConsiderationEnum[keyof typeof ProductWithVariantsHasAdultConsiderationEnum];

/**
 * 
 * @export
 * @interface Program
 */
export interface Program {
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    'type': ProgramTypeEnum;
    /**
     * 
     * @type {ProgramCredential}
     * @memberof Program
     */
    'credential'?: ProgramCredential | null;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    'name': string;
}

export const ProgramTypeEnum = {
    Altria: 'altria'
} as const;

export type ProgramTypeEnum = typeof ProgramTypeEnum[keyof typeof ProgramTypeEnum];

/**
 * 
 * @export
 * @interface ProgramCredential
 */
export interface ProgramCredential {
    /**
     * Type of SDP.
     * @type {string}
     * @memberof ProgramCredential
     */
    'type': ProgramCredentialTypeEnum;
    /**
     * Number identifier of SDP provided by the manufacturer. Altria\'s management account number\'s are five-digit, while retail control number\'s are six.
     * @type {string}
     * @memberof ProgramCredential
     */
    'number': string;
    /**
     * sFTP username provided by the manufacturer to send SDP report files.
     * @type {string}
     * @memberof ProgramCredential
     */
    'sftp_username': string;
    /**
     * The ID for this record
     * @type {string}
     * @memberof ProgramCredential
     */
    'id': string;
    /**
     * List of merchant ID\'s that use this credential
     * @type {Array<string>}
     * @memberof ProgramCredential
     */
    'merchant_ids': Array<string>;
}

export const ProgramCredentialTypeEnum = {
    Altria: 'altria'
} as const;

export type ProgramCredentialTypeEnum = typeof ProgramCredentialTypeEnum[keyof typeof ProgramCredentialTypeEnum];

/**
 * 
 * @export
 * @interface ProgramCredentialCreate
 */
export interface ProgramCredentialCreate {
    /**
     * Type of SDP.
     * @type {string}
     * @memberof ProgramCredentialCreate
     */
    'type': ProgramCredentialCreateTypeEnum;
    /**
     * Number identifier of SDP provided by the manufacturer. Altria\'s management account number\'s are five-digit, while retail control number\'s are six.
     * @type {string}
     * @memberof ProgramCredentialCreate
     */
    'number': string;
    /**
     * sFTP username provided by the manufacturer to send SDP report files.
     * @type {string}
     * @memberof ProgramCredentialCreate
     */
    'sftp_username': string;
    /**
     * sFTP password provided by the manufacturer to send SDP report files.
     * @type {string}
     * @memberof ProgramCredentialCreate
     */
    'sftp_password': string;
}

export const ProgramCredentialCreateTypeEnum = {
    Altria: 'altria'
} as const;

export type ProgramCredentialCreateTypeEnum = typeof ProgramCredentialCreateTypeEnum[keyof typeof ProgramCredentialCreateTypeEnum];

/**
 * 
 * @export
 * @interface PurchaseRequirement
 */
export interface PurchaseRequirement {
    /**
     * The type of purchase requirement. Options are quantity, value, or matching_quantity.
     * @type {string}
     * @memberof PurchaseRequirement
     */
    'type': PurchaseRequirementTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PurchaseRequirement
     */
    'operator': PurchaseRequirementOperatorEnum;
    /**
     * 
     * @type {any}
     * @memberof PurchaseRequirement
     */
    'value'?: any;
    /**
     * If purchase requirement is setting an upper limit (using = or <) this field defines whether overages should be restricted. Options are: null - any overage does not receive the discount but purchase is not restricted, restrict - the customer cannot purchase beyond the upper limit, disqualify - the discount does not apply at all if the customer purchases more than the upper limit
     * @type {string}
     * @memberof PurchaseRequirement
     */
    'overage_restriction'?: PurchaseRequirementOverageRestrictionEnum | null;
}

export const PurchaseRequirementTypeEnum = {
    Quantity: 'quantity',
    Value: 'value',
    MatchingQuantity: 'matching_quantity'
} as const;

export type PurchaseRequirementTypeEnum = typeof PurchaseRequirementTypeEnum[keyof typeof PurchaseRequirementTypeEnum];
export const PurchaseRequirementOperatorEnum = {
    Equal: '=',
    GreaterThan: '>',
    LessThan: '<',
    GreaterThanOrEqualTo: '>=',
    LessThanOrEqualTo: '<=',
    IncrementOf: 'increment_of'
} as const;

export type PurchaseRequirementOperatorEnum = typeof PurchaseRequirementOperatorEnum[keyof typeof PurchaseRequirementOperatorEnum];
export const PurchaseRequirementOverageRestrictionEnum = {
    Restrict: 'restrict',
    Disqualify: 'disqualify',
    Null: 'null'
} as const;

export type PurchaseRequirementOverageRestrictionEnum = typeof PurchaseRequirementOverageRestrictionEnum[keyof typeof PurchaseRequirementOverageRestrictionEnum];

/**
 * 
 * @export
 * @interface ReadOnlyListAllCategories200Response
 */
export interface ReadOnlyListAllCategories200Response {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadOnlyListAllCategories200Response
     */
    'items'?: Array<string>;
    /**
     * Unique ID, designating the last identifier in the given data set. This value can be used to request the \'next\' batch of records.
     * @type {string}
     * @memberof ReadOnlyListAllCategories200Response
     */
    'cursor'?: string;
    /**
     * Maximal number of items to send.
     * @type {number}
     * @memberof ReadOnlyListAllCategories200Response
     */
    'results_per_page'?: number;
}
/**
 * @type ReadOnlyListAllCategoriesQParameter
 * @export
 */
export type ReadOnlyListAllCategoriesQParameter = string;

/**
 * 
 * @export
 * @interface RedirectApiResponse
 */
export interface RedirectApiResponse {
    /**
     * 
     * @type {string}
     * @memberof RedirectApiResponse
     */
    'redirect_url': string;
}
/**
 * 
 * @export
 * @interface ScandataSubmission
 */
export interface ScandataSubmission {
    /**
     * 
     * @type {string}
     * @memberof ScandataSubmission
     */
    'week_ending_date': string;
    /**
     * 
     * @type {string}
     * @memberof ScandataSubmission
     */
    'submission_date': string;
    /**
     * 
     * @type {number}
     * @memberof ScandataSubmission
     */
    'version': number;
    /**
     * The ID for this record
     * @type {string}
     * @memberof ScandataSubmission
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface ScandataSubmissionBase
 */
export interface ScandataSubmissionBase {
    /**
     * 
     * @type {string}
     * @memberof ScandataSubmissionBase
     */
    'week_ending_date': string;
    /**
     * 
     * @type {string}
     * @memberof ScandataSubmissionBase
     */
    'submission_date': string;
    /**
     * 
     * @type {number}
     * @memberof ScandataSubmissionBase
     */
    'version': number;
}
/**
 * 
 * @export
 * @interface SuggestedPrice
 */
export interface SuggestedPrice {
    /**
     * 
     * @type {number}
     * @memberof SuggestedPrice
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof SuggestedPrice
     */
    'currency_code': SuggestedPriceCurrencyCodeEnum;
}

export const SuggestedPriceCurrencyCodeEnum = {
    Usd: 'USD'
} as const;

export type SuggestedPriceCurrencyCodeEnum = typeof SuggestedPriceCurrencyCodeEnum[keyof typeof SuggestedPriceCurrencyCodeEnum];

/**
 * 
 * @export
 * @interface TaskRequestData
 */
export interface TaskRequestData {
    /**
     * Path to task class
     * @type {string}
     * @memberof TaskRequestData
     */
    'path': string;
    /**
     * kwargs to run the task with
     * @type {{ [key: string]: any; }}
     * @memberof TaskRequestData
     */
    'kwargs': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ThriveAccount
 */
export interface ThriveAccount {
    /**
     * Thrive inventory account ID
     * @type {string}
     * @memberof ThriveAccount
     */
    'account_id': string;
    /**
     * Thrive user ID
     * @type {string}
     * @memberof ThriveAccount
     */
    'user_id': string;
    /**
     * Thrive user email
     * @type {string}
     * @memberof ThriveAccount
     */
    'email': string;
    /**
     * Thrive user\'s first and last name
     * @type {string}
     * @memberof ThriveAccount
     */
    'name': string;
    /**
     * The thrive company\'s name
     * @type {string}
     * @memberof ThriveAccount
     */
    'company_name'?: string;
}
/**
 * Not Authorized Exception
 * @export
 * @interface ThriveInventoryAuthToken401Response
 */
export interface ThriveInventoryAuthToken401Response {
    /**
     * 
     * @type {number}
     * @memberof ThriveInventoryAuthToken401Response
     */
    'status_code': number;
    /**
     * 
     * @type {string}
     * @memberof ThriveInventoryAuthToken401Response
     */
    'detail': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ThriveInventoryAuthToken401Response
     */
    'extra'?: { [key: string]: any; };
}
/**
 * Validation Exception
 * @export
 * @interface UpdateInternalUser400Response
 */
export interface UpdateInternalUser400Response {
    /**
     * 
     * @type {number}
     * @memberof UpdateInternalUser400Response
     */
    'status_code': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateInternalUser400Response
     */
    'detail': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateInternalUser400Response
     */
    'extra'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface UpdateProgramProgramCredentialCreateRequestBody
 */
export interface UpdateProgramProgramCredentialCreateRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateProgramProgramCredentialCreateRequestBody
     */
    'type': UpdateProgramProgramCredentialCreateRequestBodyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateProgramProgramCredentialCreateRequestBody
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProgramProgramCredentialCreateRequestBody
     */
    'sftp_password': string;
}

export const UpdateProgramProgramCredentialCreateRequestBodyTypeEnum = {
    Altria: 'altria'
} as const;

export type UpdateProgramProgramCredentialCreateRequestBodyTypeEnum = typeof UpdateProgramProgramCredentialCreateRequestBodyTypeEnum[keyof typeof UpdateProgramProgramCredentialCreateRequestBodyTypeEnum];

/**
 * 
 * @export
 * @interface VariantsWithPrice
 */
export interface VariantsWithPrice {
    /**
     * 
     * @type {string}
     * @memberof VariantsWithPrice
     */
    'sku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VariantsWithPrice
     */
    'gtin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VariantsWithPrice
     */
    'gtin12'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VariantsWithPrice
     */
    'gtin8'?: string | null;
    /**
     * A list of properties that identify this variant. Must match those defined on the product. If defined on the product, it is required on the variant.
     * @type {Array<VariesBy>}
     * @memberof VariantsWithPrice
     */
    'varies_by'?: Array<VariesBy>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof VariantsWithPrice
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<SuggestedPrice>}
     * @memberof VariantsWithPrice
     */
    'suggested_prices'?: Array<SuggestedPrice> | null;
    /**
     * 
     * @type {number}
     * @memberof VariantsWithPrice
     */
    'ordinal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VariantsWithPrice
     */
    'id'?: string | null;
    /**
     * 
     * @type {Offer}
     * @memberof VariantsWithPrice
     */
    'price': Offer;
    /**
     * 
     * @type {string}
     * @memberof VariantsWithPrice
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface VariesBy
 */
export interface VariesBy {
    /**
     * The property this variant varies by. Matches the varies by identifiers on the Product. i.e. Size / Color
     * @type {string}
     * @memberof VariesBy
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VariesBy
     */
    'value': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof VariesBy
     */
    'metadata'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface Video
 */
export interface Video {
    /**
     * 
     * @type {string}
     * @memberof Video
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof Video
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Video
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof Video
     */
    'type': VideoTypeEnum;
}

export const VideoTypeEnum = {
    VideoMp4: 'video/mp4'
} as const;

export type VideoTypeEnum = typeof VideoTypeEnum[keyof typeof VideoTypeEnum];


/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update an internal user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getInternalUser', 'userId', userId)
            const localVarPath = `/admin/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all internal users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInternalUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an internal user
         * @param {string} userId 
         * @param {Array<UpdateInternalUserInternalRolesEnum>} [internalRoles] The list of admin roles to apply.
         * @param {Array<UpdateInternalUserPartnerRepRolesEnum>} [partnerRepRoles] The list of partner roles to apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInternalUser: async (userId: string, internalRoles?: Array<UpdateInternalUserInternalRolesEnum>, partnerRepRoles?: Array<UpdateInternalUserPartnerRepRolesEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateInternalUser', 'userId', userId)
            const localVarPath = `/admin/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (internalRoles) {
                localVarFormParams.set('internal_roles', internalRoles.join(COLLECTION_FORMATS.csv));
            }

                if (partnerRepRoles) {
                localVarFormParams.set('partner_rep_roles', partnerRepRoles.join(COLLECTION_FORMATS.csv));
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update an internal user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInternalUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FSUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInternalUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.getInternalUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all internal users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInternalUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FSUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInternalUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.listInternalUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an internal user
         * @param {string} userId 
         * @param {Array<UpdateInternalUserInternalRolesEnum>} [internalRoles] The list of admin roles to apply.
         * @param {Array<UpdateInternalUserPartnerRepRolesEnum>} [partnerRepRoles] The list of partner roles to apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInternalUser(userId: string, internalRoles?: Array<UpdateInternalUserInternalRolesEnum>, partnerRepRoles?: Array<UpdateInternalUserPartnerRepRolesEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInternalUser(userId, internalRoles, partnerRepRoles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.updateInternalUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Update an internal user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInternalUser(userId: string, options?: any): AxiosPromise<FSUser> {
            return localVarFp.getInternalUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all internal users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInternalUsers(options?: any): AxiosPromise<Array<FSUser>> {
            return localVarFp.listInternalUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an internal user
         * @param {string} userId 
         * @param {Array<UpdateInternalUserInternalRolesEnum>} [internalRoles] The list of admin roles to apply.
         * @param {Array<UpdateInternalUserPartnerRepRolesEnum>} [partnerRepRoles] The list of partner roles to apply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInternalUser(userId: string, internalRoles?: Array<UpdateInternalUserInternalRolesEnum>, partnerRepRoles?: Array<UpdateInternalUserPartnerRepRolesEnum>, options?: any): AxiosPromise<string> {
            return localVarFp.updateInternalUser(userId, internalRoles, partnerRepRoles, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * 
     * @summary Update an internal user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getInternalUser(userId: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).getInternalUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all internal users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public listInternalUsers(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).listInternalUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an internal user
     * @param {string} userId 
     * @param {Array<UpdateInternalUserInternalRolesEnum>} [internalRoles] The list of admin roles to apply.
     * @param {Array<UpdateInternalUserPartnerRepRolesEnum>} [partnerRepRoles] The list of partner roles to apply.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public updateInternalUser(userId: string, internalRoles?: Array<UpdateInternalUserInternalRolesEnum>, partnerRepRoles?: Array<UpdateInternalUserPartnerRepRolesEnum>, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).updateInternalUser(userId, internalRoles, partnerRepRoles, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UpdateInternalUserInternalRolesEnum = {
    SuperAdmin: 'Thrive Super Admin',
    Developer: 'Thrive Developer',
    CustomerCare: 'Thrive Customer Care'
} as const;
export type UpdateInternalUserInternalRolesEnum = typeof UpdateInternalUserInternalRolesEnum[keyof typeof UpdateInternalUserInternalRolesEnum];
/**
 * @export
 */
export const UpdateInternalUserPartnerRepRolesEnum = {
    CloverBusinessConsultant: 'Clover Business Consultant'
} as const;
export type UpdateInternalUserPartnerRepRolesEnum = typeof UpdateInternalUserPartnerRepRolesEnum[keyof typeof UpdateInternalUserPartnerRepRolesEnum];


/**
 * AgeVerificationApi - axios parameter creator
 * @export
 */
export const AgeVerificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete age verification rule by ID
         * @param {string} merchantId 
         * @param {string} ageVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule: async (merchantId: string, ageVerificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule', 'merchantId', merchantId)
            // verify required parameter 'ageVerificationId' is not null or undefined
            assertParamExists('catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule', 'ageVerificationId', ageVerificationId)
            const localVarPath = `/catalog-merchants/{merchant_id}/age-verification/{age_verification_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"age_verification_id"}}`, encodeURIComponent(String(ageVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an age verification rule for a specific merchant.
         * @summary Create an age verification rule
         * @param {string} merchantId 
         * @param {AgeVerificationBase} ageVerificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgeVerification: async (merchantId: string, ageVerificationBase: AgeVerificationBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createAgeVerification', 'merchantId', merchantId)
            // verify required parameter 'ageVerificationBase' is not null or undefined
            assertParamExists('createAgeVerification', 'ageVerificationBase', ageVerificationBase)
            const localVarPath = `/catalog-merchants/{merchant_id}/age-verification`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ageVerificationBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get age verification rule
         * @param {string} merchantId 
         * @param {string | null} ageVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgeVerification: async (merchantId: string, ageVerificationId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getAgeVerification', 'merchantId', merchantId)
            // verify required parameter 'ageVerificationId' is not null or undefined
            assertParamExists('getAgeVerification', 'ageVerificationId', ageVerificationId)
            const localVarPath = `/catalog-merchants/{merchant_id}/age-verification/{age_verification_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"age_verification_id"}}`, encodeURIComponent(String(ageVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List age verification rules for a merchant.
         * @param {string} merchantId 
         * @param {ListAgeVerificationOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgeVerification: async (merchantId: string, orderBy?: ListAgeVerificationOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listAgeVerification', 'merchantId', merchantId)
            const localVarPath = `/catalog-merchants/{merchant_id}/age-verification`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an age verification rule
         * @summary Update age verification rule
         * @param {string} merchantId 
         * @param {string} ageVerificationId 
         * @param {AgeVerificationBase} ageVerificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgeVerification: async (merchantId: string, ageVerificationId: string, ageVerificationBase: AgeVerificationBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateAgeVerification', 'merchantId', merchantId)
            // verify required parameter 'ageVerificationId' is not null or undefined
            assertParamExists('updateAgeVerification', 'ageVerificationId', ageVerificationId)
            // verify required parameter 'ageVerificationBase' is not null or undefined
            assertParamExists('updateAgeVerification', 'ageVerificationBase', ageVerificationBase)
            const localVarPath = `/catalog-merchants/{merchant_id}/age-verification/{age_verification_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"age_verification_id"}}`, encodeURIComponent(String(ageVerificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ageVerificationBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgeVerificationApi - functional programming interface
 * @export
 */
export const AgeVerificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgeVerificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete age verification rule by ID
         * @param {string} merchantId 
         * @param {string} ageVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule(merchantId: string, ageVerificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule(merchantId, ageVerificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgeVerificationApi.catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an age verification rule for a specific merchant.
         * @summary Create an age verification rule
         * @param {string} merchantId 
         * @param {AgeVerificationBase} ageVerificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgeVerification(merchantId: string, ageVerificationBase: AgeVerificationBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgeVerification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgeVerification(merchantId, ageVerificationBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgeVerificationApi.createAgeVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get age verification rule
         * @param {string} merchantId 
         * @param {string | null} ageVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgeVerification(merchantId: string, ageVerificationId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgeVerification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgeVerification(merchantId, ageVerificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgeVerificationApi.getAgeVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List age verification rules for a merchant.
         * @param {string} merchantId 
         * @param {ListAgeVerificationOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAgeVerification(merchantId: string, orderBy?: ListAgeVerificationOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAgeVerification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAgeVerification(merchantId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgeVerificationApi.listAgeVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an age verification rule
         * @summary Update age verification rule
         * @param {string} merchantId 
         * @param {string} ageVerificationId 
         * @param {AgeVerificationBase} ageVerificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgeVerification(merchantId: string, ageVerificationId: string, ageVerificationBase: AgeVerificationBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgeVerification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgeVerification(merchantId, ageVerificationId, ageVerificationBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgeVerificationApi.updateAgeVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgeVerificationApi - factory interface
 * @export
 */
export const AgeVerificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgeVerificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete age verification rule by ID
         * @param {string} merchantId 
         * @param {string} ageVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule(merchantId: string, ageVerificationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule(merchantId, ageVerificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an age verification rule for a specific merchant.
         * @summary Create an age verification rule
         * @param {string} merchantId 
         * @param {AgeVerificationBase} ageVerificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgeVerification(merchantId: string, ageVerificationBase: AgeVerificationBase, options?: any): AxiosPromise<AgeVerification> {
            return localVarFp.createAgeVerification(merchantId, ageVerificationBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get age verification rule
         * @param {string} merchantId 
         * @param {string | null} ageVerificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgeVerification(merchantId: string, ageVerificationId: string | null, options?: any): AxiosPromise<AgeVerification> {
            return localVarFp.getAgeVerification(merchantId, ageVerificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List age verification rules for a merchant.
         * @param {string} merchantId 
         * @param {ListAgeVerificationOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgeVerification(merchantId: string, orderBy?: ListAgeVerificationOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListAgeVerification200Response> {
            return localVarFp.listAgeVerification(merchantId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an age verification rule
         * @summary Update age verification rule
         * @param {string} merchantId 
         * @param {string} ageVerificationId 
         * @param {AgeVerificationBase} ageVerificationBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgeVerification(merchantId: string, ageVerificationId: string, ageVerificationBase: AgeVerificationBase, options?: any): AxiosPromise<AgeVerification> {
            return localVarFp.updateAgeVerification(merchantId, ageVerificationId, ageVerificationBase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgeVerificationApi - object-oriented interface
 * @export
 * @class AgeVerificationApi
 * @extends {BaseAPI}
 */
export class AgeVerificationApi extends BaseAPI {
    /**
     * 
     * @summary Delete age verification rule by ID
     * @param {string} merchantId 
     * @param {string} ageVerificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgeVerificationApi
     */
    public catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule(merchantId: string, ageVerificationId: string, options?: RawAxiosRequestConfig) {
        return AgeVerificationApiFp(this.configuration).catalogMerchantsMerchantIdAgeVerificationAgeVerificationIdDeleteAgeVerificationRule(merchantId, ageVerificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an age verification rule for a specific merchant.
     * @summary Create an age verification rule
     * @param {string} merchantId 
     * @param {AgeVerificationBase} ageVerificationBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgeVerificationApi
     */
    public createAgeVerification(merchantId: string, ageVerificationBase: AgeVerificationBase, options?: RawAxiosRequestConfig) {
        return AgeVerificationApiFp(this.configuration).createAgeVerification(merchantId, ageVerificationBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get age verification rule
     * @param {string} merchantId 
     * @param {string | null} ageVerificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgeVerificationApi
     */
    public getAgeVerification(merchantId: string, ageVerificationId: string | null, options?: RawAxiosRequestConfig) {
        return AgeVerificationApiFp(this.configuration).getAgeVerification(merchantId, ageVerificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List age verification rules for a merchant.
     * @param {string} merchantId 
     * @param {ListAgeVerificationOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgeVerificationApi
     */
    public listAgeVerification(merchantId: string, orderBy?: ListAgeVerificationOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return AgeVerificationApiFp(this.configuration).listAgeVerification(merchantId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an age verification rule
     * @summary Update age verification rule
     * @param {string} merchantId 
     * @param {string} ageVerificationId 
     * @param {AgeVerificationBase} ageVerificationBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgeVerificationApi
     */
    public updateAgeVerification(merchantId: string, ageVerificationId: string, ageVerificationBase: AgeVerificationBase, options?: RawAxiosRequestConfig) {
        return AgeVerificationApiFp(this.configuration).updateAgeVerification(merchantId, ageVerificationId, ageVerificationBase, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListAgeVerificationOrderByEnum = {
    CreatedAt: 'created_at'
} as const;
export type ListAgeVerificationOrderByEnum = typeof ListAgeVerificationOrderByEnum[keyof typeof ListAgeVerificationOrderByEnum];


/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allows a Clover app to post a Clover access token along with required headers. An API token is returned to use against these APIs if the Clover token is valid. 
         * @summary Clover token authentication
         * @param {string | null} xCloverAppId 
         * @param {string | null} xCloverMerchantId 
         * @param {string | null} xCloverDeviceId 
         * @param {CloverToken} cloverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloverAuthToken: async (xCloverAppId: string | null, xCloverMerchantId: string | null, xCloverDeviceId: string | null, cloverToken: CloverToken, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCloverAppId' is not null or undefined
            assertParamExists('cloverAuthToken', 'xCloverAppId', xCloverAppId)
            // verify required parameter 'xCloverMerchantId' is not null or undefined
            assertParamExists('cloverAuthToken', 'xCloverMerchantId', xCloverMerchantId)
            // verify required parameter 'xCloverDeviceId' is not null or undefined
            assertParamExists('cloverAuthToken', 'xCloverDeviceId', xCloverDeviceId)
            // verify required parameter 'cloverToken' is not null or undefined
            assertParamExists('cloverAuthToken', 'cloverToken', cloverToken)
            const localVarPath = `/auth/clover-device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCloverAppId != null) {
                localVarHeaderParameter['X-Clover-App-Id'] = String(xCloverAppId);
            }

            if (xCloverMerchantId != null) {
                localVarHeaderParameter['X-Clover-Merchant-Id'] = String(xCloverMerchantId);
            }

            if (xCloverDeviceId != null) {
                localVarHeaderParameter['X-Clover-Device-Id'] = String(xCloverDeviceId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloverToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows Thrive inventory to request an auth token for the user
         * @summary Thrive inventory authentication
         * @param {string | null} xThriveSharedKey 
         * @param {ThriveAccount} thriveAccount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thriveInventoryAuthToken: async (xThriveSharedKey: string | null, thriveAccount: ThriveAccount, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xThriveSharedKey' is not null or undefined
            assertParamExists('thriveInventoryAuthToken', 'xThriveSharedKey', xThriveSharedKey)
            // verify required parameter 'thriveAccount' is not null or undefined
            assertParamExists('thriveInventoryAuthToken', 'thriveAccount', thriveAccount)
            const localVarPath = `/auth/thrive-inventory-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xThriveSharedKey != null) {
                localVarHeaderParameter['X-Thrive-Shared-Key'] = String(xThriveSharedKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(thriveAccount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Allows a Clover app to post a Clover access token along with required headers. An API token is returned to use against these APIs if the Clover token is valid. 
         * @summary Clover token authentication
         * @param {string | null} xCloverAppId 
         * @param {string | null} xCloverMerchantId 
         * @param {string | null} xCloverDeviceId 
         * @param {CloverToken} cloverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloverAuthToken(xCloverAppId: string | null, xCloverMerchantId: string | null, xCloverDeviceId: string | null, cloverToken: CloverToken, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloverAuthToken(xCloverAppId, xCloverMerchantId, xCloverDeviceId, cloverToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.cloverAuthToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows Thrive inventory to request an auth token for the user
         * @summary Thrive inventory authentication
         * @param {string | null} xThriveSharedKey 
         * @param {ThriveAccount} thriveAccount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thriveInventoryAuthToken(xThriveSharedKey: string | null, thriveAccount: ThriveAccount, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thriveInventoryAuthToken(xThriveSharedKey, thriveAccount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.thriveInventoryAuthToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Allows a Clover app to post a Clover access token along with required headers. An API token is returned to use against these APIs if the Clover token is valid. 
         * @summary Clover token authentication
         * @param {string | null} xCloverAppId 
         * @param {string | null} xCloverMerchantId 
         * @param {string | null} xCloverDeviceId 
         * @param {CloverToken} cloverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloverAuthToken(xCloverAppId: string | null, xCloverMerchantId: string | null, xCloverDeviceId: string | null, cloverToken: CloverToken, options?: any): AxiosPromise<any> {
            return localVarFp.cloverAuthToken(xCloverAppId, xCloverMerchantId, xCloverDeviceId, cloverToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows Thrive inventory to request an auth token for the user
         * @summary Thrive inventory authentication
         * @param {string | null} xThriveSharedKey 
         * @param {ThriveAccount} thriveAccount 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thriveInventoryAuthToken(xThriveSharedKey: string | null, thriveAccount: ThriveAccount, options?: any): AxiosPromise<any> {
            return localVarFp.thriveInventoryAuthToken(xThriveSharedKey, thriveAccount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Allows a Clover app to post a Clover access token along with required headers. An API token is returned to use against these APIs if the Clover token is valid. 
     * @summary Clover token authentication
     * @param {string | null} xCloverAppId 
     * @param {string | null} xCloverMerchantId 
     * @param {string | null} xCloverDeviceId 
     * @param {CloverToken} cloverToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public cloverAuthToken(xCloverAppId: string | null, xCloverMerchantId: string | null, xCloverDeviceId: string | null, cloverToken: CloverToken, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).cloverAuthToken(xCloverAppId, xCloverMerchantId, xCloverDeviceId, cloverToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows Thrive inventory to request an auth token for the user
     * @summary Thrive inventory authentication
     * @param {string | null} xThriveSharedKey 
     * @param {ThriveAccount} thriveAccount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public thriveInventoryAuthToken(xThriveSharedKey: string | null, thriveAccount: ThriveAccount, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).thriveInventoryAuthToken(xThriveSharedKey, thriveAccount, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BrandApi - axios parameter creator
 * @export
 */
export const BrandApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a brand that belongs to an organization identified by organization ID
         * @summary Create a brand
         * @param {string} orgId 
         * @param {BrandPayload} brandPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: async (orgId: string, brandPayload: BrandPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createBrand', 'orgId', orgId)
            // verify required parameter 'brandPayload' is not null or undefined
            assertParamExists('createBrand', 'brandPayload', brandPayload)
            const localVarPath = `/organizations/{org_id}/brands`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get brand by id that belongs to an organization.
         * @summary Get brand by ID
         * @param {string} orgId 
         * @param {string | null} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand: async (orgId: string, brandId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getBrand', 'orgId', orgId)
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrand', 'brandId', brandId)
            const localVarPath = `/organizations/{org_id}/brands/{brand_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"brand_id"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all brands belonging to an organization
         * @summary List brands
         * @param {string} orgId 
         * @param {ListBrandsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBrands: async (orgId: string, orderBy?: ListBrandsOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('listBrands', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/brands`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially updates one brand by ID
         * @summary Partial update brand
         * @param {string} orgId 
         * @param {string} brandId 
         * @param {PartialUpdateBrandByIdBrandPayloadRequestBody} partialUpdateBrandByIdBrandPayloadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBrand: async (orgId: string, brandId: string, partialUpdateBrandByIdBrandPayloadRequestBody: PartialUpdateBrandByIdBrandPayloadRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('patchBrand', 'orgId', orgId)
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('patchBrand', 'brandId', brandId)
            // verify required parameter 'partialUpdateBrandByIdBrandPayloadRequestBody' is not null or undefined
            assertParamExists('patchBrand', 'partialUpdateBrandByIdBrandPayloadRequestBody', partialUpdateBrandByIdBrandPayloadRequestBody)
            const localVarPath = `/organizations/{org_id}/brands/{brand_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"brand_id"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateBrandByIdBrandPayloadRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates one brand by ID
         * @summary Update brand
         * @param {string} orgId 
         * @param {string} brandId 
         * @param {BrandPayload} brandPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand: async (orgId: string, brandId: string, brandPayload: BrandPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateBrand', 'orgId', orgId)
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateBrand', 'brandId', brandId)
            // verify required parameter 'brandPayload' is not null or undefined
            assertParamExists('updateBrand', 'brandPayload', brandPayload)
            const localVarPath = `/organizations/{org_id}/brands/{brand_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"brand_id"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandApi - functional programming interface
 * @export
 */
export const BrandApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a brand that belongs to an organization identified by organization ID
         * @summary Create a brand
         * @param {string} orgId 
         * @param {BrandPayload} brandPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBrand(orgId: string, brandPayload: BrandPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Brand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBrand(orgId, brandPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.createBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get brand by id that belongs to an organization.
         * @summary Get brand by ID
         * @param {string} orgId 
         * @param {string | null} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrand(orgId: string, brandId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Brand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrand(orgId, brandId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.getBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all brands belonging to an organization
         * @summary List brands
         * @param {string} orgId 
         * @param {ListBrandsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBrands(orgId: string, orderBy?: ListBrandsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListBrands200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBrands(orgId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.listBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Partially updates one brand by ID
         * @summary Partial update brand
         * @param {string} orgId 
         * @param {string} brandId 
         * @param {PartialUpdateBrandByIdBrandPayloadRequestBody} partialUpdateBrandByIdBrandPayloadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchBrand(orgId: string, brandId: string, partialUpdateBrandByIdBrandPayloadRequestBody: PartialUpdateBrandByIdBrandPayloadRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Brand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchBrand(orgId, brandId, partialUpdateBrandByIdBrandPayloadRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.patchBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates one brand by ID
         * @summary Update brand
         * @param {string} orgId 
         * @param {string} brandId 
         * @param {BrandPayload} brandPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBrand(orgId: string, brandId: string, brandPayload: BrandPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Brand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBrand(orgId, brandId, brandPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandApi.updateBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BrandApi - factory interface
 * @export
 */
export const BrandApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandApiFp(configuration)
    return {
        /**
         * Create a brand that belongs to an organization identified by organization ID
         * @summary Create a brand
         * @param {string} orgId 
         * @param {BrandPayload} brandPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand(orgId: string, brandPayload: BrandPayload, options?: any): AxiosPromise<Brand> {
            return localVarFp.createBrand(orgId, brandPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Get brand by id that belongs to an organization.
         * @summary Get brand by ID
         * @param {string} orgId 
         * @param {string | null} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand(orgId: string, brandId: string | null, options?: any): AxiosPromise<Brand> {
            return localVarFp.getBrand(orgId, brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all brands belonging to an organization
         * @summary List brands
         * @param {string} orgId 
         * @param {ListBrandsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBrands(orgId: string, orderBy?: ListBrandsOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListBrands200Response> {
            return localVarFp.listBrands(orgId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Partially updates one brand by ID
         * @summary Partial update brand
         * @param {string} orgId 
         * @param {string} brandId 
         * @param {PartialUpdateBrandByIdBrandPayloadRequestBody} partialUpdateBrandByIdBrandPayloadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBrand(orgId: string, brandId: string, partialUpdateBrandByIdBrandPayloadRequestBody: PartialUpdateBrandByIdBrandPayloadRequestBody, options?: any): AxiosPromise<Brand> {
            return localVarFp.patchBrand(orgId, brandId, partialUpdateBrandByIdBrandPayloadRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates one brand by ID
         * @summary Update brand
         * @param {string} orgId 
         * @param {string} brandId 
         * @param {BrandPayload} brandPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand(orgId: string, brandId: string, brandPayload: BrandPayload, options?: any): AxiosPromise<Brand> {
            return localVarFp.updateBrand(orgId, brandId, brandPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandApi - object-oriented interface
 * @export
 * @class BrandApi
 * @extends {BaseAPI}
 */
export class BrandApi extends BaseAPI {
    /**
     * Create a brand that belongs to an organization identified by organization ID
     * @summary Create a brand
     * @param {string} orgId 
     * @param {BrandPayload} brandPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public createBrand(orgId: string, brandPayload: BrandPayload, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).createBrand(orgId, brandPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get brand by id that belongs to an organization.
     * @summary Get brand by ID
     * @param {string} orgId 
     * @param {string | null} brandId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public getBrand(orgId: string, brandId: string | null, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).getBrand(orgId, brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all brands belonging to an organization
     * @summary List brands
     * @param {string} orgId 
     * @param {ListBrandsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public listBrands(orgId: string, orderBy?: ListBrandsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).listBrands(orgId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Partially updates one brand by ID
     * @summary Partial update brand
     * @param {string} orgId 
     * @param {string} brandId 
     * @param {PartialUpdateBrandByIdBrandPayloadRequestBody} partialUpdateBrandByIdBrandPayloadRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public patchBrand(orgId: string, brandId: string, partialUpdateBrandByIdBrandPayloadRequestBody: PartialUpdateBrandByIdBrandPayloadRequestBody, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).patchBrand(orgId, brandId, partialUpdateBrandByIdBrandPayloadRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates one brand by ID
     * @summary Update brand
     * @param {string} orgId 
     * @param {string} brandId 
     * @param {BrandPayload} brandPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandApi
     */
    public updateBrand(orgId: string, brandId: string, brandPayload: BrandPayload, options?: RawAxiosRequestConfig) {
        return BrandApiFp(this.configuration).updateBrand(orgId, brandId, brandPayload, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListBrandsOrderByEnum = {
    Name: 'name',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at'
} as const;
export type ListBrandsOrderByEnum = typeof ListBrandsOrderByEnum[keyof typeof ListBrandsOrderByEnum];


/**
 * CatalogMerchantApi - axios parameter creator
 * @export
 */
export const CatalogMerchantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a merchant identified by external ID and provider. Only reps with the right role can access this API.
         * @summary Create a catalog merchant
         * @param {Merchant} merchant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsCreateMerchant: async (merchant: Merchant, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchant' is not null or undefined
            assertParamExists('catalogMerchantsCreateMerchant', 'merchant', merchant)
            const localVarPath = `/catalog-merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchant, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists catalog merchants added by current user. Only reps with the right role can access this API.
         * @summary List catalog merchants
         * @param {CatalogMerchantsListMerchantsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsListMerchants: async (orderBy?: CatalogMerchantsListMerchantsOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/catalog-merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets one catalog merchant by ID. Only reps with the right role can access this API. Only merchants created by the current user can be retrieved.
         * @summary Get catalog merchant by id
         * @param {string | null} merchantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsMerchantIdGetMerchant: async (merchantId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('catalogMerchantsMerchantIdGetMerchant', 'merchantId', merchantId)
            const localVarPath = `/catalog-merchants/{merchant_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A mapping with the product\'s Clover IDs for a specified merchant.
         * @summary Product ids for merchant id
         * @param {string} merchantId 
         * @param {boolean | null} [reverse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsMerchantIdMerchantProductIdsGetMerchant: async (merchantId: string, reverse?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('catalogMerchantsMerchantIdMerchantProductIdsGetMerchant', 'merchantId', merchantId)
            const localVarPath = `/catalog-merchants/{merchant_id}/merchant-product-ids`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reverse !== undefined) {
                localVarQueryParameter['reverse'] = reverse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogMerchantApi - functional programming interface
 * @export
 */
export const CatalogMerchantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogMerchantApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a merchant identified by external ID and provider. Only reps with the right role can access this API.
         * @summary Create a catalog merchant
         * @param {Merchant} merchant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async catalogMerchantsCreateMerchant(merchant: Merchant, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Merchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.catalogMerchantsCreateMerchant(merchant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogMerchantApi.catalogMerchantsCreateMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists catalog merchants added by current user. Only reps with the right role can access this API.
         * @summary List catalog merchants
         * @param {CatalogMerchantsListMerchantsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async catalogMerchantsListMerchants(orderBy?: CatalogMerchantsListMerchantsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogMerchantsListMerchants200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.catalogMerchantsListMerchants(orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogMerchantApi.catalogMerchantsListMerchants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets one catalog merchant by ID. Only reps with the right role can access this API. Only merchants created by the current user can be retrieved.
         * @summary Get catalog merchant by id
         * @param {string | null} merchantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async catalogMerchantsMerchantIdGetMerchant(merchantId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Merchant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.catalogMerchantsMerchantIdGetMerchant(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogMerchantApi.catalogMerchantsMerchantIdGetMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A mapping with the product\'s Clover IDs for a specified merchant.
         * @summary Product ids for merchant id
         * @param {string} merchantId 
         * @param {boolean | null} [reverse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async catalogMerchantsMerchantIdMerchantProductIdsGetMerchant(merchantId: string, reverse?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.catalogMerchantsMerchantIdMerchantProductIdsGetMerchant(merchantId, reverse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogMerchantApi.catalogMerchantsMerchantIdMerchantProductIdsGetMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatalogMerchantApi - factory interface
 * @export
 */
export const CatalogMerchantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogMerchantApiFp(configuration)
    return {
        /**
         * Create a merchant identified by external ID and provider. Only reps with the right role can access this API.
         * @summary Create a catalog merchant
         * @param {Merchant} merchant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsCreateMerchant(merchant: Merchant, options?: any): AxiosPromise<Merchant> {
            return localVarFp.catalogMerchantsCreateMerchant(merchant, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists catalog merchants added by current user. Only reps with the right role can access this API.
         * @summary List catalog merchants
         * @param {CatalogMerchantsListMerchantsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsListMerchants(orderBy?: CatalogMerchantsListMerchantsOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<CatalogMerchantsListMerchants200Response> {
            return localVarFp.catalogMerchantsListMerchants(orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets one catalog merchant by ID. Only reps with the right role can access this API. Only merchants created by the current user can be retrieved.
         * @summary Get catalog merchant by id
         * @param {string | null} merchantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsMerchantIdGetMerchant(merchantId: string | null, options?: any): AxiosPromise<Merchant> {
            return localVarFp.catalogMerchantsMerchantIdGetMerchant(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * A mapping with the product\'s Clover IDs for a specified merchant.
         * @summary Product ids for merchant id
         * @param {string} merchantId 
         * @param {boolean | null} [reverse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsMerchantIdMerchantProductIdsGetMerchant(merchantId: string, reverse?: boolean | null, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.catalogMerchantsMerchantIdMerchantProductIdsGetMerchant(merchantId, reverse, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogMerchantApi - object-oriented interface
 * @export
 * @class CatalogMerchantApi
 * @extends {BaseAPI}
 */
export class CatalogMerchantApi extends BaseAPI {
    /**
     * Create a merchant identified by external ID and provider. Only reps with the right role can access this API.
     * @summary Create a catalog merchant
     * @param {Merchant} merchant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogMerchantApi
     */
    public catalogMerchantsCreateMerchant(merchant: Merchant, options?: RawAxiosRequestConfig) {
        return CatalogMerchantApiFp(this.configuration).catalogMerchantsCreateMerchant(merchant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists catalog merchants added by current user. Only reps with the right role can access this API.
     * @summary List catalog merchants
     * @param {CatalogMerchantsListMerchantsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogMerchantApi
     */
    public catalogMerchantsListMerchants(orderBy?: CatalogMerchantsListMerchantsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return CatalogMerchantApiFp(this.configuration).catalogMerchantsListMerchants(orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets one catalog merchant by ID. Only reps with the right role can access this API. Only merchants created by the current user can be retrieved.
     * @summary Get catalog merchant by id
     * @param {string | null} merchantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogMerchantApi
     */
    public catalogMerchantsMerchantIdGetMerchant(merchantId: string | null, options?: RawAxiosRequestConfig) {
        return CatalogMerchantApiFp(this.configuration).catalogMerchantsMerchantIdGetMerchant(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A mapping with the product\'s Clover IDs for a specified merchant.
     * @summary Product ids for merchant id
     * @param {string} merchantId 
     * @param {boolean | null} [reverse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogMerchantApi
     */
    public catalogMerchantsMerchantIdMerchantProductIdsGetMerchant(merchantId: string, reverse?: boolean | null, options?: RawAxiosRequestConfig) {
        return CatalogMerchantApiFp(this.configuration).catalogMerchantsMerchantIdMerchantProductIdsGetMerchant(merchantId, reverse, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CatalogMerchantsListMerchantsOrderByEnum = {
    Name: 'name',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at'
} as const;
export type CatalogMerchantsListMerchantsOrderByEnum = typeof CatalogMerchantsListMerchantsOrderByEnum[keyof typeof CatalogMerchantsListMerchantsOrderByEnum];


/**
 * CoreApi - axios parameter creator
 * @export
 */
export const CoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Run Command
         * @param {TaskRequestData} taskRequestData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreCommandRunCommand: async (taskRequestData: TaskRequestData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskRequestData' is not null or undefined
            assertParamExists('coreCommandRunCommand', 'taskRequestData', taskRequestData)
            const localVarPath = `/core/command`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run task
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreRunTaskRunTask: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('coreRunTaskRunTask', 'body', body)
            const localVarPath = `/core/run-task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CoreApi - functional programming interface
 * @export
 */
export const CoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CoreApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Run Command
         * @param {TaskRequestData} taskRequestData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coreCommandRunCommand(taskRequestData: TaskRequestData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coreCommandRunCommand(taskRequestData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreApi.coreCommandRunCommand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Run task
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coreRunTaskRunTask(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coreRunTaskRunTask(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreApi.coreRunTaskRunTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CoreApi - factory interface
 * @export
 */
export const CoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CoreApiFp(configuration)
    return {
        /**
         * 
         * @summary Run Command
         * @param {TaskRequestData} taskRequestData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreCommandRunCommand(taskRequestData: TaskRequestData, options?: any): AxiosPromise<void> {
            return localVarFp.coreCommandRunCommand(taskRequestData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run task
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coreRunTaskRunTask(body: any, options?: any): AxiosPromise<void> {
            return localVarFp.coreRunTaskRunTask(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CoreApi - object-oriented interface
 * @export
 * @class CoreApi
 * @extends {BaseAPI}
 */
export class CoreApi extends BaseAPI {
    /**
     * 
     * @summary Run Command
     * @param {TaskRequestData} taskRequestData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    public coreCommandRunCommand(taskRequestData: TaskRequestData, options?: RawAxiosRequestConfig) {
        return CoreApiFp(this.configuration).coreCommandRunCommand(taskRequestData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run task
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    public coreRunTaskRunTask(body: any, options?: RawAxiosRequestConfig) {
        return CoreApiFp(this.configuration).coreRunTaskRunTask(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiscountsApi - axios parameter creator
 * @export
 */
export const DiscountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a discount by ID
         * @param {string} merchantId 
         * @param {string} discountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount: async (merchantId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount', 'merchantId', merchantId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount', 'discountId', discountId)
            const localVarPath = `/catalog-merchants/{merchant_id}/discounts/{discount_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"discount_id"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a discount for a specific merchant.
         * @summary Create a discount
         * @param {string} merchantId 
         * @param {DiscountBase} discountBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscount: async (merchantId: string, discountBase: DiscountBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createDiscount', 'merchantId', merchantId)
            // verify required parameter 'discountBase' is not null or undefined
            assertParamExists('createDiscount', 'discountBase', discountBase)
            const localVarPath = `/catalog-merchants/{merchant_id}/discounts`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discountBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get discount
         * @param {string} merchantId 
         * @param {string | null} discountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscount: async (merchantId: string, discountId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getDiscount', 'merchantId', merchantId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('getDiscount', 'discountId', discountId)
            const localVarPath = `/catalog-merchants/{merchant_id}/discounts/{discount_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"discount_id"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List discounts for a merchant.
         * @param {string} merchantId 
         * @param {ListDiscountsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiscounts: async (merchantId: string, orderBy?: ListDiscountsOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listDiscounts', 'merchantId', merchantId)
            const localVarPath = `/catalog-merchants/{merchant_id}/discounts`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a discount
         * @summary Update discount
         * @param {string} merchantId 
         * @param {string} discountId 
         * @param {DiscountBase} discountBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiscounts: async (merchantId: string, discountId: string, discountBase: DiscountBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateDiscounts', 'merchantId', merchantId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('updateDiscounts', 'discountId', discountId)
            // verify required parameter 'discountBase' is not null or undefined
            assertParamExists('updateDiscounts', 'discountBase', discountBase)
            const localVarPath = `/catalog-merchants/{merchant_id}/discounts/{discount_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"discount_id"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discountBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscountsApi - functional programming interface
 * @export
 */
export const DiscountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a discount by ID
         * @param {string} merchantId 
         * @param {string} discountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount(merchantId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount(merchantId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a discount for a specific merchant.
         * @summary Create a discount
         * @param {string} merchantId 
         * @param {DiscountBase} discountBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDiscount(merchantId: string, discountBase: DiscountBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDiscount(merchantId, discountBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.createDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get discount
         * @param {string} merchantId 
         * @param {string | null} discountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscount(merchantId: string, discountId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscount(merchantId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.getDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List discounts for a merchant.
         * @param {string} merchantId 
         * @param {ListDiscountsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDiscounts(merchantId: string, orderBy?: ListDiscountsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiscounts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDiscounts(merchantId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.listDiscounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a discount
         * @summary Update discount
         * @param {string} merchantId 
         * @param {string} discountId 
         * @param {DiscountBase} discountBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDiscounts(merchantId: string, discountId: string, discountBase: DiscountBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDiscounts(merchantId, discountId, discountBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountsApi.updateDiscounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiscountsApi - factory interface
 * @export
 */
export const DiscountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscountsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a discount by ID
         * @param {string} merchantId 
         * @param {string} discountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount(merchantId: string, discountId: string, options?: any): AxiosPromise<void> {
            return localVarFp.catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount(merchantId, discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a discount for a specific merchant.
         * @summary Create a discount
         * @param {string} merchantId 
         * @param {DiscountBase} discountBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscount(merchantId: string, discountBase: DiscountBase, options?: any): AxiosPromise<Discount> {
            return localVarFp.createDiscount(merchantId, discountBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get discount
         * @param {string} merchantId 
         * @param {string | null} discountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscount(merchantId: string, discountId: string | null, options?: any): AxiosPromise<Discount> {
            return localVarFp.getDiscount(merchantId, discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List discounts for a merchant.
         * @param {string} merchantId 
         * @param {ListDiscountsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDiscounts(merchantId: string, orderBy?: ListDiscountsOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListDiscounts200Response> {
            return localVarFp.listDiscounts(merchantId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a discount
         * @summary Update discount
         * @param {string} merchantId 
         * @param {string} discountId 
         * @param {DiscountBase} discountBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiscounts(merchantId: string, discountId: string, discountBase: DiscountBase, options?: any): AxiosPromise<Discount> {
            return localVarFp.updateDiscounts(merchantId, discountId, discountBase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiscountsApi - object-oriented interface
 * @export
 * @class DiscountsApi
 * @extends {BaseAPI}
 */
export class DiscountsApi extends BaseAPI {
    /**
     * 
     * @summary Delete a discount by ID
     * @param {string} merchantId 
     * @param {string} discountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount(merchantId: string, discountId: string, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).catalogMerchantsMerchantIdDiscountsDiscountIdDeleteDiscount(merchantId, discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a discount for a specific merchant.
     * @summary Create a discount
     * @param {string} merchantId 
     * @param {DiscountBase} discountBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public createDiscount(merchantId: string, discountBase: DiscountBase, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).createDiscount(merchantId, discountBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get discount
     * @param {string} merchantId 
     * @param {string | null} discountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public getDiscount(merchantId: string, discountId: string | null, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).getDiscount(merchantId, discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List discounts for a merchant.
     * @param {string} merchantId 
     * @param {ListDiscountsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public listDiscounts(merchantId: string, orderBy?: ListDiscountsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).listDiscounts(merchantId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a discount
     * @summary Update discount
     * @param {string} merchantId 
     * @param {string} discountId 
     * @param {DiscountBase} discountBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountsApi
     */
    public updateDiscounts(merchantId: string, discountId: string, discountBase: DiscountBase, options?: RawAxiosRequestConfig) {
        return DiscountsApiFp(this.configuration).updateDiscounts(merchantId, discountId, discountBase, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListDiscountsOrderByEnum = {
    Name: 'name',
    UpdatedAt: 'updated_at',
    CreatedAt: 'created_at'
} as const;
export type ListDiscountsOrderByEnum = typeof ListDiscountsOrderByEnum[keyof typeof ListDiscountsOrderByEnum];


/**
 * MerchantCatalogProductsApi - axios parameter creator
 * @export
 */
export const MerchantCatalogProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Bulk add products to a merchant catalog
         * @summary Bulk add products to catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {Array<CatalogProductAssociation>} catalogProductAssociation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAddProductsMerchantCatalog: async (merchantId: string, catalogId: string, catalogProductAssociation: Array<CatalogProductAssociation>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('bulkAddProductsMerchantCatalog', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('bulkAddProductsMerchantCatalog', 'catalogId', catalogId)
            // verify required parameter 'catalogProductAssociation' is not null or undefined
            assertParamExists('bulkAddProductsMerchantCatalog', 'catalogProductAssociation', catalogProductAssociation)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}/products`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogProductAssociation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Copy catalog from a different merchant
         * @summary Copy catalog from a different merchant
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {CatalogCopy} catalogCopy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyMerchantCatalog: async (merchantId: string, catalogId: string, catalogCopy: CatalogCopy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('copyMerchantCatalog', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('copyMerchantCatalog', 'catalogId', catalogId)
            // verify required parameter 'catalogCopy' is not null or undefined
            assertParamExists('copyMerchantCatalog', 'catalogCopy', catalogCopy)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}/copy-catalog`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogCopy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists the products associated with a particular merchant catalog
         * @summary List merchant catalog products
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {ListMerchantCatalogProductsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantCatalogProducts: async (merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogProductsOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listMerchantCatalogProducts', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('listMerchantCatalogProducts', 'catalogId', catalogId)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}/products`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists the products to be verified associated with a particular merchant catalog
         * @summary List merchant catalog products to be verified
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {ListMerchantCatalogProductsToVerifyOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantCatalogProductsToVerify: async (merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogProductsToVerifyOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listMerchantCatalogProductsToVerify', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('listMerchantCatalogProductsToVerify', 'catalogId', catalogId)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}/products-to-verify`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk queue products to be added to a merchant catalog, verifying processing in an asynchronous way.
         * @summary Queue products to catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {Array<AsyncCatalogAssociation>} asyncCatalogAssociation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueProductsToCatalog: async (merchantId: string, catalogId: string, asyncCatalogAssociation: Array<AsyncCatalogAssociation>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('queueProductsToCatalog', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('queueProductsToCatalog', 'catalogId', catalogId)
            // verify required parameter 'asyncCatalogAssociation' is not null or undefined
            assertParamExists('queueProductsToCatalog', 'asyncCatalogAssociation', asyncCatalogAssociation)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}/async-queue-products`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asyncCatalogAssociation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantCatalogProductsApi - functional programming interface
 * @export
 */
export const MerchantCatalogProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantCatalogProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * Bulk add products to a merchant catalog
         * @summary Bulk add products to catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {Array<CatalogProductAssociation>} catalogProductAssociation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkAddProductsMerchantCatalog(merchantId: string, catalogId: string, catalogProductAssociation: Array<CatalogProductAssociation>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogProductAssociation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkAddProductsMerchantCatalog(merchantId, catalogId, catalogProductAssociation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogProductsApi.bulkAddProductsMerchantCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Copy catalog from a different merchant
         * @summary Copy catalog from a different merchant
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {CatalogCopy} catalogCopy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyMerchantCatalog(merchantId: string, catalogId: string, catalogCopy: CatalogCopy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogProductAssociation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyMerchantCatalog(merchantId, catalogId, catalogCopy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogProductsApi.copyMerchantCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists the products associated with a particular merchant catalog
         * @summary List merchant catalog products
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {ListMerchantCatalogProductsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMerchantCatalogProducts(merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogProductsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMerchantCatalogProducts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMerchantCatalogProducts(merchantId, catalogId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogProductsApi.listMerchantCatalogProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists the products to be verified associated with a particular merchant catalog
         * @summary List merchant catalog products to be verified
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {ListMerchantCatalogProductsToVerifyOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMerchantCatalogProductsToVerify(merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogProductsToVerifyOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMerchantCatalogProductsToVerify200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMerchantCatalogProductsToVerify(merchantId, catalogId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogProductsApi.listMerchantCatalogProductsToVerify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk queue products to be added to a merchant catalog, verifying processing in an asynchronous way.
         * @summary Queue products to catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {Array<AsyncCatalogAssociation>} asyncCatalogAssociation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queueProductsToCatalog(merchantId: string, catalogId: string, asyncCatalogAssociation: Array<AsyncCatalogAssociation>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AsyncCatalogUploadTracking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queueProductsToCatalog(merchantId, catalogId, asyncCatalogAssociation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogProductsApi.queueProductsToCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MerchantCatalogProductsApi - factory interface
 * @export
 */
export const MerchantCatalogProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantCatalogProductsApiFp(configuration)
    return {
        /**
         * Bulk add products to a merchant catalog
         * @summary Bulk add products to catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {Array<CatalogProductAssociation>} catalogProductAssociation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAddProductsMerchantCatalog(merchantId: string, catalogId: string, catalogProductAssociation: Array<CatalogProductAssociation>, options?: any): AxiosPromise<Array<CatalogProductAssociation>> {
            return localVarFp.bulkAddProductsMerchantCatalog(merchantId, catalogId, catalogProductAssociation, options).then((request) => request(axios, basePath));
        },
        /**
         * Copy catalog from a different merchant
         * @summary Copy catalog from a different merchant
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {CatalogCopy} catalogCopy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyMerchantCatalog(merchantId: string, catalogId: string, catalogCopy: CatalogCopy, options?: any): AxiosPromise<Array<CatalogProductAssociation>> {
            return localVarFp.copyMerchantCatalog(merchantId, catalogId, catalogCopy, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the products associated with a particular merchant catalog
         * @summary List merchant catalog products
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {ListMerchantCatalogProductsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantCatalogProducts(merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogProductsOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListMerchantCatalogProducts200Response> {
            return localVarFp.listMerchantCatalogProducts(merchantId, catalogId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the products to be verified associated with a particular merchant catalog
         * @summary List merchant catalog products to be verified
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {ListMerchantCatalogProductsToVerifyOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantCatalogProductsToVerify(merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogProductsToVerifyOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListMerchantCatalogProductsToVerify200Response> {
            return localVarFp.listMerchantCatalogProductsToVerify(merchantId, catalogId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk queue products to be added to a merchant catalog, verifying processing in an asynchronous way.
         * @summary Queue products to catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {Array<AsyncCatalogAssociation>} asyncCatalogAssociation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueProductsToCatalog(merchantId: string, catalogId: string, asyncCatalogAssociation: Array<AsyncCatalogAssociation>, options?: any): AxiosPromise<AsyncCatalogUploadTracking> {
            return localVarFp.queueProductsToCatalog(merchantId, catalogId, asyncCatalogAssociation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantCatalogProductsApi - object-oriented interface
 * @export
 * @class MerchantCatalogProductsApi
 * @extends {BaseAPI}
 */
export class MerchantCatalogProductsApi extends BaseAPI {
    /**
     * Bulk add products to a merchant catalog
     * @summary Bulk add products to catalog
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {Array<CatalogProductAssociation>} catalogProductAssociation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogProductsApi
     */
    public bulkAddProductsMerchantCatalog(merchantId: string, catalogId: string, catalogProductAssociation: Array<CatalogProductAssociation>, options?: RawAxiosRequestConfig) {
        return MerchantCatalogProductsApiFp(this.configuration).bulkAddProductsMerchantCatalog(merchantId, catalogId, catalogProductAssociation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Copy catalog from a different merchant
     * @summary Copy catalog from a different merchant
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {CatalogCopy} catalogCopy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogProductsApi
     */
    public copyMerchantCatalog(merchantId: string, catalogId: string, catalogCopy: CatalogCopy, options?: RawAxiosRequestConfig) {
        return MerchantCatalogProductsApiFp(this.configuration).copyMerchantCatalog(merchantId, catalogId, catalogCopy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists the products associated with a particular merchant catalog
     * @summary List merchant catalog products
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {ListMerchantCatalogProductsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogProductsApi
     */
    public listMerchantCatalogProducts(merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogProductsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return MerchantCatalogProductsApiFp(this.configuration).listMerchantCatalogProducts(merchantId, catalogId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists the products to be verified associated with a particular merchant catalog
     * @summary List merchant catalog products to be verified
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {ListMerchantCatalogProductsToVerifyOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogProductsApi
     */
    public listMerchantCatalogProductsToVerify(merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogProductsToVerifyOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return MerchantCatalogProductsApiFp(this.configuration).listMerchantCatalogProductsToVerify(merchantId, catalogId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk queue products to be added to a merchant catalog, verifying processing in an asynchronous way.
     * @summary Queue products to catalog
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {Array<AsyncCatalogAssociation>} asyncCatalogAssociation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogProductsApi
     */
    public queueProductsToCatalog(merchantId: string, catalogId: string, asyncCatalogAssociation: Array<AsyncCatalogAssociation>, options?: RawAxiosRequestConfig) {
        return MerchantCatalogProductsApiFp(this.configuration).queueProductsToCatalog(merchantId, catalogId, asyncCatalogAssociation, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListMerchantCatalogProductsOrderByEnum = {
    ProductId: 'product_id'
} as const;
export type ListMerchantCatalogProductsOrderByEnum = typeof ListMerchantCatalogProductsOrderByEnum[keyof typeof ListMerchantCatalogProductsOrderByEnum];
/**
 * @export
 */
export const ListMerchantCatalogProductsToVerifyOrderByEnum = {
    ProductId: 'product_id'
} as const;
export type ListMerchantCatalogProductsToVerifyOrderByEnum = typeof ListMerchantCatalogProductsToVerifyOrderByEnum[keyof typeof ListMerchantCatalogProductsToVerifyOrderByEnum];


/**
 * MerchantCatalogUploadsApi - axios parameter creator
 * @export
 */
export const MerchantCatalogUploadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a specific upload associated with a particular merchant catalog
         * @summary Get merchant catalog upload detail
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {string | null} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantCatalogUpload: async (merchantId: string, catalogId: string, uploadId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantCatalogUpload', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('getMerchantCatalogUpload', 'catalogId', catalogId)
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('getMerchantCatalogUpload', 'uploadId', uploadId)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}/uploads/{upload_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)))
                .replace(`{${"upload_id"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists the uploads associated with a particular merchant catalog
         * @summary List merchant catalog uploads
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {ListMerchantCatalogUploadsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantCatalogUploads: async (merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogUploadsOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listMerchantCatalogUploads', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('listMerchantCatalogUploads', 'catalogId', catalogId)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}/uploads`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantCatalogUploadsApi - functional programming interface
 * @export
 */
export const MerchantCatalogUploadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantCatalogUploadsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a specific upload associated with a particular merchant catalog
         * @summary Get merchant catalog upload detail
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {string | null} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantCatalogUpload(merchantId: string, catalogId: string, uploadId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantCatalogUpload(merchantId, catalogId, uploadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogUploadsApi.getMerchantCatalogUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists the uploads associated with a particular merchant catalog
         * @summary List merchant catalog uploads
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {ListMerchantCatalogUploadsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMerchantCatalogUploads(merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogUploadsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMerchantCatalogUploads200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMerchantCatalogUploads(merchantId, catalogId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogUploadsApi.listMerchantCatalogUploads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MerchantCatalogUploadsApi - factory interface
 * @export
 */
export const MerchantCatalogUploadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantCatalogUploadsApiFp(configuration)
    return {
        /**
         * Get a specific upload associated with a particular merchant catalog
         * @summary Get merchant catalog upload detail
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {string | null} uploadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantCatalogUpload(merchantId: string, catalogId: string, uploadId: string | null, options?: any): AxiosPromise<MerchantCatalog> {
            return localVarFp.getMerchantCatalogUpload(merchantId, catalogId, uploadId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the uploads associated with a particular merchant catalog
         * @summary List merchant catalog uploads
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {ListMerchantCatalogUploadsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantCatalogUploads(merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogUploadsOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListMerchantCatalogUploads200Response> {
            return localVarFp.listMerchantCatalogUploads(merchantId, catalogId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantCatalogUploadsApi - object-oriented interface
 * @export
 * @class MerchantCatalogUploadsApi
 * @extends {BaseAPI}
 */
export class MerchantCatalogUploadsApi extends BaseAPI {
    /**
     * Get a specific upload associated with a particular merchant catalog
     * @summary Get merchant catalog upload detail
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {string | null} uploadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogUploadsApi
     */
    public getMerchantCatalogUpload(merchantId: string, catalogId: string, uploadId: string | null, options?: RawAxiosRequestConfig) {
        return MerchantCatalogUploadsApiFp(this.configuration).getMerchantCatalogUpload(merchantId, catalogId, uploadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists the uploads associated with a particular merchant catalog
     * @summary List merchant catalog uploads
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {ListMerchantCatalogUploadsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogUploadsApi
     */
    public listMerchantCatalogUploads(merchantId: string, catalogId: string, orderBy?: ListMerchantCatalogUploadsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return MerchantCatalogUploadsApiFp(this.configuration).listMerchantCatalogUploads(merchantId, catalogId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListMerchantCatalogUploadsOrderByEnum = {
    UploadId: 'upload_id'
} as const;
export type ListMerchantCatalogUploadsOrderByEnum = typeof ListMerchantCatalogUploadsOrderByEnum[keyof typeof ListMerchantCatalogUploadsOrderByEnum];


/**
 * MerchantCatalogsApi - axios parameter creator
 * @export
 */
export const MerchantCatalogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a merchant catalog comprising of products and prices that will be available to import in a sales channel (pos, ecommerce).
         * @summary Create a catalog
         * @param {string} merchantId 
         * @param {MerchantCatalogBase} merchantCatalogBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchantCatalog: async (merchantId: string, merchantCatalogBase: MerchantCatalogBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createMerchantCatalog', 'merchantId', merchantId)
            // verify required parameter 'merchantCatalogBase' is not null or undefined
            assertParamExists('createMerchantCatalog', 'merchantCatalogBase', merchantCatalogBase)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantCatalogBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveMerchantCatalog: async (merchantId: string, catalogId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getActiveMerchantCatalog', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('getActiveMerchantCatalog', 'catalogId', catalogId)
            const localVarPath = `/catalog-merchants/{merchant_id}/active-catalogs/{catalog_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantCatalog: async (merchantId: string, catalogId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantCatalog', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('getMerchantCatalog', 'catalogId', catalogId)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a stripe checkout session
         * @param {string} merchantId 
         * @param {string | null} catalogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intitiateCatalogCheckout: async (merchantId: string, catalogId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('intitiateCatalogCheckout', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('intitiateCatalogCheckout', 'catalogId', catalogId)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}/checkout`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List active merchant catalogs
         * @param {string} merchantId 
         * @param {ListActiveMerchantCatalogsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveMerchantCatalogs: async (merchantId: string, orderBy?: ListActiveMerchantCatalogsOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listActiveMerchantCatalogs', 'merchantId', merchantId)
            const localVarPath = `/catalog-merchants/{merchant_id}/active-catalogs`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List merchant catalogs
         * @param {string} merchantId 
         * @param {ListMerchantCatalogsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantCatalogs: async (merchantId: string, orderBy?: ListMerchantCatalogsOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listMerchantCatalogs', 'merchantId', merchantId)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially update a merchant catalog
         * @summary Partial update merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {PartialUpdateCatalogMerchantCatalogRequestBody} partialUpdateCatalogMerchantCatalogRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMerchantCatalog: async (merchantId: string, catalogId: string, partialUpdateCatalogMerchantCatalogRequestBody: PartialUpdateCatalogMerchantCatalogRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('patchMerchantCatalog', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('patchMerchantCatalog', 'catalogId', catalogId)
            // verify required parameter 'partialUpdateCatalogMerchantCatalogRequestBody' is not null or undefined
            assertParamExists('patchMerchantCatalog', 'partialUpdateCatalogMerchantCatalogRequestBody', partialUpdateCatalogMerchantCatalogRequestBody)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateCatalogMerchantCatalogRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a merchant catalog
         * @summary Update merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {MerchantCatalogBase} merchantCatalogBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantCatalog: async (merchantId: string, catalogId: string, merchantCatalogBase: MerchantCatalogBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateMerchantCatalog', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('updateMerchantCatalog', 'catalogId', catalogId)
            // verify required parameter 'merchantCatalogBase' is not null or undefined
            assertParamExists('updateMerchantCatalog', 'merchantCatalogBase', merchantCatalogBase)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantCatalogBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verifies a stripe checkout session
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {string | null} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCatalogCheckout: async (merchantId: string, catalogId: string, sessionId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('verifyCatalogCheckout', 'merchantId', merchantId)
            // verify required parameter 'catalogId' is not null or undefined
            assertParamExists('verifyCatalogCheckout', 'catalogId', catalogId)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('verifyCatalogCheckout', 'sessionId', sessionId)
            const localVarPath = `/catalog-merchants/{merchant_id}/catalogs/{catalog_id}/checkout-complete`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"catalog_id"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantCatalogsApi - functional programming interface
 * @export
 */
export const MerchantCatalogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantCatalogsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a merchant catalog comprising of products and prices that will be available to import in a sales channel (pos, ecommerce).
         * @summary Create a catalog
         * @param {string} merchantId 
         * @param {MerchantCatalogBase} merchantCatalogBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMerchantCatalog(merchantId: string, merchantCatalogBase: MerchantCatalogBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMerchantCatalog(merchantId, merchantCatalogBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogsApi.createMerchantCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get active merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveMerchantCatalog(merchantId: string, catalogId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveMerchantCatalog(merchantId, catalogId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogsApi.getActiveMerchantCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantCatalog(merchantId: string, catalogId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantCatalog(merchantId, catalogId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogsApi.getMerchantCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a stripe checkout session
         * @param {string} merchantId 
         * @param {string | null} catalogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async intitiateCatalogCheckout(merchantId: string, catalogId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedirectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.intitiateCatalogCheckout(merchantId, catalogId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogsApi.intitiateCatalogCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List active merchant catalogs
         * @param {string} merchantId 
         * @param {ListActiveMerchantCatalogsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActiveMerchantCatalogs(merchantId: string, orderBy?: ListActiveMerchantCatalogsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMerchantCatalogs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActiveMerchantCatalogs(merchantId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogsApi.listActiveMerchantCatalogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List merchant catalogs
         * @param {string} merchantId 
         * @param {ListMerchantCatalogsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMerchantCatalogs(merchantId: string, orderBy?: ListMerchantCatalogsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMerchantCatalogs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMerchantCatalogs(merchantId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogsApi.listMerchantCatalogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Partially update a merchant catalog
         * @summary Partial update merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {PartialUpdateCatalogMerchantCatalogRequestBody} partialUpdateCatalogMerchantCatalogRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchMerchantCatalog(merchantId: string, catalogId: string, partialUpdateCatalogMerchantCatalogRequestBody: PartialUpdateCatalogMerchantCatalogRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateCatalogMerchantCatalogResponseBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchMerchantCatalog(merchantId, catalogId, partialUpdateCatalogMerchantCatalogRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogsApi.patchMerchantCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a merchant catalog
         * @summary Update merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {MerchantCatalogBase} merchantCatalogBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantCatalog(merchantId: string, catalogId: string, merchantCatalogBase: MerchantCatalogBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantCatalog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantCatalog(merchantId, catalogId, merchantCatalogBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogsApi.updateMerchantCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verifies a stripe checkout session
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {string | null} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyCatalogCheckout(merchantId: string, catalogId: string, sessionId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedirectApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyCatalogCheckout(merchantId, catalogId, sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantCatalogsApi.verifyCatalogCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MerchantCatalogsApi - factory interface
 * @export
 */
export const MerchantCatalogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantCatalogsApiFp(configuration)
    return {
        /**
         * Create a merchant catalog comprising of products and prices that will be available to import in a sales channel (pos, ecommerce).
         * @summary Create a catalog
         * @param {string} merchantId 
         * @param {MerchantCatalogBase} merchantCatalogBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchantCatalog(merchantId: string, merchantCatalogBase: MerchantCatalogBase, options?: any): AxiosPromise<MerchantCatalog> {
            return localVarFp.createMerchantCatalog(merchantId, merchantCatalogBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveMerchantCatalog(merchantId: string, catalogId: string, options?: any): AxiosPromise<MerchantCatalog> {
            return localVarFp.getActiveMerchantCatalog(merchantId, catalogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantCatalog(merchantId: string, catalogId: string, options?: any): AxiosPromise<MerchantCatalog> {
            return localVarFp.getMerchantCatalog(merchantId, catalogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a stripe checkout session
         * @param {string} merchantId 
         * @param {string | null} catalogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intitiateCatalogCheckout(merchantId: string, catalogId: string | null, options?: any): AxiosPromise<RedirectApiResponse> {
            return localVarFp.intitiateCatalogCheckout(merchantId, catalogId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List active merchant catalogs
         * @param {string} merchantId 
         * @param {ListActiveMerchantCatalogsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveMerchantCatalogs(merchantId: string, orderBy?: ListActiveMerchantCatalogsOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListMerchantCatalogs200Response> {
            return localVarFp.listActiveMerchantCatalogs(merchantId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List merchant catalogs
         * @param {string} merchantId 
         * @param {ListMerchantCatalogsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantCatalogs(merchantId: string, orderBy?: ListMerchantCatalogsOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListMerchantCatalogs200Response> {
            return localVarFp.listMerchantCatalogs(merchantId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Partially update a merchant catalog
         * @summary Partial update merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {PartialUpdateCatalogMerchantCatalogRequestBody} partialUpdateCatalogMerchantCatalogRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMerchantCatalog(merchantId: string, catalogId: string, partialUpdateCatalogMerchantCatalogRequestBody: PartialUpdateCatalogMerchantCatalogRequestBody, options?: any): AxiosPromise<PartialUpdateCatalogMerchantCatalogResponseBody> {
            return localVarFp.patchMerchantCatalog(merchantId, catalogId, partialUpdateCatalogMerchantCatalogRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a merchant catalog
         * @summary Update merchant catalog
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {MerchantCatalogBase} merchantCatalogBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantCatalog(merchantId: string, catalogId: string, merchantCatalogBase: MerchantCatalogBase, options?: any): AxiosPromise<MerchantCatalog> {
            return localVarFp.updateMerchantCatalog(merchantId, catalogId, merchantCatalogBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verifies a stripe checkout session
         * @param {string} merchantId 
         * @param {string} catalogId 
         * @param {string | null} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCatalogCheckout(merchantId: string, catalogId: string, sessionId: string | null, options?: any): AxiosPromise<RedirectApiResponse> {
            return localVarFp.verifyCatalogCheckout(merchantId, catalogId, sessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantCatalogsApi - object-oriented interface
 * @export
 * @class MerchantCatalogsApi
 * @extends {BaseAPI}
 */
export class MerchantCatalogsApi extends BaseAPI {
    /**
     * Create a merchant catalog comprising of products and prices that will be available to import in a sales channel (pos, ecommerce).
     * @summary Create a catalog
     * @param {string} merchantId 
     * @param {MerchantCatalogBase} merchantCatalogBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogsApi
     */
    public createMerchantCatalog(merchantId: string, merchantCatalogBase: MerchantCatalogBase, options?: RawAxiosRequestConfig) {
        return MerchantCatalogsApiFp(this.configuration).createMerchantCatalog(merchantId, merchantCatalogBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active merchant catalog
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogsApi
     */
    public getActiveMerchantCatalog(merchantId: string, catalogId: string, options?: RawAxiosRequestConfig) {
        return MerchantCatalogsApiFp(this.configuration).getActiveMerchantCatalog(merchantId, catalogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant catalog
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogsApi
     */
    public getMerchantCatalog(merchantId: string, catalogId: string, options?: RawAxiosRequestConfig) {
        return MerchantCatalogsApiFp(this.configuration).getMerchantCatalog(merchantId, catalogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a stripe checkout session
     * @param {string} merchantId 
     * @param {string | null} catalogId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogsApi
     */
    public intitiateCatalogCheckout(merchantId: string, catalogId: string | null, options?: RawAxiosRequestConfig) {
        return MerchantCatalogsApiFp(this.configuration).intitiateCatalogCheckout(merchantId, catalogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List active merchant catalogs
     * @param {string} merchantId 
     * @param {ListActiveMerchantCatalogsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogsApi
     */
    public listActiveMerchantCatalogs(merchantId: string, orderBy?: ListActiveMerchantCatalogsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return MerchantCatalogsApiFp(this.configuration).listActiveMerchantCatalogs(merchantId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List merchant catalogs
     * @param {string} merchantId 
     * @param {ListMerchantCatalogsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogsApi
     */
    public listMerchantCatalogs(merchantId: string, orderBy?: ListMerchantCatalogsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return MerchantCatalogsApiFp(this.configuration).listMerchantCatalogs(merchantId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Partially update a merchant catalog
     * @summary Partial update merchant catalog
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {PartialUpdateCatalogMerchantCatalogRequestBody} partialUpdateCatalogMerchantCatalogRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogsApi
     */
    public patchMerchantCatalog(merchantId: string, catalogId: string, partialUpdateCatalogMerchantCatalogRequestBody: PartialUpdateCatalogMerchantCatalogRequestBody, options?: RawAxiosRequestConfig) {
        return MerchantCatalogsApiFp(this.configuration).patchMerchantCatalog(merchantId, catalogId, partialUpdateCatalogMerchantCatalogRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a merchant catalog
     * @summary Update merchant catalog
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {MerchantCatalogBase} merchantCatalogBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogsApi
     */
    public updateMerchantCatalog(merchantId: string, catalogId: string, merchantCatalogBase: MerchantCatalogBase, options?: RawAxiosRequestConfig) {
        return MerchantCatalogsApiFp(this.configuration).updateMerchantCatalog(merchantId, catalogId, merchantCatalogBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verifies a stripe checkout session
     * @param {string} merchantId 
     * @param {string} catalogId 
     * @param {string | null} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantCatalogsApi
     */
    public verifyCatalogCheckout(merchantId: string, catalogId: string, sessionId: string | null, options?: RawAxiosRequestConfig) {
        return MerchantCatalogsApiFp(this.configuration).verifyCatalogCheckout(merchantId, catalogId, sessionId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListActiveMerchantCatalogsOrderByEnum = {
    Name: 'name'
} as const;
export type ListActiveMerchantCatalogsOrderByEnum = typeof ListActiveMerchantCatalogsOrderByEnum[keyof typeof ListActiveMerchantCatalogsOrderByEnum];
/**
 * @export
 */
export const ListMerchantCatalogsOrderByEnum = {
    Name: 'name'
} as const;
export type ListMerchantCatalogsOrderByEnum = typeof ListMerchantCatalogsOrderByEnum[keyof typeof ListMerchantCatalogsOrderByEnum];


/**
 * OrganizationApi - axios parameter creator
 * @export
 */
export const OrganizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates an organization that can manage products.
         * @summary Create an organization
         * @param {OrganizationPayload} organizationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrg: async (organizationPayload: OrganizationPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPayload' is not null or undefined
            assertParamExists('createOrg', 'organizationPayload', organizationPayload)
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get organization by id.
         * @summary Get organization by id
         * @param {string | null} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrg: async (orgId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrg', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all organizations for which the current user has access.
         * @summary List organizations
         * @param {ListOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (orderBy?: ListOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially update properties on an organization.
         * @summary Partial update organization
         * @param {string} orgId 
         * @param {PartialUpdateOrganizationOrganizationPayloadRequestBody} partialUpdateOrganizationOrganizationPayloadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOrg: async (orgId: string, partialUpdateOrganizationOrganizationPayloadRequestBody: PartialUpdateOrganizationOrganizationPayloadRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('patchOrg', 'orgId', orgId)
            // verify required parameter 'partialUpdateOrganizationOrganizationPayloadRequestBody' is not null or undefined
            assertParamExists('patchOrg', 'partialUpdateOrganizationOrganizationPayloadRequestBody', partialUpdateOrganizationOrganizationPayloadRequestBody)
            const localVarPath = `/organizations/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateOrganizationOrganizationPayloadRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full update to an organization and replacing with new values.
         * @summary Update organization
         * @param {string} orgId 
         * @param {OrganizationPayload} organizationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrg: async (orgId: string, organizationPayload: OrganizationPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateOrg', 'orgId', orgId)
            // verify required parameter 'organizationPayload' is not null or undefined
            assertParamExists('updateOrg', 'organizationPayload', organizationPayload)
            const localVarPath = `/organizations/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationApi - functional programming interface
 * @export
 */
export const OrganizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates an organization that can manage products.
         * @summary Create an organization
         * @param {OrganizationPayload} organizationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrg(organizationPayload: OrganizationPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrg(organizationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApi.createOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get organization by id.
         * @summary Get organization by id
         * @param {string | null} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrg(orgId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrg(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApi.getOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all organizations for which the current user has access.
         * @summary List organizations
         * @param {ListOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(orderBy?: ListOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<List200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Partially update properties on an organization.
         * @summary Partial update organization
         * @param {string} orgId 
         * @param {PartialUpdateOrganizationOrganizationPayloadRequestBody} partialUpdateOrganizationOrganizationPayloadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchOrg(orgId: string, partialUpdateOrganizationOrganizationPayloadRequestBody: PartialUpdateOrganizationOrganizationPayloadRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchOrg(orgId, partialUpdateOrganizationOrganizationPayloadRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApi.patchOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Full update to an organization and replacing with new values.
         * @summary Update organization
         * @param {string} orgId 
         * @param {OrganizationPayload} organizationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrg(orgId: string, organizationPayload: OrganizationPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrg(orgId, organizationPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationApi.updateOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationApi - factory interface
 * @export
 */
export const OrganizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationApiFp(configuration)
    return {
        /**
         * Creates an organization that can manage products.
         * @summary Create an organization
         * @param {OrganizationPayload} organizationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrg(organizationPayload: OrganizationPayload, options?: any): AxiosPromise<Organization> {
            return localVarFp.createOrg(organizationPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Get organization by id.
         * @summary Get organization by id
         * @param {string | null} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrg(orgId: string | null, options?: any): AxiosPromise<Organization> {
            return localVarFp.getOrg(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all organizations for which the current user has access.
         * @summary List organizations
         * @param {ListOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(orderBy?: ListOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<List200Response> {
            return localVarFp.list(orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Partially update properties on an organization.
         * @summary Partial update organization
         * @param {string} orgId 
         * @param {PartialUpdateOrganizationOrganizationPayloadRequestBody} partialUpdateOrganizationOrganizationPayloadRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOrg(orgId: string, partialUpdateOrganizationOrganizationPayloadRequestBody: PartialUpdateOrganizationOrganizationPayloadRequestBody, options?: any): AxiosPromise<Organization> {
            return localVarFp.patchOrg(orgId, partialUpdateOrganizationOrganizationPayloadRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Full update to an organization and replacing with new values.
         * @summary Update organization
         * @param {string} orgId 
         * @param {OrganizationPayload} organizationPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrg(orgId: string, organizationPayload: OrganizationPayload, options?: any): AxiosPromise<Organization> {
            return localVarFp.updateOrg(orgId, organizationPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationApi - object-oriented interface
 * @export
 * @class OrganizationApi
 * @extends {BaseAPI}
 */
export class OrganizationApi extends BaseAPI {
    /**
     * Creates an organization that can manage products.
     * @summary Create an organization
     * @param {OrganizationPayload} organizationPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public createOrg(organizationPayload: OrganizationPayload, options?: RawAxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).createOrg(organizationPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get organization by id.
     * @summary Get organization by id
     * @param {string | null} orgId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public getOrg(orgId: string | null, options?: RawAxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).getOrg(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all organizations for which the current user has access.
     * @summary List organizations
     * @param {ListOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public list(orderBy?: ListOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).list(orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Partially update properties on an organization.
     * @summary Partial update organization
     * @param {string} orgId 
     * @param {PartialUpdateOrganizationOrganizationPayloadRequestBody} partialUpdateOrganizationOrganizationPayloadRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public patchOrg(orgId: string, partialUpdateOrganizationOrganizationPayloadRequestBody: PartialUpdateOrganizationOrganizationPayloadRequestBody, options?: RawAxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).patchOrg(orgId, partialUpdateOrganizationOrganizationPayloadRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full update to an organization and replacing with new values.
     * @summary Update organization
     * @param {string} orgId 
     * @param {OrganizationPayload} organizationPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    public updateOrg(orgId: string, organizationPayload: OrganizationPayload, options?: RawAxiosRequestConfig) {
        return OrganizationApiFp(this.configuration).updateOrg(orgId, organizationPayload, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListOrderByEnum = {
    Name: 'name',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at'
} as const;
export type ListOrderByEnum = typeof ListOrderByEnum[keyof typeof ListOrderByEnum];


/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *            Create a product that belongs to an organization identified by organization ID.                       For ease of creating a product and variants, you must specify at least one variant at creation time.
         * @summary Create a product
         * @param {string} orgId 
         * @param {ProductCreateWithVariants} productCreateWithVariants 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (orgId: string, productCreateWithVariants: ProductCreateWithVariants, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createProduct', 'orgId', orgId)
            // verify required parameter 'productCreateWithVariants' is not null or undefined
            assertParamExists('createProduct', 'productCreateWithVariants', productCreateWithVariants)
            const localVarPath = `/organizations/{org_id}/products`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productCreateWithVariants, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches one product by ID
         * @summary Get product by id
         * @param {string} orgId 
         * @param {string | null} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (orgId: string, productId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getProduct', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProduct', 'productId', productId)
            const localVarPath = `/organizations/{org_id}/products/{product_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches one variant by UPC
         * @summary Get product by variant UPC
         * @param {string | null} upc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByVariantUPC: async (upc: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upc' is not null or undefined
            assertParamExists('getProductByVariantUPC', 'upc', upc)
            const localVarPath = `/organizations/upc-lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (upc !== undefined) {
                localVarQueryParameter['upc'] = upc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all products that your account owns
         * @summary List products
         * @param {string} orgId 
         * @param {ListProductsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: async (orgId: string, orderBy?: ListProductsOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('listProducts', 'orgId', orgId)
            const localVarPath = `/organizations/{org_id}/products`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a product by ID
         * @param {string} orgId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrgIdProductsProductIdDeleteProductById: async (orgId: string, productId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('organizationsOrgIdProductsProductIdDeleteProductById', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('organizationsOrgIdProductsProductIdDeleteProductById', 'productId', productId)
            const localVarPath = `/organizations/{org_id}/products/{product_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used to partially update fields on the Product. **Variants cannot be updated with this endpoint**. To update fields that affect variants, such as `varies_by`, you must use the (Update Product)[/docs#/operations/UpdateProduct] endpoint to do so.
         * @summary Partial update product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {PatchProductProductUpdateRequestBody} patchProductProductUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateProduct: async (orgId: string, productId: string, patchProductProductUpdateRequestBody: PatchProductProductUpdateRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('partialUpdateProduct', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('partialUpdateProduct', 'productId', productId)
            // verify required parameter 'patchProductProductUpdateRequestBody' is not null or undefined
            assertParamExists('partialUpdateProduct', 'patchProductProductUpdateRequestBody', patchProductProductUpdateRequestBody)
            const localVarPath = `/organizations/{org_id}/products/{product_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchProductProductUpdateRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {ProductUpdateWithVariants} productUpdateWithVariants 
         * @param {boolean} [overrideVariants] Must be set to true if the                                                 product payload is missing any variants.                                                     Missing variants will be removed from this product if true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (orgId: string, productId: string, productUpdateWithVariants: ProductUpdateWithVariants, overrideVariants?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateProduct', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('updateProduct', 'productId', productId)
            // verify required parameter 'productUpdateWithVariants' is not null or undefined
            assertParamExists('updateProduct', 'productUpdateWithVariants', productUpdateWithVariants)
            const localVarPath = `/organizations/{org_id}/products/{product_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (overrideVariants !== undefined) {
                localVarQueryParameter['override_variants'] = overrideVariants;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productUpdateWithVariants, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         *            Create a product that belongs to an organization identified by organization ID.                       For ease of creating a product and variants, you must specify at least one variant at creation time.
         * @summary Create a product
         * @param {string} orgId 
         * @param {ProductCreateWithVariants} productCreateWithVariants 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(orgId: string, productCreateWithVariants: ProductCreateWithVariants, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWithVariants>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(orgId, productCreateWithVariants, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.createProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches one product by ID
         * @summary Get product by id
         * @param {string} orgId 
         * @param {string | null} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(orgId: string, productId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWithVariants>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProduct(orgId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.getProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches one variant by UPC
         * @summary Get product by variant UPC
         * @param {string | null} upc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductByVariantUPC(upc: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWithVariants>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductByVariantUPC(upc, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.getProductByVariantUPC']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all products that your account owns
         * @summary List products
         * @param {string} orgId 
         * @param {ListProductsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProducts(orgId: string, orderBy?: ListProductsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListProducts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProducts(orgId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.listProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a product by ID
         * @param {string} orgId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationsOrgIdProductsProductIdDeleteProductById(orgId: string, productId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationsOrgIdProductsProductIdDeleteProductById(orgId, productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.organizationsOrgIdProductsProductIdDeleteProductById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used to partially update fields on the Product. **Variants cannot be updated with this endpoint**. To update fields that affect variants, such as `varies_by`, you must use the (Update Product)[/docs#/operations/UpdateProduct] endpoint to do so.
         * @summary Partial update product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {PatchProductProductUpdateRequestBody} patchProductProductUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partialUpdateProduct(orgId: string, productId: string, patchProductProductUpdateRequestBody: PatchProductProductUpdateRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partialUpdateProduct(orgId, productId, patchProductProductUpdateRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.partialUpdateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {ProductUpdateWithVariants} productUpdateWithVariants 
         * @param {boolean} [overrideVariants] Must be set to true if the                                                 product payload is missing any variants.                                                     Missing variants will be removed from this product if true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(orgId: string, productId: string, productUpdateWithVariants: ProductUpdateWithVariants, overrideVariants?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(orgId, productId, productUpdateWithVariants, overrideVariants, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductApi.updateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         *            Create a product that belongs to an organization identified by organization ID.                       For ease of creating a product and variants, you must specify at least one variant at creation time.
         * @summary Create a product
         * @param {string} orgId 
         * @param {ProductCreateWithVariants} productCreateWithVariants 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(orgId: string, productCreateWithVariants: ProductCreateWithVariants, options?: any): AxiosPromise<ProductWithVariants> {
            return localVarFp.createProduct(orgId, productCreateWithVariants, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches one product by ID
         * @summary Get product by id
         * @param {string} orgId 
         * @param {string | null} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(orgId: string, productId: string | null, options?: any): AxiosPromise<ProductWithVariants> {
            return localVarFp.getProduct(orgId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches one variant by UPC
         * @summary Get product by variant UPC
         * @param {string | null} upc 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByVariantUPC(upc: string | null, options?: any): AxiosPromise<ProductWithVariants> {
            return localVarFp.getProductByVariantUPC(upc, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all products that your account owns
         * @summary List products
         * @param {string} orgId 
         * @param {ListProductsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts(orgId: string, orderBy?: ListProductsOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListProducts200Response> {
            return localVarFp.listProducts(orgId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a product by ID
         * @param {string} orgId 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsOrgIdProductsProductIdDeleteProductById(orgId: string, productId: string, options?: any): AxiosPromise<void> {
            return localVarFp.organizationsOrgIdProductsProductIdDeleteProductById(orgId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used to partially update fields on the Product. **Variants cannot be updated with this endpoint**. To update fields that affect variants, such as `varies_by`, you must use the (Update Product)[/docs#/operations/UpdateProduct] endpoint to do so.
         * @summary Partial update product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {PatchProductProductUpdateRequestBody} patchProductProductUpdateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateProduct(orgId: string, productId: string, patchProductProductUpdateRequestBody: PatchProductProductUpdateRequestBody, options?: any): AxiosPromise<Product> {
            return localVarFp.partialUpdateProduct(orgId, productId, patchProductProductUpdateRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {ProductUpdateWithVariants} productUpdateWithVariants 
         * @param {boolean} [overrideVariants] Must be set to true if the                                                 product payload is missing any variants.                                                     Missing variants will be removed from this product if true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(orgId: string, productId: string, productUpdateWithVariants: ProductUpdateWithVariants, overrideVariants?: boolean, options?: any): AxiosPromise<Product> {
            return localVarFp.updateProduct(orgId, productId, productUpdateWithVariants, overrideVariants, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     *            Create a product that belongs to an organization identified by organization ID.                       For ease of creating a product and variants, you must specify at least one variant at creation time.
     * @summary Create a product
     * @param {string} orgId 
     * @param {ProductCreateWithVariants} productCreateWithVariants 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public createProduct(orgId: string, productCreateWithVariants: ProductCreateWithVariants, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).createProduct(orgId, productCreateWithVariants, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches one product by ID
     * @summary Get product by id
     * @param {string} orgId 
     * @param {string | null} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProduct(orgId: string, productId: string | null, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).getProduct(orgId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches one variant by UPC
     * @summary Get product by variant UPC
     * @param {string | null} upc 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProductByVariantUPC(upc: string | null, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).getProductByVariantUPC(upc, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all products that your account owns
     * @summary List products
     * @param {string} orgId 
     * @param {ListProductsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public listProducts(orgId: string, orderBy?: ListProductsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).listProducts(orgId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a product by ID
     * @param {string} orgId 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public organizationsOrgIdProductsProductIdDeleteProductById(orgId: string, productId: string, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).organizationsOrgIdProductsProductIdDeleteProductById(orgId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used to partially update fields on the Product. **Variants cannot be updated with this endpoint**. To update fields that affect variants, such as `varies_by`, you must use the (Update Product)[/docs#/operations/UpdateProduct] endpoint to do so.
     * @summary Partial update product
     * @param {string} orgId 
     * @param {string} productId 
     * @param {PatchProductProductUpdateRequestBody} patchProductProductUpdateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public partialUpdateProduct(orgId: string, productId: string, patchProductProductUpdateRequestBody: PatchProductProductUpdateRequestBody, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).partialUpdateProduct(orgId, productId, patchProductProductUpdateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update product
     * @param {string} orgId 
     * @param {string} productId 
     * @param {ProductUpdateWithVariants} productUpdateWithVariants 
     * @param {boolean} [overrideVariants] Must be set to true if the                                                 product payload is missing any variants.                                                     Missing variants will be removed from this product if true.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public updateProduct(orgId: string, productId: string, productUpdateWithVariants: ProductUpdateWithVariants, overrideVariants?: boolean, options?: RawAxiosRequestConfig) {
        return ProductApiFp(this.configuration).updateProduct(orgId, productId, productUpdateWithVariants, overrideVariants, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListProductsOrderByEnum = {
    Title: 'title',
    UpdatedAt: 'updated_at',
    CreatedAt: 'created_at'
} as const;
export type ListProductsOrderByEnum = typeof ListProductsOrderByEnum[keyof typeof ListProductsOrderByEnum];


/**
 * ProductMediaApi - axios parameter creator
 * @export
 */
export const ProductMediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new media record for a product. Media can also be associated with variants.
         * @summary Create media for a product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {Array<MediaUploadRequest>} mediaUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductMedia: async (orgId: string, productId: string, mediaUploadRequest: Array<MediaUploadRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createProductMedia', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('createProductMedia', 'productId', productId)
            // verify required parameter 'mediaUploadRequest' is not null or undefined
            assertParamExists('createProductMedia', 'mediaUploadRequest', mediaUploadRequest)
            const localVarPath = `/organizations/{org_id}/products/{product_id}/media`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductMediaApi - functional programming interface
 * @export
 */
export const ProductMediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductMediaApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new media record for a product. Media can also be associated with variants.
         * @summary Create media for a product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {Array<MediaUploadRequest>} mediaUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductMedia(orgId: string, productId: string, mediaUploadRequest: Array<MediaUploadRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MediaUploadResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductMedia(orgId, productId, mediaUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductMediaApi.createProductMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductMediaApi - factory interface
 * @export
 */
export const ProductMediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductMediaApiFp(configuration)
    return {
        /**
         * Creates a new media record for a product. Media can also be associated with variants.
         * @summary Create media for a product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {Array<MediaUploadRequest>} mediaUploadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductMedia(orgId: string, productId: string, mediaUploadRequest: Array<MediaUploadRequest>, options?: any): AxiosPromise<Array<MediaUploadResponse>> {
            return localVarFp.createProductMedia(orgId, productId, mediaUploadRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductMediaApi - object-oriented interface
 * @export
 * @class ProductMediaApi
 * @extends {BaseAPI}
 */
export class ProductMediaApi extends BaseAPI {
    /**
     * Creates a new media record for a product. Media can also be associated with variants.
     * @summary Create media for a product
     * @param {string} orgId 
     * @param {string} productId 
     * @param {Array<MediaUploadRequest>} mediaUploadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductMediaApi
     */
    public createProductMedia(orgId: string, productId: string, mediaUploadRequest: Array<MediaUploadRequest>, options?: RawAxiosRequestConfig) {
        return ProductMediaApiFp(this.configuration).createProductMedia(orgId, productId, mediaUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReadOnlyEndpointsApi - axios parameter creator
 * @export
 */
export const ReadOnlyEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lists all categories
         * @summary List categories
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {ReadOnlyListAllCategoriesQParameter | null} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOnlyListAllCategories: async (cursor?: string | null, limit?: number, q?: ReadOnlyListAllCategoriesQParameter | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (q) {
                for (const [key, value] of Object.entries(q)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all products
         * @summary List products
         * @param {ReadOnlyListAllProductsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [organizationId] Optional organization_id to filter list only to products that belong to this organization.
         * @param {Array<string> | null} [brandIds] Optional brand_ids to filter list only to products that belong to these brands.
         * @param {Array<string> | null} [googleProductCategoryIds] Optional google product category filter for products belonging to this category.
         * @param {boolean | null} [includeChildrenCategories] Used in conjunction with &#x60;google_product_category_ids&#x60; to include all products in children categories.
         * @param {string | null} [cursor] Optional cursor to fetch the next page.
         * @param {string | null} [q] Search query. Can be search terms or GTIN.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOnlyListAllProducts: async (orderBy?: ReadOnlyListAllProductsOrderByEnum, limit?: number, organizationId?: string | null, brandIds?: Array<string> | null, googleProductCategoryIds?: Array<string> | null, includeChildrenCategories?: boolean | null, cursor?: string | null, q?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (brandIds) {
                localVarQueryParameter['brand_ids'] = brandIds;
            }

            if (googleProductCategoryIds) {
                localVarQueryParameter['google_product_category_ids'] = googleProductCategoryIds;
            }

            if (includeChildrenCategories !== undefined) {
                localVarQueryParameter['include_children_categories'] = includeChildrenCategories;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all variants
         * @summary List variants
         * @param {ReadOnlyListAllVariantsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [orgId] Filter list of variants for ones belonging to a particular organization.
         * @param {string | null} [brandId] Filter list of variants for ones belonging to a particular brand.
         * @param {string | null} [productId] Filter list of variants for variants belonging to a particular product.
         * @param {string | null} [cursor] Optional cursor to fetch the next page.
         * @param {string | null} [search] TODO: Not yet implemented. The query string to search for in the product or variants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOnlyListAllVariants: async (orderBy?: ReadOnlyListAllVariantsOrderByEnum, limit?: number, orgId?: string | null, brandId?: string | null, productId?: string | null, cursor?: string | null, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/variants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }

            if (brandId !== undefined) {
                localVarQueryParameter['brand_id'] = brandId;
            }

            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all brands with optional organization filter.
         * @summary List brands
         * @param {ReadOnlyListBrandsOrderByEnum} [orderBy] 
         * @param {string | null} [orgId] Optional organization_id to filter list to brands owned by org.
         * @param {number} [limit] 
         * @param {string | null} [cursor] Optional cursor to fetch the next page.
         * @param {string | null} [q] Brand search query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOnlyListBrands: async (orderBy?: ReadOnlyListBrandsOrderByEnum, orgId?: string | null, limit?: number, cursor?: string | null, q?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['org_id'] = orgId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReadOnlyEndpointsApi - functional programming interface
 * @export
 */
export const ReadOnlyEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReadOnlyEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * Lists all categories
         * @summary List categories
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {ReadOnlyListAllCategoriesQParameter | null} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readOnlyListAllCategories(cursor?: string | null, limit?: number, q?: ReadOnlyListAllCategoriesQParameter | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadOnlyListAllCategories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readOnlyListAllCategories(cursor, limit, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReadOnlyEndpointsApi.readOnlyListAllCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all products
         * @summary List products
         * @param {ReadOnlyListAllProductsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [organizationId] Optional organization_id to filter list only to products that belong to this organization.
         * @param {Array<string> | null} [brandIds] Optional brand_ids to filter list only to products that belong to these brands.
         * @param {Array<string> | null} [googleProductCategoryIds] Optional google product category filter for products belonging to this category.
         * @param {boolean | null} [includeChildrenCategories] Used in conjunction with &#x60;google_product_category_ids&#x60; to include all products in children categories.
         * @param {string | null} [cursor] Optional cursor to fetch the next page.
         * @param {string | null} [q] Search query. Can be search terms or GTIN.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readOnlyListAllProducts(orderBy?: ReadOnlyListAllProductsOrderByEnum, limit?: number, organizationId?: string | null, brandIds?: Array<string> | null, googleProductCategoryIds?: Array<string> | null, includeChildrenCategories?: boolean | null, cursor?: string | null, q?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListProducts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readOnlyListAllProducts(orderBy, limit, organizationId, brandIds, googleProductCategoryIds, includeChildrenCategories, cursor, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReadOnlyEndpointsApi.readOnlyListAllProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all variants
         * @summary List variants
         * @param {ReadOnlyListAllVariantsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [orgId] Filter list of variants for ones belonging to a particular organization.
         * @param {string | null} [brandId] Filter list of variants for ones belonging to a particular brand.
         * @param {string | null} [productId] Filter list of variants for variants belonging to a particular product.
         * @param {string | null} [cursor] Optional cursor to fetch the next page.
         * @param {string | null} [search] TODO: Not yet implemented. The query string to search for in the product or variants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readOnlyListAllVariants(orderBy?: ReadOnlyListAllVariantsOrderByEnum, limit?: number, orgId?: string | null, brandId?: string | null, productId?: string | null, cursor?: string | null, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVariants200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readOnlyListAllVariants(orderBy, limit, orgId, brandId, productId, cursor, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReadOnlyEndpointsApi.readOnlyListAllVariants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all brands with optional organization filter.
         * @summary List brands
         * @param {ReadOnlyListBrandsOrderByEnum} [orderBy] 
         * @param {string | null} [orgId] Optional organization_id to filter list to brands owned by org.
         * @param {number} [limit] 
         * @param {string | null} [cursor] Optional cursor to fetch the next page.
         * @param {string | null} [q] Brand search query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readOnlyListBrands(orderBy?: ReadOnlyListBrandsOrderByEnum, orgId?: string | null, limit?: number, cursor?: string | null, q?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListBrands200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readOnlyListBrands(orderBy, orgId, limit, cursor, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReadOnlyEndpointsApi.readOnlyListBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReadOnlyEndpointsApi - factory interface
 * @export
 */
export const ReadOnlyEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReadOnlyEndpointsApiFp(configuration)
    return {
        /**
         * Lists all categories
         * @summary List categories
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {ReadOnlyListAllCategoriesQParameter | null} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOnlyListAllCategories(cursor?: string | null, limit?: number, q?: ReadOnlyListAllCategoriesQParameter | null, options?: any): AxiosPromise<ReadOnlyListAllCategories200Response> {
            return localVarFp.readOnlyListAllCategories(cursor, limit, q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all products
         * @summary List products
         * @param {ReadOnlyListAllProductsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [organizationId] Optional organization_id to filter list only to products that belong to this organization.
         * @param {Array<string> | null} [brandIds] Optional brand_ids to filter list only to products that belong to these brands.
         * @param {Array<string> | null} [googleProductCategoryIds] Optional google product category filter for products belonging to this category.
         * @param {boolean | null} [includeChildrenCategories] Used in conjunction with &#x60;google_product_category_ids&#x60; to include all products in children categories.
         * @param {string | null} [cursor] Optional cursor to fetch the next page.
         * @param {string | null} [q] Search query. Can be search terms or GTIN.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOnlyListAllProducts(orderBy?: ReadOnlyListAllProductsOrderByEnum, limit?: number, organizationId?: string | null, brandIds?: Array<string> | null, googleProductCategoryIds?: Array<string> | null, includeChildrenCategories?: boolean | null, cursor?: string | null, q?: string | null, options?: any): AxiosPromise<ListProducts200Response> {
            return localVarFp.readOnlyListAllProducts(orderBy, limit, organizationId, brandIds, googleProductCategoryIds, includeChildrenCategories, cursor, q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all variants
         * @summary List variants
         * @param {ReadOnlyListAllVariantsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [orgId] Filter list of variants for ones belonging to a particular organization.
         * @param {string | null} [brandId] Filter list of variants for ones belonging to a particular brand.
         * @param {string | null} [productId] Filter list of variants for variants belonging to a particular product.
         * @param {string | null} [cursor] Optional cursor to fetch the next page.
         * @param {string | null} [search] TODO: Not yet implemented. The query string to search for in the product or variants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOnlyListAllVariants(orderBy?: ReadOnlyListAllVariantsOrderByEnum, limit?: number, orgId?: string | null, brandId?: string | null, productId?: string | null, cursor?: string | null, search?: string | null, options?: any): AxiosPromise<GetVariants200Response> {
            return localVarFp.readOnlyListAllVariants(orderBy, limit, orgId, brandId, productId, cursor, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all brands with optional organization filter.
         * @summary List brands
         * @param {ReadOnlyListBrandsOrderByEnum} [orderBy] 
         * @param {string | null} [orgId] Optional organization_id to filter list to brands owned by org.
         * @param {number} [limit] 
         * @param {string | null} [cursor] Optional cursor to fetch the next page.
         * @param {string | null} [q] Brand search query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readOnlyListBrands(orderBy?: ReadOnlyListBrandsOrderByEnum, orgId?: string | null, limit?: number, cursor?: string | null, q?: string | null, options?: any): AxiosPromise<ListBrands200Response> {
            return localVarFp.readOnlyListBrands(orderBy, orgId, limit, cursor, q, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReadOnlyEndpointsApi - object-oriented interface
 * @export
 * @class ReadOnlyEndpointsApi
 * @extends {BaseAPI}
 */
export class ReadOnlyEndpointsApi extends BaseAPI {
    /**
     * Lists all categories
     * @summary List categories
     * @param {string | null} [cursor] 
     * @param {number} [limit] 
     * @param {ReadOnlyListAllCategoriesQParameter | null} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReadOnlyEndpointsApi
     */
    public readOnlyListAllCategories(cursor?: string | null, limit?: number, q?: ReadOnlyListAllCategoriesQParameter | null, options?: RawAxiosRequestConfig) {
        return ReadOnlyEndpointsApiFp(this.configuration).readOnlyListAllCategories(cursor, limit, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all products
     * @summary List products
     * @param {ReadOnlyListAllProductsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [organizationId] Optional organization_id to filter list only to products that belong to this organization.
     * @param {Array<string> | null} [brandIds] Optional brand_ids to filter list only to products that belong to these brands.
     * @param {Array<string> | null} [googleProductCategoryIds] Optional google product category filter for products belonging to this category.
     * @param {boolean | null} [includeChildrenCategories] Used in conjunction with &#x60;google_product_category_ids&#x60; to include all products in children categories.
     * @param {string | null} [cursor] Optional cursor to fetch the next page.
     * @param {string | null} [q] Search query. Can be search terms or GTIN.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReadOnlyEndpointsApi
     */
    public readOnlyListAllProducts(orderBy?: ReadOnlyListAllProductsOrderByEnum, limit?: number, organizationId?: string | null, brandIds?: Array<string> | null, googleProductCategoryIds?: Array<string> | null, includeChildrenCategories?: boolean | null, cursor?: string | null, q?: string | null, options?: RawAxiosRequestConfig) {
        return ReadOnlyEndpointsApiFp(this.configuration).readOnlyListAllProducts(orderBy, limit, organizationId, brandIds, googleProductCategoryIds, includeChildrenCategories, cursor, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all variants
     * @summary List variants
     * @param {ReadOnlyListAllVariantsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [orgId] Filter list of variants for ones belonging to a particular organization.
     * @param {string | null} [brandId] Filter list of variants for ones belonging to a particular brand.
     * @param {string | null} [productId] Filter list of variants for variants belonging to a particular product.
     * @param {string | null} [cursor] Optional cursor to fetch the next page.
     * @param {string | null} [search] TODO: Not yet implemented. The query string to search for in the product or variants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReadOnlyEndpointsApi
     */
    public readOnlyListAllVariants(orderBy?: ReadOnlyListAllVariantsOrderByEnum, limit?: number, orgId?: string | null, brandId?: string | null, productId?: string | null, cursor?: string | null, search?: string | null, options?: RawAxiosRequestConfig) {
        return ReadOnlyEndpointsApiFp(this.configuration).readOnlyListAllVariants(orderBy, limit, orgId, brandId, productId, cursor, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all brands with optional organization filter.
     * @summary List brands
     * @param {ReadOnlyListBrandsOrderByEnum} [orderBy] 
     * @param {string | null} [orgId] Optional organization_id to filter list to brands owned by org.
     * @param {number} [limit] 
     * @param {string | null} [cursor] Optional cursor to fetch the next page.
     * @param {string | null} [q] Brand search query.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReadOnlyEndpointsApi
     */
    public readOnlyListBrands(orderBy?: ReadOnlyListBrandsOrderByEnum, orgId?: string | null, limit?: number, cursor?: string | null, q?: string | null, options?: RawAxiosRequestConfig) {
        return ReadOnlyEndpointsApiFp(this.configuration).readOnlyListBrands(orderBy, orgId, limit, cursor, q, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ReadOnlyListAllProductsOrderByEnum = {
    Organization: 'organization',
    Title: 'title',
    UpdatedAt: 'updated_at',
    CreatedAt: 'created_at'
} as const;
export type ReadOnlyListAllProductsOrderByEnum = typeof ReadOnlyListAllProductsOrderByEnum[keyof typeof ReadOnlyListAllProductsOrderByEnum];
/**
 * @export
 */
export const ReadOnlyListAllVariantsOrderByEnum = {
    Gtin: 'gtin',
    Ordinal: 'ordinal',
    UpdatedAt: 'updated_at',
    CreatedAt: 'created_at'
} as const;
export type ReadOnlyListAllVariantsOrderByEnum = typeof ReadOnlyListAllVariantsOrderByEnum[keyof typeof ReadOnlyListAllVariantsOrderByEnum];
/**
 * @export
 */
export const ReadOnlyListBrandsOrderByEnum = {
    Name: 'name',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at'
} as const;
export type ReadOnlyListBrandsOrderByEnum = typeof ReadOnlyListBrandsOrderByEnum[keyof typeof ReadOnlyListBrandsOrderByEnum];


/**
 * ScanDataProgramApi - axios parameter creator
 * @export
 */
export const ScanDataProgramApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a scan data program credential. This enrolls the merchant in the program
         * @summary Create Program Credential
         * @param {string} merchantId The ID for this record
         * @param {ProgramCredentialCreate} programCredentialCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScanDataProgramCredential: async (merchantId: string, programCredentialCreate: ProgramCredentialCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('createScanDataProgramCredential', 'merchantId', merchantId)
            // verify required parameter 'programCredentialCreate' is not null or undefined
            assertParamExists('createScanDataProgramCredential', 'programCredentialCreate', programCredentialCreate)
            const localVarPath = `/scan_data/{merchant_id}/programs`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(programCredentialCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a scan data program credential. This is to un-enroll from a program.
         * @summary Delete Program
         * @param {string} merchantId The ID for this record
         * @param {string} programCredentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScanDataProgram: async (merchantId: string, programCredentialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('deleteScanDataProgram', 'merchantId', merchantId)
            // verify required parameter 'programCredentialId' is not null or undefined
            assertParamExists('deleteScanDataProgram', 'programCredentialId', programCredentialId)
            const localVarPath = `/scan_data/{merchant_id}/programs/{program_credential_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"program_credential_id"}}`, encodeURIComponent(String(programCredentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get scan data program by ID.
         * @summary Get Program Credential by ID
         * @param {string} merchantId The ID for this record
         * @param {string | null} programCredentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScanDataProgram: async (merchantId: string, programCredentialId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getScanDataProgram', 'merchantId', merchantId)
            // verify required parameter 'programCredentialId' is not null or undefined
            assertParamExists('getScanDataProgram', 'programCredentialId', programCredentialId)
            const localVarPath = `/scan_data/{merchant_id}/programs/{program_credential_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"program_credential_id"}}`, encodeURIComponent(String(programCredentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List scan data programs for a merchant ID.
         * @summary List Programs
         * @param {string} merchantId The ID for this record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScanDataPrograms: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('listScanDataPrograms', 'merchantId', merchantId)
            const localVarPath = `/scan_data/{merchant_id}/programs`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full update to a scan data program credential.
         * @summary Update Program Credential
         * @param {string} merchantId The ID for this record
         * @param {string} programCredentialId 
         * @param {UpdateProgramProgramCredentialCreateRequestBody} updateProgramProgramCredentialCreateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScanDataProgramCredential: async (merchantId: string, programCredentialId: string, updateProgramProgramCredentialCreateRequestBody: UpdateProgramProgramCredentialCreateRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateScanDataProgramCredential', 'merchantId', merchantId)
            // verify required parameter 'programCredentialId' is not null or undefined
            assertParamExists('updateScanDataProgramCredential', 'programCredentialId', programCredentialId)
            // verify required parameter 'updateProgramProgramCredentialCreateRequestBody' is not null or undefined
            assertParamExists('updateScanDataProgramCredential', 'updateProgramProgramCredentialCreateRequestBody', updateProgramProgramCredentialCreateRequestBody)
            const localVarPath = `/scan_data/{merchant_id}/programs/{program_credential_id}`
                .replace(`{${"merchant_id"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"program_credential_id"}}`, encodeURIComponent(String(programCredentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProgramProgramCredentialCreateRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScanDataProgramApi - functional programming interface
 * @export
 */
export const ScanDataProgramApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScanDataProgramApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a scan data program credential. This enrolls the merchant in the program
         * @summary Create Program Credential
         * @param {string} merchantId The ID for this record
         * @param {ProgramCredentialCreate} programCredentialCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createScanDataProgramCredential(merchantId: string, programCredentialCreate: ProgramCredentialCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramCredential>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createScanDataProgramCredential(merchantId, programCredentialCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDataProgramApi.createScanDataProgramCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a scan data program credential. This is to un-enroll from a program.
         * @summary Delete Program
         * @param {string} merchantId The ID for this record
         * @param {string} programCredentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScanDataProgram(merchantId: string, programCredentialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScanDataProgram(merchantId, programCredentialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDataProgramApi.deleteScanDataProgram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get scan data program by ID.
         * @summary Get Program Credential by ID
         * @param {string} merchantId The ID for this record
         * @param {string | null} programCredentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScanDataProgram(merchantId: string, programCredentialId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProgramProgramCredentialResponseBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScanDataProgram(merchantId, programCredentialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDataProgramApi.getScanDataProgram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List scan data programs for a merchant ID.
         * @summary List Programs
         * @param {string} merchantId The ID for this record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listScanDataPrograms(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Program>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listScanDataPrograms(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDataProgramApi.listScanDataPrograms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Full update to a scan data program credential.
         * @summary Update Program Credential
         * @param {string} merchantId The ID for this record
         * @param {string} programCredentialId 
         * @param {UpdateProgramProgramCredentialCreateRequestBody} updateProgramProgramCredentialCreateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScanDataProgramCredential(merchantId: string, programCredentialId: string, updateProgramProgramCredentialCreateRequestBody: UpdateProgramProgramCredentialCreateRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgramCredential>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScanDataProgramCredential(merchantId, programCredentialId, updateProgramProgramCredentialCreateRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDataProgramApi.updateScanDataProgramCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScanDataProgramApi - factory interface
 * @export
 */
export const ScanDataProgramApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScanDataProgramApiFp(configuration)
    return {
        /**
         * Creates a scan data program credential. This enrolls the merchant in the program
         * @summary Create Program Credential
         * @param {string} merchantId The ID for this record
         * @param {ProgramCredentialCreate} programCredentialCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScanDataProgramCredential(merchantId: string, programCredentialCreate: ProgramCredentialCreate, options?: any): AxiosPromise<ProgramCredential> {
            return localVarFp.createScanDataProgramCredential(merchantId, programCredentialCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a scan data program credential. This is to un-enroll from a program.
         * @summary Delete Program
         * @param {string} merchantId The ID for this record
         * @param {string} programCredentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScanDataProgram(merchantId: string, programCredentialId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteScanDataProgram(merchantId, programCredentialId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get scan data program by ID.
         * @summary Get Program Credential by ID
         * @param {string} merchantId The ID for this record
         * @param {string | null} programCredentialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScanDataProgram(merchantId: string, programCredentialId: string | null, options?: any): AxiosPromise<GetProgramProgramCredentialResponseBody> {
            return localVarFp.getScanDataProgram(merchantId, programCredentialId, options).then((request) => request(axios, basePath));
        },
        /**
         * List scan data programs for a merchant ID.
         * @summary List Programs
         * @param {string} merchantId The ID for this record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScanDataPrograms(merchantId: string, options?: any): AxiosPromise<Array<Program>> {
            return localVarFp.listScanDataPrograms(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Full update to a scan data program credential.
         * @summary Update Program Credential
         * @param {string} merchantId The ID for this record
         * @param {string} programCredentialId 
         * @param {UpdateProgramProgramCredentialCreateRequestBody} updateProgramProgramCredentialCreateRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScanDataProgramCredential(merchantId: string, programCredentialId: string, updateProgramProgramCredentialCreateRequestBody: UpdateProgramProgramCredentialCreateRequestBody, options?: any): AxiosPromise<ProgramCredential> {
            return localVarFp.updateScanDataProgramCredential(merchantId, programCredentialId, updateProgramProgramCredentialCreateRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScanDataProgramApi - object-oriented interface
 * @export
 * @class ScanDataProgramApi
 * @extends {BaseAPI}
 */
export class ScanDataProgramApi extends BaseAPI {
    /**
     * Creates a scan data program credential. This enrolls the merchant in the program
     * @summary Create Program Credential
     * @param {string} merchantId The ID for this record
     * @param {ProgramCredentialCreate} programCredentialCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanDataProgramApi
     */
    public createScanDataProgramCredential(merchantId: string, programCredentialCreate: ProgramCredentialCreate, options?: RawAxiosRequestConfig) {
        return ScanDataProgramApiFp(this.configuration).createScanDataProgramCredential(merchantId, programCredentialCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a scan data program credential. This is to un-enroll from a program.
     * @summary Delete Program
     * @param {string} merchantId The ID for this record
     * @param {string} programCredentialId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanDataProgramApi
     */
    public deleteScanDataProgram(merchantId: string, programCredentialId: string, options?: RawAxiosRequestConfig) {
        return ScanDataProgramApiFp(this.configuration).deleteScanDataProgram(merchantId, programCredentialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get scan data program by ID.
     * @summary Get Program Credential by ID
     * @param {string} merchantId The ID for this record
     * @param {string | null} programCredentialId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanDataProgramApi
     */
    public getScanDataProgram(merchantId: string, programCredentialId: string | null, options?: RawAxiosRequestConfig) {
        return ScanDataProgramApiFp(this.configuration).getScanDataProgram(merchantId, programCredentialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List scan data programs for a merchant ID.
     * @summary List Programs
     * @param {string} merchantId The ID for this record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanDataProgramApi
     */
    public listScanDataPrograms(merchantId: string, options?: RawAxiosRequestConfig) {
        return ScanDataProgramApiFp(this.configuration).listScanDataPrograms(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full update to a scan data program credential.
     * @summary Update Program Credential
     * @param {string} merchantId The ID for this record
     * @param {string} programCredentialId 
     * @param {UpdateProgramProgramCredentialCreateRequestBody} updateProgramProgramCredentialCreateRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanDataProgramApi
     */
    public updateScanDataProgramCredential(merchantId: string, programCredentialId: string, updateProgramProgramCredentialCreateRequestBody: UpdateProgramProgramCredentialCreateRequestBody, options?: RawAxiosRequestConfig) {
        return ScanDataProgramApiFp(this.configuration).updateScanDataProgramCredential(merchantId, programCredentialId, updateProgramProgramCredentialCreateRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScandataInterestApi - axios parameter creator
 * @export
 */
export const ScandataInterestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Express interest in the scandata program
         * @param {CloverInterest} cloverInterest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scandataInterest: async (cloverInterest: CloverInterest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cloverInterest' is not null or undefined
            assertParamExists('scandataInterest', 'cloverInterest', cloverInterest)
            const localVarPath = `/scan_data/interest/clover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloverInterest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScandataInterestApi - functional programming interface
 * @export
 */
export const ScandataInterestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScandataInterestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Express interest in the scandata program
         * @param {CloverInterest} cloverInterest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scandataInterest(cloverInterest: CloverInterest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scandataInterest(cloverInterest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScandataInterestApi.scandataInterest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScandataInterestApi - factory interface
 * @export
 */
export const ScandataInterestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScandataInterestApiFp(configuration)
    return {
        /**
         * 
         * @summary Express interest in the scandata program
         * @param {CloverInterest} cloverInterest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scandataInterest(cloverInterest: CloverInterest, options?: any): AxiosPromise<any> {
            return localVarFp.scandataInterest(cloverInterest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScandataInterestApi - object-oriented interface
 * @export
 * @class ScandataInterestApi
 * @extends {BaseAPI}
 */
export class ScandataInterestApi extends BaseAPI {
    /**
     * 
     * @summary Express interest in the scandata program
     * @param {CloverInterest} cloverInterest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScandataInterestApi
     */
    public scandataInterest(cloverInterest: CloverInterest, options?: RawAxiosRequestConfig) {
        return ScandataInterestApiFp(this.configuration).scandataInterest(cloverInterest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScandataSubmissionsApi - axios parameter creator
 * @export
 */
export const ScandataSubmissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a scandata submission for a specific program credential.
         * @summary Create a scandata submission
         * @param {string} programCredentialId 
         * @param {ScandataSubmissionBase} scandataSubmissionBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScandataSubmission: async (programCredentialId: string, scandataSubmissionBase: ScandataSubmissionBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programCredentialId' is not null or undefined
            assertParamExists('createScandataSubmission', 'programCredentialId', programCredentialId)
            // verify required parameter 'scandataSubmissionBase' is not null or undefined
            assertParamExists('createScandataSubmission', 'scandataSubmissionBase', scandataSubmissionBase)
            const localVarPath = `/scan_data/{program_credential_id}/submissions`
                .replace(`{${"program_credential_id"}}`, encodeURIComponent(String(programCredentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scandataSubmissionBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get scandata submission
         * @param {string} programCredentialId 
         * @param {string | null} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScandataSubmissions: async (programCredentialId: string, submissionId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programCredentialId' is not null or undefined
            assertParamExists('getScandataSubmissions', 'programCredentialId', programCredentialId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('getScandataSubmissions', 'submissionId', submissionId)
            const localVarPath = `/scan_data/{program_credential_id}/submissions/{submission_id}`
                .replace(`{${"program_credential_id"}}`, encodeURIComponent(String(programCredentialId)))
                .replace(`{${"submission_id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List scandata submissions for a program credential.
         * @param {string | null} programCredentialId 
         * @param {ListScandataSubmissionsOrderByEnum} [orderBy] 
         * @param {string} [orderByDirection] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScandataSubmissions: async (programCredentialId: string | null, orderBy?: ListScandataSubmissionsOrderByEnum, orderByDirection?: string, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programCredentialId' is not null or undefined
            assertParamExists('listScandataSubmissions', 'programCredentialId', programCredentialId)
            const localVarPath = `/scan_data/{program_credential_id}/submissions`
                .replace(`{${"program_credential_id"}}`, encodeURIComponent(String(programCredentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderByDirection !== undefined) {
                localVarQueryParameter['order_by_direction'] = orderByDirection;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a scandata submission by ID
         * @param {string} programCredentialId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission: async (programCredentialId: string, submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'programCredentialId' is not null or undefined
            assertParamExists('scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission', 'programCredentialId', programCredentialId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission', 'submissionId', submissionId)
            const localVarPath = `/scan_data/{program_credential_id}/submissions/{submission_id}`
                .replace(`{${"program_credential_id"}}`, encodeURIComponent(String(programCredentialId)))
                .replace(`{${"submission_id"}}`, encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScandataSubmissionsApi - functional programming interface
 * @export
 */
export const ScandataSubmissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScandataSubmissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a scandata submission for a specific program credential.
         * @summary Create a scandata submission
         * @param {string} programCredentialId 
         * @param {ScandataSubmissionBase} scandataSubmissionBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createScandataSubmission(programCredentialId: string, scandataSubmissionBase: ScandataSubmissionBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScandataSubmission>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createScandataSubmission(programCredentialId, scandataSubmissionBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScandataSubmissionsApi.createScandataSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get scandata submission
         * @param {string} programCredentialId 
         * @param {string | null} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScandataSubmissions(programCredentialId: string, submissionId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScandataSubmission>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScandataSubmissions(programCredentialId, submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScandataSubmissionsApi.getScandataSubmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List scandata submissions for a program credential.
         * @param {string | null} programCredentialId 
         * @param {ListScandataSubmissionsOrderByEnum} [orderBy] 
         * @param {string} [orderByDirection] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listScandataSubmissions(programCredentialId: string | null, orderBy?: ListScandataSubmissionsOrderByEnum, orderByDirection?: string, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListScandataSubmissions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listScandataSubmissions(programCredentialId, orderBy, orderByDirection, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScandataSubmissionsApi.listScandataSubmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a scandata submission by ID
         * @param {string} programCredentialId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission(programCredentialId: string, submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission(programCredentialId, submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScandataSubmissionsApi.scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScandataSubmissionsApi - factory interface
 * @export
 */
export const ScandataSubmissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScandataSubmissionsApiFp(configuration)
    return {
        /**
         * Create a scandata submission for a specific program credential.
         * @summary Create a scandata submission
         * @param {string} programCredentialId 
         * @param {ScandataSubmissionBase} scandataSubmissionBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScandataSubmission(programCredentialId: string, scandataSubmissionBase: ScandataSubmissionBase, options?: any): AxiosPromise<ScandataSubmission> {
            return localVarFp.createScandataSubmission(programCredentialId, scandataSubmissionBase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get scandata submission
         * @param {string} programCredentialId 
         * @param {string | null} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScandataSubmissions(programCredentialId: string, submissionId: string | null, options?: any): AxiosPromise<ScandataSubmission> {
            return localVarFp.getScandataSubmissions(programCredentialId, submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List scandata submissions for a program credential.
         * @param {string | null} programCredentialId 
         * @param {ListScandataSubmissionsOrderByEnum} [orderBy] 
         * @param {string} [orderByDirection] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScandataSubmissions(programCredentialId: string | null, orderBy?: ListScandataSubmissionsOrderByEnum, orderByDirection?: string, limit?: number, cursor?: string | null, options?: any): AxiosPromise<ListScandataSubmissions200Response> {
            return localVarFp.listScandataSubmissions(programCredentialId, orderBy, orderByDirection, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a scandata submission by ID
         * @param {string} programCredentialId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission(programCredentialId: string, submissionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission(programCredentialId, submissionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScandataSubmissionsApi - object-oriented interface
 * @export
 * @class ScandataSubmissionsApi
 * @extends {BaseAPI}
 */
export class ScandataSubmissionsApi extends BaseAPI {
    /**
     * Create a scandata submission for a specific program credential.
     * @summary Create a scandata submission
     * @param {string} programCredentialId 
     * @param {ScandataSubmissionBase} scandataSubmissionBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScandataSubmissionsApi
     */
    public createScandataSubmission(programCredentialId: string, scandataSubmissionBase: ScandataSubmissionBase, options?: RawAxiosRequestConfig) {
        return ScandataSubmissionsApiFp(this.configuration).createScandataSubmission(programCredentialId, scandataSubmissionBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get scandata submission
     * @param {string} programCredentialId 
     * @param {string | null} submissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScandataSubmissionsApi
     */
    public getScandataSubmissions(programCredentialId: string, submissionId: string | null, options?: RawAxiosRequestConfig) {
        return ScandataSubmissionsApiFp(this.configuration).getScandataSubmissions(programCredentialId, submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List scandata submissions for a program credential.
     * @param {string | null} programCredentialId 
     * @param {ListScandataSubmissionsOrderByEnum} [orderBy] 
     * @param {string} [orderByDirection] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScandataSubmissionsApi
     */
    public listScandataSubmissions(programCredentialId: string | null, orderBy?: ListScandataSubmissionsOrderByEnum, orderByDirection?: string, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return ScandataSubmissionsApiFp(this.configuration).listScandataSubmissions(programCredentialId, orderBy, orderByDirection, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a scandata submission by ID
     * @param {string} programCredentialId 
     * @param {string} submissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScandataSubmissionsApi
     */
    public scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission(programCredentialId: string, submissionId: string, options?: RawAxiosRequestConfig) {
        return ScandataSubmissionsApiFp(this.configuration).scanDataProgramCredentialIdSubmissionsSubmissionIdDeleteSubmission(programCredentialId, submissionId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListScandataSubmissionsOrderByEnum = {
    Version: 'version',
    UpdatedAt: 'updated_at',
    CreatedAt: 'created_at'
} as const;
export type ListScandataSubmissionsOrderByEnum = typeof ListScandataSubmissionsOrderByEnum[keyof typeof ListScandataSubmissionsOrderByEnum];


/**
 * SearchEngineApi - axios parameter creator
 * @export
 */
export const SearchEngineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate search results from search engine API.
         * @summary Generate search results
         * @param {CreateSearchResultSearchResultRequestBody} createSearchResultSearchResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSearchResults: async (createSearchResultSearchResultRequestBody: CreateSearchResultSearchResultRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSearchResultSearchResultRequestBody' is not null or undefined
            assertParamExists('createSearchResults', 'createSearchResultSearchResultRequestBody', createSearchResultSearchResultRequestBody)
            const localVarPath = `/search_results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSearchResultSearchResultRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Parse and store data from a url.
         * @summary Parse product page
         * @param {ParseProductPageProductLookupRequestBody} parseProductPageProductLookupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseProductPage: async (parseProductPageProductLookupRequestBody: ParseProductPageProductLookupRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parseProductPageProductLookupRequestBody' is not null or undefined
            assertParamExists('parseProductPage', 'parseProductPageProductLookupRequestBody', parseProductPageProductLookupRequestBody)
            const localVarPath = `/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(parseProductPageProductLookupRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Push - Generate search results
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResultsPushPushSearchResult: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('searchResultsPushPushSearchResult', 'body', body)
            const localVarPath = `/search_results/push`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchEngineApi - functional programming interface
 * @export
 */
export const SearchEngineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchEngineApiAxiosParamCreator(configuration)
    return {
        /**
         * Generate search results from search engine API.
         * @summary Generate search results
         * @param {CreateSearchResultSearchResultRequestBody} createSearchResultSearchResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSearchResults(createSearchResultSearchResultRequestBody: CreateSearchResultSearchResultRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSearchResultSearchResultResponseBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSearchResults(createSearchResultSearchResultRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchEngineApi.createSearchResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Parse and store data from a url.
         * @summary Parse product page
         * @param {ParseProductPageProductLookupRequestBody} parseProductPageProductLookupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parseProductPage(parseProductPageProductLookupRequestBody: ParseProductPageProductLookupRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParseProductPageProductLookupResponseBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parseProductPage(parseProductPageProductLookupRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchEngineApi.parseProductPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Push - Generate search results
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchResultsPushPushSearchResult(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchResultsPushPushSearchResult(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchEngineApi.searchResultsPushPushSearchResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchEngineApi - factory interface
 * @export
 */
export const SearchEngineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchEngineApiFp(configuration)
    return {
        /**
         * Generate search results from search engine API.
         * @summary Generate search results
         * @param {CreateSearchResultSearchResultRequestBody} createSearchResultSearchResultRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSearchResults(createSearchResultSearchResultRequestBody: CreateSearchResultSearchResultRequestBody, options?: any): AxiosPromise<CreateSearchResultSearchResultResponseBody> {
            return localVarFp.createSearchResults(createSearchResultSearchResultRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Parse and store data from a url.
         * @summary Parse product page
         * @param {ParseProductPageProductLookupRequestBody} parseProductPageProductLookupRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parseProductPage(parseProductPageProductLookupRequestBody: ParseProductPageProductLookupRequestBody, options?: any): AxiosPromise<ParseProductPageProductLookupResponseBody> {
            return localVarFp.parseProductPage(parseProductPageProductLookupRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Push - Generate search results
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResultsPushPushSearchResult(body: any, options?: any): AxiosPromise<void> {
            return localVarFp.searchResultsPushPushSearchResult(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchEngineApi - object-oriented interface
 * @export
 * @class SearchEngineApi
 * @extends {BaseAPI}
 */
export class SearchEngineApi extends BaseAPI {
    /**
     * Generate search results from search engine API.
     * @summary Generate search results
     * @param {CreateSearchResultSearchResultRequestBody} createSearchResultSearchResultRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineApi
     */
    public createSearchResults(createSearchResultSearchResultRequestBody: CreateSearchResultSearchResultRequestBody, options?: RawAxiosRequestConfig) {
        return SearchEngineApiFp(this.configuration).createSearchResults(createSearchResultSearchResultRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Parse and store data from a url.
     * @summary Parse product page
     * @param {ParseProductPageProductLookupRequestBody} parseProductPageProductLookupRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineApi
     */
    public parseProductPage(parseProductPageProductLookupRequestBody: ParseProductPageProductLookupRequestBody, options?: RawAxiosRequestConfig) {
        return SearchEngineApiFp(this.configuration).parseProductPage(parseProductPageProductLookupRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Push - Generate search results
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineApi
     */
    public searchResultsPushPushSearchResult(body: any, options?: RawAxiosRequestConfig) {
        return SearchEngineApiFp(this.configuration).searchResultsPushPushSearchResult(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VariantsApi - axios parameter creator
 * @export
 */
export const VariantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new variant for a product
         * @summary Create variant for a product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {ProductVariantBase} productVariantBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVariant: async (orgId: string, productId: string, productVariantBase: ProductVariantBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('createVariant', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('createVariant', 'productId', productId)
            // verify required parameter 'productVariantBase' is not null or undefined
            assertParamExists('createVariant', 'productVariantBase', productVariantBase)
            const localVarPath = `/organizations/{org_id}/products/{product_id}/variants`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productVariantBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches fetches one variant by ID
         * @summary Get variant by ID
         * @param {string} orgId 
         * @param {string} productId 
         * @param {string | null} variantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariant: async (orgId: string, productId: string, variantId: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getVariant', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getVariant', 'productId', productId)
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('getVariant', 'variantId', variantId)
            const localVarPath = `/organizations/{org_id}/products/{product_id}/variants/{variant_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"variant_id"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches all variants belonging to a product
         * @summary List variants for a product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {GetVariantsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariants: async (orgId: string, productId: string, orderBy?: GetVariantsOrderByEnum, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getVariants', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getVariants', 'productId', productId)
            const localVarPath = `/organizations/{org_id}/products/{product_id}/variants`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partial update an existing variant that belongs to a product by passing only fields that are being updated.
         * @summary Partial update variant
         * @param {string} orgId 
         * @param {string} productId 
         * @param {string} variantId 
         * @param {PartialUpdateVariantProductVariantRequestBody} partialUpdateVariantProductVariantRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateVariant: async (orgId: string, productId: string, variantId: string, partialUpdateVariantProductVariantRequestBody: PartialUpdateVariantProductVariantRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('partialUpdateVariant', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('partialUpdateVariant', 'productId', productId)
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('partialUpdateVariant', 'variantId', variantId)
            // verify required parameter 'partialUpdateVariantProductVariantRequestBody' is not null or undefined
            assertParamExists('partialUpdateVariant', 'partialUpdateVariantProductVariantRequestBody', partialUpdateVariantProductVariantRequestBody)
            const localVarPath = `/organizations/{org_id}/products/{product_id}/variants/{variant_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"variant_id"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialUpdateVariantProductVariantRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing variant that belongs to a product.
         * @summary Update variant
         * @param {string} orgId 
         * @param {string} productId 
         * @param {string} variantId 
         * @param {ProductVariantBase} productVariantBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVariant: async (orgId: string, productId: string, variantId: string, productVariantBase: ProductVariantBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('updateVariant', 'orgId', orgId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('updateVariant', 'productId', productId)
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('updateVariant', 'variantId', variantId)
            // verify required parameter 'productVariantBase' is not null or undefined
            assertParamExists('updateVariant', 'productVariantBase', productVariantBase)
            const localVarPath = `/organizations/{org_id}/products/{product_id}/variants/{variant_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"variant_id"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productVariantBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VariantsApi - functional programming interface
 * @export
 */
export const VariantsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VariantsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new variant for a product
         * @summary Create variant for a product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {ProductVariantBase} productVariantBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVariant(orgId: string, productId: string, productVariantBase: ProductVariantBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductVariant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVariant(orgId, productId, productVariantBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariantsApi.createVariant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches fetches one variant by ID
         * @summary Get variant by ID
         * @param {string} orgId 
         * @param {string} productId 
         * @param {string | null} variantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariant(orgId: string, productId: string, variantId: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductVariant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariant(orgId, productId, variantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariantsApi.getVariant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches all variants belonging to a product
         * @summary List variants for a product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {GetVariantsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariants(orgId: string, productId: string, orderBy?: GetVariantsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVariants200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariants(orgId, productId, orderBy, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariantsApi.getVariants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Partial update an existing variant that belongs to a product by passing only fields that are being updated.
         * @summary Partial update variant
         * @param {string} orgId 
         * @param {string} productId 
         * @param {string} variantId 
         * @param {PartialUpdateVariantProductVariantRequestBody} partialUpdateVariantProductVariantRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partialUpdateVariant(orgId: string, productId: string, variantId: string, partialUpdateVariantProductVariantRequestBody: PartialUpdateVariantProductVariantRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartialUpdateVariantProductVariantResponseBody>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partialUpdateVariant(orgId, productId, variantId, partialUpdateVariantProductVariantRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariantsApi.partialUpdateVariant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing variant that belongs to a product.
         * @summary Update variant
         * @param {string} orgId 
         * @param {string} productId 
         * @param {string} variantId 
         * @param {ProductVariantBase} productVariantBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVariant(orgId: string, productId: string, variantId: string, productVariantBase: ProductVariantBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductVariant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVariant(orgId, productId, variantId, productVariantBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VariantsApi.updateVariant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VariantsApi - factory interface
 * @export
 */
export const VariantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VariantsApiFp(configuration)
    return {
        /**
         * Creates a new variant for a product
         * @summary Create variant for a product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {ProductVariantBase} productVariantBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVariant(orgId: string, productId: string, productVariantBase: ProductVariantBase, options?: any): AxiosPromise<ProductVariant> {
            return localVarFp.createVariant(orgId, productId, productVariantBase, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches fetches one variant by ID
         * @summary Get variant by ID
         * @param {string} orgId 
         * @param {string} productId 
         * @param {string | null} variantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariant(orgId: string, productId: string, variantId: string | null, options?: any): AxiosPromise<ProductVariant> {
            return localVarFp.getVariant(orgId, productId, variantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches all variants belonging to a product
         * @summary List variants for a product
         * @param {string} orgId 
         * @param {string} productId 
         * @param {GetVariantsOrderByEnum} [orderBy] 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariants(orgId: string, productId: string, orderBy?: GetVariantsOrderByEnum, limit?: number, cursor?: string | null, options?: any): AxiosPromise<GetVariants200Response> {
            return localVarFp.getVariants(orgId, productId, orderBy, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Partial update an existing variant that belongs to a product by passing only fields that are being updated.
         * @summary Partial update variant
         * @param {string} orgId 
         * @param {string} productId 
         * @param {string} variantId 
         * @param {PartialUpdateVariantProductVariantRequestBody} partialUpdateVariantProductVariantRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partialUpdateVariant(orgId: string, productId: string, variantId: string, partialUpdateVariantProductVariantRequestBody: PartialUpdateVariantProductVariantRequestBody, options?: any): AxiosPromise<PartialUpdateVariantProductVariantResponseBody> {
            return localVarFp.partialUpdateVariant(orgId, productId, variantId, partialUpdateVariantProductVariantRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing variant that belongs to a product.
         * @summary Update variant
         * @param {string} orgId 
         * @param {string} productId 
         * @param {string} variantId 
         * @param {ProductVariantBase} productVariantBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVariant(orgId: string, productId: string, variantId: string, productVariantBase: ProductVariantBase, options?: any): AxiosPromise<ProductVariant> {
            return localVarFp.updateVariant(orgId, productId, variantId, productVariantBase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VariantsApi - object-oriented interface
 * @export
 * @class VariantsApi
 * @extends {BaseAPI}
 */
export class VariantsApi extends BaseAPI {
    /**
     * Creates a new variant for a product
     * @summary Create variant for a product
     * @param {string} orgId 
     * @param {string} productId 
     * @param {ProductVariantBase} productVariantBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariantsApi
     */
    public createVariant(orgId: string, productId: string, productVariantBase: ProductVariantBase, options?: RawAxiosRequestConfig) {
        return VariantsApiFp(this.configuration).createVariant(orgId, productId, productVariantBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches fetches one variant by ID
     * @summary Get variant by ID
     * @param {string} orgId 
     * @param {string} productId 
     * @param {string | null} variantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariantsApi
     */
    public getVariant(orgId: string, productId: string, variantId: string | null, options?: RawAxiosRequestConfig) {
        return VariantsApiFp(this.configuration).getVariant(orgId, productId, variantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches all variants belonging to a product
     * @summary List variants for a product
     * @param {string} orgId 
     * @param {string} productId 
     * @param {GetVariantsOrderByEnum} [orderBy] 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariantsApi
     */
    public getVariants(orgId: string, productId: string, orderBy?: GetVariantsOrderByEnum, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return VariantsApiFp(this.configuration).getVariants(orgId, productId, orderBy, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Partial update an existing variant that belongs to a product by passing only fields that are being updated.
     * @summary Partial update variant
     * @param {string} orgId 
     * @param {string} productId 
     * @param {string} variantId 
     * @param {PartialUpdateVariantProductVariantRequestBody} partialUpdateVariantProductVariantRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariantsApi
     */
    public partialUpdateVariant(orgId: string, productId: string, variantId: string, partialUpdateVariantProductVariantRequestBody: PartialUpdateVariantProductVariantRequestBody, options?: RawAxiosRequestConfig) {
        return VariantsApiFp(this.configuration).partialUpdateVariant(orgId, productId, variantId, partialUpdateVariantProductVariantRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing variant that belongs to a product.
     * @summary Update variant
     * @param {string} orgId 
     * @param {string} productId 
     * @param {string} variantId 
     * @param {ProductVariantBase} productVariantBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariantsApi
     */
    public updateVariant(orgId: string, productId: string, variantId: string, productVariantBase: ProductVariantBase, options?: RawAxiosRequestConfig) {
        return VariantsApiFp(this.configuration).updateVariant(orgId, productId, variantId, productVariantBase, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetVariantsOrderByEnum = {
    Gtin: 'gtin',
    Ordinal: 'ordinal',
    UpdatedAt: 'updated_at',
    CreatedAt: 'created_at'
} as const;
export type GetVariantsOrderByEnum = typeof GetVariantsOrderByEnum[keyof typeof GetVariantsOrderByEnum];


